import React, { useState, useEffect } from "react";
import axios from "axios";
//import { useCookies } from "react-cookie";
//import createPersistedState from 'use-persisted-state';

//import logo from "./logo.png";
import dropdown from "./dropdown.svg";
//import tick from "./tick.svg";
import vertical from "./vertical-line.svg";
import meat from "./meats_by_dre.png";

import socialDiscord from "./social-discord.svg";
import socialInsta from "./social-insta.svg";
import socialTiktok from "./social-tiktok.svg";

import Cookies from "js-cookie";

import { Adsense } from "@ctrl/react-adsense";

import { NavLink, useLocation } from "react-router-dom";

//import { removeDirAndFiles } from "minio/dist/main/helpers"; // not sure why this line is here??

//import BoardPaper from "./BoardPaper";

function getSubj(str) {
  //console.log(str);
  if (str === undefined) {
    return "Subject";
  } else {
    return str;
  }
}

function getUrlPath(loc_parts, num, end_str) {
  // e.g. "/".concat(String(loc_parts[1])).concat('/').concat(String(loc_parts[2])).concat('/aqa')
  let urlString = "/";

  for (let i = 1; i <= num; i++) {
    urlString = urlString + String(loc_parts[i]) + "/";
  }
  urlString = urlString + end_str;

  return urlString;
}

function getUrlPathHash(loc_parts, num, end_str) {
  let urlString = "";

  for (let i = 1; i <= num; i++) {
    //if (i>1) {
    //}
    urlString = urlString + "/" + String(loc_parts[i]);
  }
  urlString = urlString + "#" + end_str;

  return urlString;
}

const herokuOrLocal = true;
var baseURL = "";
var papersURL = "";

if (herokuOrLocal === true) {
  baseURL = "https://examoo.physicsfox.org/api/"; // https://papersrepo.herokuapp.com/api/ , http://localhost:5000/api
  papersURL = "https://examoo.physicsfox.org/paper/";
} else {
  baseURL = "http://localhost:5000/api/"; // https://papersrepo.herokuapp.com/api/ , http://localhost:5000/api
  papersURL = "http://localhost:5000/paper/";
}

function showBoxN(loc_parts_n) {
  if (loc_parts_n === undefined || loc_parts_n === "") {
    return false;
  } else {
    return true;
  }
}

/*
function getDataAxios(str) {

	var james = '';

	var urlll = baseURL+str;
	console.log('URL:'+urlll)

	axios.get(baseURL+str)
		.then((response) => {
			console.log('respdata '+response.data);
			james = response.data;
			console.log('james '+james);
		})
		.catch(error =>
			console.log(error)
		);

	if (!james) {
		return null;
	} else {
		return james;
	}

}
*/

//const qualDataRUFF = getDataAxios('qualifications');

//console.log('Data returned: '+qualDataRUFF);

//const the_logo = document.getElementById('logo-id');

function Exams(props) {
  // initially, get all info from URL. Then from click (which changes URL)!

  const location = useLocation(); // gets current url
  var loc_path = location.pathname + location.hash; // '/gcse/maths/aqa' + '1-H'
  var loc_parts = loc_path.replace("#", "/").split("/"); // ['', 'gcse', 'maths', 'aqa']   // OG: loc_path.split('/')

  const [toggleQual, setToggleQual] = useState(false);
  const [toggleSubj, setToggleSubj] = useState(false);
  const [toggleBoard, setToggleBoard] = useState(false);
  const [togglePaper, setTogglePaper] = useState(false);

  const [subjEnabled, setSubjEnabled] = useState(false);
  const [paperTypeEnabled, setPaperTypeEnabled] = useState(false);
  const [examBoardEnabled, setExamBoardEnabled] = useState(false);

  const [box1Height, setBox1Height] = useState(300);
  const [box2Height, setBox2Height] = useState(300);

  // currently-selected URLs of qual, subj
  const [regionUrl, setRegionUrl] = useState("uk");
  const [qualUrl, setQualUrl] = useState(loc_parts[1]);
  const [subjUrl, setSubjUrl] = useState(loc_parts[2]);
  const [examBoardUrl, setExamBoardUrl] = useState(loc_parts[3]);
  const [paperTypeUrl, setPaperTypeUrl] = useState(loc_parts[4]);
  const [papersFiltered, setPapersFiltered] = useState(false);

  // currently-selected Names of qual, subj
  const [qualName, setQualName] = useState("Qualification"); //qualData.find(x => x.url === qualUrl).name  //'Choose Qualification:'
  const [subjName, setSubjName] = useState("Subject");
  const [examBoardName, setExamBoardName] = useState("Exam board");
  const [paperTypeName, setPaperTypeName] = useState("All papers");

  const [qualNum, setQualNum] = useState(0); // id of qualification (e.g. GCSE has id=1, A-Level has id=3)
  const [subjNum, setSubjNum] = useState(0);
  const [examBoardNum, setExamBoardNum] = useState(0);
  const [paperTypeNum, setPaperTypeNum] = useState(0);

  const [subjColour, setSubjColour] = useState("#eec9e8"); // #f6aded #f1f1f1

  //const [loadingPapers, setLoadingPapers] = useState(true) // #f6aded #f1f1f1

  //const [count, setCount] = useState(0);
  //const [count, setCount] = useStickyState('true', "count"); JWC

  //const [cookies, setCookie] = useCookies(['user']);

  /*
	function handleCookie() {
		setCookie("user", "gowtham", {
		  path: "/"
		});
	  }
	*/

  useEffect(() => {
    // need all this to not get error (.clientHeight gives error because select-box-1 hasn't loaded yet)
    var boxheighttemp = document.getElementById("select-box-1").clientHeight;

    if (!boxheighttemp) {
      boxheighttemp = 0;
    }

    setBox1Height(boxheighttemp + 50);
  }, [toggleQual, toggleSubj]);

  useEffect(() => {
    var boxheighttemp = document.getElementById("select-box-2").clientHeight;

    if (!boxheighttemp) {
      boxheighttemp = 0;
    }

    setBox2Height(boxheighttemp + 102); // + 150
  }, [toggleBoard, togglePaper]);

  props.setPathNavBar(loc_path); // source of a console error (I think)

  /*
	var colourDictTest = {
		1: "#FFC001",
		2: "#FF0000", 
		3: "#00FF00", 
	};
	*/

  // just directly use props.colourData[] instead..?
  var colourDict = {};

  for (var group in props.colourData) {
    colourDict[props.colourData[group].id] = props.colourData[group].hex_colour;
  }

  //console.log('1' + props.colourData);
  //console.log('2' + colourDict);

  function updateQual() {
    //setQualUrl(loc_parts[1]);  // is this necessary?

    var thing = props.qualData.find((x) => x.url === qualUrl);

    setQualName(thing.name);
    setQualNum(thing.id);
  }

  function updateSubj() {
    //setQualUrl(loc_parts[1]);  // is this necessary?
    //setSubjUrl(loc_parts[2]);  // is this necessary?

    //var thing = props.subjData.filter(x => x.qualification === qualNum && x.url === subjUrl)[0];
    var thing0 = props.qualData.find((x) => x.url === qualUrl);
    var thing = props.subjData.find(
      (x) => x.qualification === thing0.id && x.url === subjUrl,
    );

    setSubjName(thing.name);
    setSubjNum(thing.id);
    setSubjColour(colourDict[thing.colour]);
  }

  function updateExamBoard() {
    //setQualUrl(loc_parts[1]);  // is this necessary?
    //setSubjUrl(loc_parts[2]);  // is this necessary?
    //setExamBoardUrl(loc_parts[3]); // is this necessary?

    // OG:
    /*
		var thing = props.subjData.filter(x => x.qualification === qualNum && x.url === subjUrl)[0];
		var thing2 = props.examBoardData.find(x => x.url === examBoardUrl);
		setExamBoardName(thing.name);
		setExamBoardNum(thing.id);
		*/

    var thing0 = props.qualData.find((x) => x.url === qualUrl);

    var thing = props.subjData.find(
      (x) => x.qualification === thing0.id && x.url === subjUrl,
    ); // (x => x.url === subjUrl)

    //console.log(subjNum, subjNum)

    var thing2 = props.examBoardData.find(
      (x) => x.subject === thing.id && x.url === examBoardUrl,
    ); // using thing.id instead of subjUrl (because subjUrl hasn't updated yet; it's still 0)
    //var thing = props.examBoardData.filter(x => x.subject === subjNum && x.url === examBoardUrl)[0];

    setExamBoardName(thing2.name);
    setExamBoardNum(thing2.id);

    // used to be done by allPapersFunction()
    var thing3 = props.paperTypeData.find(
      (x) => x.exam_board === thing2.id && x.order === 0,
    ); // get 'All Papers' papertype
    setPaperTypeNum(thing3.id);
  }

  function updatePaperType() {
    //setPaperTypeUrl(loc_parts[4]); // is this necessary?

    var thing0 = props.qualData.find((x) => x.url === qualUrl);
    var thing = props.subjData.find(
      (x) => x.qualification === thing0.id && x.url === subjUrl,
    ); // (x => x.url === subjUrl)

    //console.log(subjNum, subjNum)

    var thing2 = props.examBoardData.find(
      (x) => x.subject === thing.id && x.url === examBoardUrl,
    ); // using thing.id instead of subjUrl (because subjUrl hasn't updated yet; it's still 0)

    var thing3 = props.paperTypeData.find(
      (x) =>
        x.exam_board === thing2.id && x.url.replace("-", "") === paperTypeUrl,
    );

    //var thing3 = props.paperTypeData.find(x => x.url === paperTypeUrl);
    //var thing = props.paperTypeData.filter(x => x.examboard === examBoardNum && x.url === paperTypeUrl)[0];
    // ALWAYS Gets aqa maths, because 'find()' always get the first one!

    setPaperTypeName(thing3.name);
    setPaperTypeNum(thing3.id);
  }

  function resetTogglesExcept(n) {
    if (n === 1) {
      setToggleSubj(false);
      setToggleBoard(false);
      setTogglePaper(false);
    } else if (n === 2) {
      setToggleQual(false);
      setToggleBoard(false);
      setTogglePaper(false);
    } else if (n === 3) {
      setToggleQual(false);
      setToggleSubj(false);
      setTogglePaper(false);
    } else if (n === 4) {
      setToggleQual(false);
      setToggleSubj(false);
      setToggleBoard(false);
    }
  }

  function allPapersFunction() {
    // set paperTypeNum to the id of 'All PaperZ' papertype.
    // Therefore, 'All papers' bookmark is actually the 'All PaperZ' bookmark.
    //var graham = props.paperTypeData.find(item => (item.exam_board === props.examBoardData.find(x => x.url === examBoardUrl).id && item.order === 0));
    //setPaperTypeNum(graham.id);
    // NEW (June 2022): Fixed 'All Exams -> Bookmarks -> All Exams' bug.
    /*
		var thing0 = props.qualData.find(x => x.url === qualUrl);
		var thing = props.subjData.find(x => x.qualification === thing0.id && x.url === subjUrl); // (x => x.url === subjUrl)
		var thing2 = props.examBoardData.find(x => x.subject === thing.id && x.url === examBoardUrl); // using thing.id instead of subjUrl (because subjUrl hasn't updated yet; it's still 0)
		var thing3 = props.paperTypeData.find(x => x.exam_board === thing2.id && x.order === 0);

		setPaperTypeNum(thing3.id);
		*/
  }

  // faster function for when clicking on exam board
  // if doing above instead, the entire page refreshes.
  function allPapersFunctionClick(ebn) {
    setPaperTypeNum(
      props.paperTypeData.find(
        (item) => item.order === 0 && item.exam_board === ebn,
      ).id,
    );
  }

  useEffect(() => {
    if (loc_parts[1]) {
      // qual already chosen
      updateQual();
      setSubjEnabled(true);
      setToggleSubj(true);
    } else {
      setToggleQual(true);
    }

    if (loc_parts[2]) {
      // subj already chosen
      updateSubj();
      setExamBoardEnabled(true);
      setToggleSubj(false);
      setToggleBoard(true);
    }

    if (loc_parts[3]) {
      updateExamBoard();
      setPaperTypeEnabled(true);
      setToggleSubj(false);
      setToggleBoard(false);
      //papersFromServer("uk/"+loc_parts[1]+"/"+loc_parts[2]+"/"+loc_parts[3]+"/");
    }

    if (loc_parts[4]) {
      updatePaperType();
      setPapersFiltered(true);
    } else {
      //setTimeout(allPapersFunction, 300); // functionality now included in updateExamBoard();
    }
  }, []);

  // Cleanup - needed for when effect references an external data source (to remove memory leak!)
  /*
	useEffect(() => {
		function something(dataa, urll) {
			setQualName(
				dataa.find(x => x.url === urll).name
			);
		};

		something(props.qualData, qualUrl);

		// how to clean up after the effect:
		return function cleanup() {

		};

	}, [props.qualData, qualUrl]);
	*/

  useEffect(() => {
    if (examBoardNum !== 0) {
      var examBoardNameTemp = "• " + examBoardName;
    } else {
      examBoardNameTemp = "";
    }

    if (qualName !== "Qualification" && subjName !== "Subject") {
      document.title =
        qualName +
        " " +
        subjName +
        " " +
        examBoardNameTemp +
        " • All Past Papers • Examoo";
    } else {
      document.title = "Get GCSE, AS, A-Level Past Papers Now! • Examoo"; //MAYBE
    }
  }, [qualName, subjName, examBoardName]);

  /*
	useEffect(() => {
		console.log('getting papers (USEEFFECT)...');
		//console.log(props.paperData);

		axios.get(papersURL+"uk/"+loc_parts[1]+"/"+loc_parts[2]+"/"+loc_parts[3]+"/")
			.then(function (response) {
				props.setPaperData(response.data);
				console.log('got the papers.');
			})
			.catch(function (error) {
				// handle error
				console.log(error);
				console.log('DIDNT GET the papers.');
			});
	}, [examBoardNum]);
	*/

  // papersFromServer("uk/"+loc_parts[1]+"/"+loc_parts[2]+"/"+item.url+"/");

  function resetFields(n) {
    if (n >= 1) {
      // reset paper filter (to 'all papers')
      setPaperTypeName("All papers");
      setPaperTypeNum(0); // Not sure this is ever used?? Url is used instead
      setPapersFiltered(false);

      if (n >= 2) {
        // reset exam board
        setExamBoardName("Exam board");
        setExamBoardNum(0);

        if (n >= 3) {
          // reset subject
          setSubjName("Subject");
          setSubjNum(0);

          if (n >= 4) {
            // reset qualification
            setQualName("Qualification");
            setQualNum(0);
            setToggleQual(true);
            setSubjEnabled(false);
          }
        }
      }
    }
  }

  /*
	setQualName(
		qualData.find(x => x.url === qualUrl).name
	);
	*/

  // This causes infinite loop, because setting a state re-renders the page.
  //setCount(count+1);

  // This is fine, but unneccessary because you'd just do setState(1) originally anyway.
  // (HOOK RULES Docs: "Don’t call Hooks inside loops, conditions, or nested functions")
  /*
	useEffect(() => { 
		setCount(count+1);
	}, []);
	*/

  function papersFromServer(url_ending) {
    console.log("getting papers...");
    //console.log(props.paperData);

    axios
      .get(papersURL + url_ending)
      .then(function (response) {
        //props.setPaperData(response.data);
        var paperrdataa = response.data;

        console.log("got the papers.");
        console.log(paperrdataa);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
  }

  //papersFromServer(papersURL);

  //console.log(testData.ruffvar);
  //console.log(paperData.papers);

  //console.log(qualUrl);
  //const quadSpec = qualData.find(x => x.url === qualUrl).name; // get qual/subj/etc Name from URL.
  //console.log(quadSpec);

  // Turn these into FUNCTIONS ! or useEffect
  if (props.subjData) {
    var subjDataFilter = props.subjData.filter(
      (item) => item.qualification === qualNum,
    );
  } else {
    subjDataFilter = null;
  }
  //console.log('subj filtered!'); // this shows how often it runs!

  if (props.examBoardData) {
    var examBoardDataFilter = props.examBoardData.filter(
      (item) => item.subject === subjNum,
    );
  } else {
    examBoardDataFilter = null;
  }

  if (props.paperTypeData) {
    var paperTypeDataFilter = props.paperTypeData.filter(
      (item) => item.exam_board === examBoardNum && item.order !== 0, // && item.order !== 0
    );
  } else {
    paperTypeDataFilter = null;
  }

  /*
    const [runManyy, setRunManyy] = useState(0);

	useEffect(() => {
		if (props.paperTypeData) {
			allPapersFunction();
		} else {
			setRunManyy(runManyy + 1);
			// keep doing this useEffect until bookmarkArray exists (only seems to need one run)
		}

	}, [runManyy]);
	*/

  //const useCounterState = createPersistedState('count');
  //const [count, setCount] = useCounterState(false);

  /*
	var paperDict = { // get paper name from filename
		"none-pp.pdf": "Past* Paper",
		"none-qp.pdf": "Past* Paper",
		"none-ms.pdf": "Mark* Scheme",
		"pre.PDF": "Pre-release Material",
		"pp.PDF": "Past Paper",
		"qp.PDF": "Past Paper",
		"cards.PDF": "Question Cards",
		"sample.PDF": "Sample",
		"ms.PDF": "Mark Scheme",
		"er.PDF": "Exam Report",
		"com.PDF": "Commentary",
		"ins.PDF": "Insert",
		"in.PDF": "Insert",
		"sc.PDF": "Score",
		"sf.mp3": "Sound File",
		"sf.ZIP": "Sound Files (Separated)",
		"tr.PDF": "Transcript",
		"t3.PDF": "Transcript",
		"db.PDF": "Insert",
		"ex.PDF": "Example Responses",
		"notice.PDF": "Error Notice",
		"err.PDF": "Error Notice",
		"tn.PDF": "Teachers' Notes",
		"maths-in-science.PDF": "Maths In Science",
		"neastudent.PDF": "Student Booklet",
		"neateacher.PDF": "Teacher Booklet",
	};
	*/

  var paperDict = {
    // get paper name from filename
    "none-pp": "Past* Paper",
    "none-qp": "Past* Paper",
    "none-ms": "Mark* Scheme",
    pre: "Pre-release Material",
    pp: "Past Paper",
    qp: "Past Paper",
    qpr: "Past Paper (R)",
    qm: "Past Paper & MS",
    qm2: "Past Paper & MS 2",
    qm3: "Past Paper & MS 3",
    ch: "Changes",
    ch2: "More Changes",
    chz: "Changes (.zip)",
    cards: "Question Cards",
    sample: "Sample",
    ms: "Mark Scheme",
    msr: "Mark Scheme (R)",
    rep: "Exam Report",
    repr: "Exam Report (R)",
    com: "Commentary",
    ins: "Insert",
    in: "Insert",
    per: "Periodic Table",
    fo: "Formula Book",
    sb: "Source Booklet",
    bo: "Booklet",
    ma: "Map",
    anth: "Poetry Anthology",
    da: "Data Sheet",
    sc: "Score",
    cc: "Role Play",
    rp: "Role Play",
    sf: "Sound File",
    sfz: "Sound Files (.zip)",
    //"sf.zip": "Sound Files (Separated)",
    tr: "Transcript",
    t3: "Transcript",
    db: "Teacher's Booklet",
    hint: "Exam Hints",
    chk: "Revision Checklist",
    ex: "Example Responses",
    exr: "Example Responses (R)",
    ex2: "Example Responses 2",
    ex3: "Example Responses 3",
    notice: "Error Notice",
    err: "Error Notice",
    er: "Error Notice",
    tn: "Teacher's Notes",
    "maths-in-science": "Maths In Science",
    neastudent: "NEA Student Booklet",
    neateacher: "NEA Teacher Booklet",
    nea: "NEA Marking Criteria",
    t: "translation",
    neacrit: "NEA Marking Criteria",
    crit: "Assessment Criteria",
    spec: "Specification",
    specadd: "Specif. Addendum",
    guid: "Question Guidance",
    gloss: "Glossary",
    sa: "Sample",
    sa1: "Sample 1",
    sa2: "Sample 2",
    mssfz: "Mark Scheme (Audio)",
    mo: "Movie",
    dic: "Dictation",
    dica: "Dictation A",
    dicb: "Dictation B",
    faq: "FAQ",
    man: "Mandarin .mp3",
    can: "Cantonese .mp3",
    comm: "Command Words",
    code: "Code Files",
  };

  //localStorage.setItem("ruff2", "true");
  //const ruff_store = localStorage.getItem("ruff");

  // CSS (if want to depend on states)
  const seeSS = `
		.buttonnn {
			background: lightgrey;
		}
	`;

  const urlStart = "https://examoo.s3.eu-west-2.amazonaws.com/papers/uk/";

  const aqaMap = {
    // GCSE MATHS
    "gcse/maths/aqa/1-F/22-jun/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/8d6a74f167b4a2a8a6fe03d2624982dde3f9312c.pdf",
    "gcse/maths/aqa/1-H/22-jun/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/8d6a74f167b4a2a8a6fe03d2624982dde3f9312c.pdf",
    "gcse/maths/aqa/2-F/22-jun/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/8d6a74f167b4a2a8a6fe03d2624982dde3f9312c.pdf",
    "gcse/maths/aqa/2-H/22-jun/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/8d6a74f167b4a2a8a6fe03d2624982dde3f9312c.pdf",
    "gcse/maths/aqa/3-F/22-jun/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/8d6a74f167b4a2a8a6fe03d2624982dde3f9312c.pdf",
    "gcse/maths/aqa/3-H/22-jun/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/8d6a74f167b4a2a8a6fe03d2624982dde3f9312c.pdf",

    "gcse/maths/aqa/1-F/17-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83001F-SQP.PDF",
    "gcse/maths/aqa/1-F/17-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83001F-SMS.PDF",
    "gcse/maths/aqa/1-H/17-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83001H-SQP.PDF",
    "gcse/maths/aqa/1-H/17-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83001H-SMS.PDF",
    "gcse/maths/aqa/2-F/17-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83002F-SQP.PDF",
    "gcse/maths/aqa/2-F/17-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83002F-SMS.PDF",
    "gcse/maths/aqa/2-H/17-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83002H-SQP.PDF",
    "gcse/maths/aqa/2-H/17-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83002H-SMS.PDF",
    "gcse/maths/aqa/3-F/17-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83003F-SQP.PDF",
    "gcse/maths/aqa/3-F/17-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83003F-SMS.PDF",
    "gcse/maths/aqa/3-H/17-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83003H-SQP.PDF",
    "gcse/maths/aqa/3-H/17-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83003H-SMS.PDF",
    "gcse/maths/aqa/1-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83001F-QP-JUN23.PDF",
    "gcse/maths/aqa/1-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83001F-MS-JUN23.PDF",
    "gcse/maths/aqa/1-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83001H-QP-JUN23.PDF",
    "gcse/maths/aqa/1-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83001H-MS-JUN23.PDF",
    "gcse/maths/aqa/2-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83002F-QP-JUN23.PDF",
    "gcse/maths/aqa/2-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83002F-MS-JUN23.PDF",
    "gcse/maths/aqa/2-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83002H-QP-JUN23.PDF",
    "gcse/maths/aqa/2-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83002H-MS-JUN23.PDF",
    "gcse/maths/aqa/3-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83003F-QP-JUN23.PDF",
    "gcse/maths/aqa/3-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83003F-MS-JUN23.PDF",
    "gcse/maths/aqa/3-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83003H-QP-JUN23.PDF",
    "gcse/maths/aqa/3-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83003H-MS-JUN23.PDF",
    "gcse/maths/aqa/1-F/22-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83001F-QP-NOV22.PDF",
    "gcse/maths/aqa/1-F/22-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83001F-MS-NOV22.PDF",
    "gcse/maths/aqa/1-H/22-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83001H-QP-NOV22.PDF",
    "gcse/maths/aqa/1-H/22-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83001H-MS-NOV22.PDF",
    "gcse/maths/aqa/2-F/22-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83002F-QP-NOV22.PDF",
    "gcse/maths/aqa/2-F/22-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83002F-MS-NOV22.PDF",
    "gcse/maths/aqa/2-H/22-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83002H-QP-NOV22.PDF",
    "gcse/maths/aqa/2-H/22-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83002H-MS-NOV22.PDF",
    "gcse/maths/aqa/3-F/22-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83003F-QP-NOV22.PDF",
    "gcse/maths/aqa/3-F/22-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83003F-MS-NOV22.PDF",
    "gcse/maths/aqa/3-H/22-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83003H-QP-NOV22.PDF",
    "gcse/maths/aqa/3-H/22-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83003H-MS-NOV22.PDF",
    "gcse/maths/aqa/1-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83001F-QP-JUN22.PDF",
    "gcse/maths/aqa/1-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83001F-MS-JUN22.PDF",
    "gcse/maths/aqa/1-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83001H-QP-JUN22.PDF",
    "gcse/maths/aqa/1-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83001H-MS-JUN22.PDF",
    "gcse/maths/aqa/2-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83002F-QP-JUN22.PDF",
    "gcse/maths/aqa/2-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83002F-MS-JUN22.PDF",
    "gcse/maths/aqa/2-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83002H-QP-JUN22.PDF",
    "gcse/maths/aqa/2-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83002H-MS-JUN22.PDF",
    "gcse/maths/aqa/3-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83003F-QP-JUN22.PDF",
    "gcse/maths/aqa/3-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83003F-MS-JUN22.PDF",
    "gcse/maths/aqa/3-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83003H-QP-JUN22.PDF",
    "gcse/maths/aqa/3-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83003H-MS-JUN22.PDF",
    "gcse/maths/aqa/1-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83001F-QP-NOV21.PDF",
    "gcse/maths/aqa/1-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83001F-MS-NOV21.PDF",
    "gcse/maths/aqa/1-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83001H-QP-NOV21.PDF",
    "gcse/maths/aqa/1-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83001H-MS-NOV21.PDF",
    "gcse/maths/aqa/2-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83002F-QP-NOV21.PDF",
    "gcse/maths/aqa/2-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83002F-MS-NOV21.PDF",
    "gcse/maths/aqa/2-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83002H-QP-NOV21.PDF",
    "gcse/maths/aqa/2-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83002H-MS-NOV21.PDF",
    "gcse/maths/aqa/3-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83003F-QP-NOV21.PDF",
    "gcse/maths/aqa/3-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83003F-MS-NOV21.PDF",
    "gcse/maths/aqa/3-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83003H-QP-NOV21.PDF",
    "gcse/maths/aqa/3-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83003H-MS-NOV21.PDF",
    "gcse/maths/aqa/1-F/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83001F-QP-NOV20.PDF",
    "gcse/maths/aqa/1-F/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83001F-W-MS-NOV20.PDF",
    "gcse/maths/aqa/1-H/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83001H-QP-NOV20.PDF",
    "gcse/maths/aqa/1-H/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83001H-W-MS-NOV20.PDF",
    "gcse/maths/aqa/2-F/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83002F-QP-NOV20.PDF",
    "gcse/maths/aqa/2-F/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83002F-W-MS-NOV20.PDF",
    "gcse/maths/aqa/2-H/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83002H-QP-NOV20.PDF",
    "gcse/maths/aqa/2-H/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83002H-W-MS-NOV20.PDF",
    "gcse/maths/aqa/3-F/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83003F-QP-NOV20.PDF",
    "gcse/maths/aqa/3-F/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83003F-W-MS-NOV20.PDF",
    "gcse/maths/aqa/3-H/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83003H-QP-NOV20.PDF",
    "gcse/maths/aqa/3-H/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83003H-W-MS-NOV20.PDF",
    "gcse/maths/aqa/1-F/19-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83001F-QP-NOV19.PDF",
    "gcse/maths/aqa/1-F/19-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83001F-W-MS-NOV19.PDF",
    "gcse/maths/aqa/1-H/19-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83001H-QP-NOV19.PDF",
    "gcse/maths/aqa/1-H/19-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83001H-W-MS-NOV19.PDF",
    "gcse/maths/aqa/2-F/19-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83002F-QP-NOV19.PDF",
    "gcse/maths/aqa/2-F/19-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83002F-W-MS-NOV19.PDF",
    "gcse/maths/aqa/2-H/19-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83002H-QP-NOV19.PDF",
    "gcse/maths/aqa/2-H/19-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83002H-W-MS-NOV19.PDF",
    "gcse/maths/aqa/3-F/19-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83003F-QP-NOV19.PDF",
    "gcse/maths/aqa/3-F/19-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83003F-W-MS-NOV19.PDF",
    "gcse/maths/aqa/3-H/19-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83003H-QP-NOV19.PDF",
    "gcse/maths/aqa/3-H/19-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/november/AQA-83003H-W-MS-NOV19.PDF",
    "gcse/maths/aqa/1-F/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83001F-QP-JUN19.PDF",
    "gcse/maths/aqa/1-F/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83001F-W-MS-JUN19.PDF",
    "gcse/maths/aqa/1-H/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83001H-QP-JUN19.PDF",
    "gcse/maths/aqa/1-H/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83001H-W-MS-JUN19.PDF",
    "gcse/maths/aqa/2-F/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83002F-QP-JUN19.PDF",
    "gcse/maths/aqa/2-F/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83002F-W-MS-JUN19.PDF",
    "gcse/maths/aqa/2-H/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83002H-QP-JUN19.PDF",
    "gcse/maths/aqa/2-H/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83002H-W-MS-JUN19.PDF",
    "gcse/maths/aqa/3-F/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83003F-QP-JUN19.PDF",
    "gcse/maths/aqa/3-F/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83003F-W-MS-JUN19.PDF",
    "gcse/maths/aqa/3-H/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83003H-QP-JUN19.PDF",
    "gcse/maths/aqa/3-H/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83003H-W-MS-JUN19.PDF",
    "gcse/maths/aqa/1-F/18-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83001F-QP-NOV18.PDF",
    "gcse/maths/aqa/1-F/18-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83001F-W-MS-NOV18.PDF",
    "gcse/maths/aqa/1-H/18-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83001H-QP-NOV18.PDF",
    "gcse/maths/aqa/1-H/18-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83001H-W-MS-NOV18.PDF",
    "gcse/maths/aqa/2-F/18-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83002F-QP-NOV18.PDF",
    "gcse/maths/aqa/2-F/18-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83002F-W-MS-NOV18.PDF",
    "gcse/maths/aqa/2-H/18-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83002H-QP-NOV18.PDF",
    "gcse/maths/aqa/2-H/18-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83002H-W-MS-NOV18.PDF",
    "gcse/maths/aqa/3-F/18-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83003F-QP-NOV18.PDF",
    "gcse/maths/aqa/3-F/18-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83003F-W-MS-NOV18.PDF",
    "gcse/maths/aqa/3-H/18-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83003H-QP-NOV18.PDF",
    "gcse/maths/aqa/3-H/18-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/november/AQA-83003H-W-MS-NOV18.PDF",
    "gcse/maths/aqa/1-F/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83001F-QP-JUN18.PDF",
    "gcse/maths/aqa/1-F/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83001F-W-MS-JUN18.PDF",
    "gcse/maths/aqa/1-H/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83001H-QP-JUN18.PDF",
    "gcse/maths/aqa/1-H/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83001H-W-MS-JUN18.PDF",
    "gcse/maths/aqa/2-F/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83002F-QP-JUN18.PDF",
    "gcse/maths/aqa/2-F/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83002F-W-MS-JUN18.PDF",
    "gcse/maths/aqa/2-H/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83002H-QP-JUN18.PDF",
    "gcse/maths/aqa/2-H/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83002H-W-MS-JUN18.PDF",
    "gcse/maths/aqa/3-F/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83003F-QP-JUN18.PDF",
    "gcse/maths/aqa/3-F/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83003F-W-MS-JUN18.PDF",
    "gcse/maths/aqa/3-H/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83003H-QP-JUN18.PDF",
    "gcse/maths/aqa/3-H/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-83003H-W-MS-JUN18.PDF",

    "gcse/maths/aqa/1-F/17-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83001F-QP-NOV17.PDF",
    "gcse/maths/aqa/1-F/17-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83001F-W-MS-NOV17.PDF",
    "gcse/maths/aqa/1-H/17-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83001H-QP-NOV17.PDF",
    "gcse/maths/aqa/1-H/17-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83001H-W-MS-NOV17.PDF",
    "gcse/maths/aqa/2-F/17-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83002F-QP-NOV17.PDF",
    "gcse/maths/aqa/2-F/17-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83002F-W-MS-NOV17.PDF",
    "gcse/maths/aqa/2-H/17-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83002H-QP-NOV17.PDF",
    "gcse/maths/aqa/2-H/17-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83002H-W-MS-NOV17.PDF",
    "gcse/maths/aqa/3-F/17-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83003F-QP-NOV17.PDF",
    "gcse/maths/aqa/3-F/17-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83003F-W-MS-NOV17.PDF",
    "gcse/maths/aqa/3-H/17-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83003H-QP-NOV17.PDF",
    "gcse/maths/aqa/3-H/17-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/november/AQA-83003H-W-MS-NOV17.PDF",
    "gcse/maths/aqa/1-F/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83001F-QP-JUN17.PDF",
    "gcse/maths/aqa/1-F/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83001F-W-MS-JUN17.PDF",
    "gcse/maths/aqa/1-H/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83001H-QP-JUN17.PDF",
    "gcse/maths/aqa/1-H/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83001H-W-MS-JUN17.PDF",
    "gcse/maths/aqa/2-F/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83002F-QP-JUN17.PDF",
    "gcse/maths/aqa/2-F/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83002F-W-MS-JUN17.PDF",
    "gcse/maths/aqa/2-H/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83002H-QP-JUN17.PDF",
    "gcse/maths/aqa/2-H/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83002H-W-MS-JUN17.PDF",
    "gcse/maths/aqa/3-F/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83003F-QP-JUN17.PDF",
    "gcse/maths/aqa/3-F/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83003F-W-MS-JUN17.PDF",
    "gcse/maths/aqa/3-H/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83003H-QP-JUN17.PDF",
    "gcse/maths/aqa/3-H/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-83003H-W-MS-JUN17.PDF",

    // AS MATHS

    "as/maths/aqa/2/17-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-73562-SQP.PDF",
    "as/maths/aqa/2/17-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-73562-SMS.PDF",
    "as/maths/aqa/1/23-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-73561-QP-JUN23.PDF",
    "as/maths/aqa/1/23-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-73561-MS-JUN23.PDF",
    "as/maths/aqa/2/23-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-73562-QP-JUN23.PDF",
    "as/maths/aqa/2/23-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-73562-MS-JUN23.PDF",
    "as/maths/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-73561-QP-JUN22.PDF",
    "as/maths/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-73561-MS-JUN22.PDF",
    "as/maths/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-73562-QP-JUN22.PDF",
    "as/maths/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-73562-MS-JUN22.PDF",
    "as/maths/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-73561-QP-NOV21.PDF",
    "as/maths/aqa/1/21-jun/ms.PDF":
      "http://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-73561-MS-NOV21.PDF",
    "as/maths/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-73562-QP-NOV21.PDF",
    "as/maths/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-73562-MS-NOV21.PDF",
    "as/maths/aqa/1/20-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-73561-QP-NOV20.PDF",
    "as/maths/aqa/1/20-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-73561-W-MS-NOV20.PDF",
    "as/maths/aqa/2/20-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-73562-QP-NOV20.PDF",
    "as/maths/aqa/2/20-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-73562-W-MS-NOV20.PDF",
    "as/maths/aqa/2/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-73562-QP-JUN19.PDF",
    "as/maths/aqa/2/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-73562-W-MS-JUN19.PDF",
    "as/maths/aqa/1/19-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-73561-QP-JUN19.PDF",
    "as/maths/aqa/1/19-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-73561-W-MS-JUN19.PDF",
    "as/maths/aqa/1/18-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-73561-QP-JUN18.PDF",
    "as/maths/aqa/1/18-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-73561-W-MS-JUN18.PDF",
    "as/maths/aqa/2/18-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-73562-QP-JUN18.PDF",
    "as/maths/aqa/2/18-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-73562-W-MS-JUN18.PDF",

    // A-LEVEL MATHS
    "a-level/maths/aqa/1/17-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-73571-SQP.PDF",
    "a-level/maths/aqa/1/17-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-73571-SMS.PDF",
    "a-level/maths/aqa/2/17-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-73572-SQP.PDF",
    "a-level/maths/aqa/2/17-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-73572-SMS.PDF",
    "a-level/maths/aqa/3/17-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-73573-SQP.PDF",
    "a-level/maths/aqa/3/17-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-73573-SMS.PDF",
    "a-level/maths/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-73571-QP-JUN23.PDF",
    "a-level/maths/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-73571-MS-JUN23.PDF",
    "a-level/maths/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-73572-QP-JUN23.PDF",
    "a-level/maths/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-73572-MS-JUN23.PDF",
    "a-level/maths/aqa/3/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-73573-QP-JUN23.PDF",
    "a-level/maths/aqa/3/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-73573-MS-JUN23.PDF",
    "a-level/maths/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-73571-QP-JUN22.PDF",
    "a-level/maths/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-73571-MS-JUN22.PDF",
    "a-level/maths/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-73572-QP-JUN22.PDF",
    "a-level/maths/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-73572-MS-JUN22.PDF",
    "a-level/maths/aqa/3/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-73573-QP-JUN22.PDF",
    "a-level/maths/aqa/3/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-73573-MS-JUN22.PDF",
    "a-level/maths/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-73571-QP-NOV21.PDF",
    "a-level/maths/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-73571-MS-NOV21.PDF",
    "a-level/maths/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-73572-QP-NOV21.PDF",
    "a-level/maths/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-73572-MS-NOV21.PDF",
    "a-level/maths/aqa/3/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-73573-QP-NOV21.PDF",
    "a-level/maths/aqa/3/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-73573-MS-NOV21.PDF",
    "a-level/maths/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-73571-QP-NOV20.PDF",
    "a-level/maths/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-73571-W-MS-NOV20.PDF",
    "a-level/maths/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-73572-QP-NOV20.PDF",
    "a-level/maths/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-73572-W-MS-NOV20.PDF",
    "a-level/maths/aqa/3/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-73573-QP-NOV20.PDF",
    "a-level/maths/aqa/3/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-73573-W-MS-NOV20.PDF",
    "a-level/maths/aqa/1/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-73571-QP-JUN19.PDF",
    "a-level/maths/aqa/1/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-73571-W-MS-JUN19.PDF",
    "a-level/maths/aqa/2/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-73572-QP-JUN19.PDF",
    "a-level/maths/aqa/2/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-73572-W-MS-JUN19.PDF",
    "a-level/maths/aqa/3/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-73573-QP-JUN19.PDF",
    "a-level/maths/aqa/3/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-73573-W-MS-JUN19.PDF",
    "a-level/maths/aqa/1/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-73571-QP-JUN18.PDF",
    "a-level/maths/aqa/1/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-73571-W-MS-JUN18.PDF",
    "a-level/maths/aqa/2/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-73572-QP-JUN18.PDF",
    "a-level/maths/aqa/2/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-73572-W-MS-JUN18.PDF",
    "a-level/maths/aqa/3/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-73573-QP-JUN18.PDF",
    "a-level/maths/aqa/3/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-73573-W-MS-JUN18.PDF",

    // GCSE Statistics
    "gcse/statistics/aqa/1-F/19-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83821F-SQP.PDF",
    "gcse/statistics/aqa/1-H/19-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83821H-SQP.PDF",
    "gcse/statistics/aqa/2-F/19-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83822F-SQP.PDF",
    "gcse/statistics/aqa/2-H/19-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/mathematics/AQA-83822H-SQP.PDF",
    "gcse/statistics/aqa/1-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83821F-QP-JUN23-CR.PDF",
    "gcse/statistics/aqa/1-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83821F-MS-JUN23.PDF",
    "gcse/statistics/aqa/1-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83821H-QP-JUN23.PDF",
    "gcse/statistics/aqa/1-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83821H-MS-JUN23.PDF",
    "gcse/statistics/aqa//undefined-ins/ins.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83822H-INS-NOV21.PDF",
    "gcse/statistics/aqa/2-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83822F-QP-JUN23.PDF",
    "gcse/statistics/aqa/2-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83822F-MS-JUN23.PDF",
    "gcse/statistics/aqa/2-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83822H-QP-JUN23.PDF",
    "gcse/statistics/aqa/2-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83822H-MS-JUN23.PDF",
    "gcse/statistics/aqa/1-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83821F-QP-JUN22.PDF",
    "gcse/statistics/aqa/1-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83821F-MS-JUN22.PDF",
    "gcse/statistics/aqa/1-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83821H-QP-JUN22.PDF",
    "gcse/statistics/aqa/1-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83821H-MS-JUN22.PDF",
    "gcse/statistics/aqa/2-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83822F-QP-JUN22.PDF",
    "gcse/statistics/aqa/2-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83822F-MS-JUN22.PDF",
    "gcse/statistics/aqa/2-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83822H-QP-JUN22.PDF",
    "gcse/statistics/aqa/2-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-83822H-MS-JUN22.PDF",
    "gcse/statistics/aqa/1-F/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83821F-QP-NOV21.PDF",
    "gcse/statistics/aqa/1-F/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83821F-MS-NOV21.PDF",
    "gcse/statistics/aqa/1-H/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83821H-QP-NOV21.PDF",
    "gcse/statistics/aqa/1-H/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83821H-MS-NOV21.PDF",
    "gcse/statistics/aqa/2-F/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83822F-QP-NOV21-CR.PDF",
    "gcse/statistics/aqa/2-F/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83822F-MS-NOV21.PDF",
    "gcse/statistics/aqa/2-H/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83822H-QP-NOV21.PDF",
    "gcse/statistics/aqa/2-H/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83822H-MS-NOV21.PDF",
    "gcse/statistics/aqa/1-F/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83821F-QP-NOV20.PDF",
    "gcse/statistics/aqa/1-F/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83821F-W-MS-NOV20.PDF",
    "gcse/statistics/aqa/1-H/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83821H-QP-NOV20.PDF",
    "gcse/statistics/aqa/1-H/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83821H-W-MS-NOV20.PDF",
    "gcse/statistics/aqa/2-F/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83822F-QP-NOV20.PDF",
    "gcse/statistics/aqa/2-F/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83822F-W-MS-NOV20.PDF",
    "gcse/statistics/aqa/2-H/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83822H-QP-NOV20.PDF",
    "gcse/statistics/aqa/2-H/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83822H-W-MS-NOV20.PDF",
    "gcse/statistics/aqa/2-F/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83822F-QP-JUN19.PDF",
    "gcse/statistics/aqa/2-F/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83822F-W-MS-JUN19.PDF",

    // GCSE Spanish
    "gcse/spanish/aqa/1-F/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86981F-SQP.PDF",
    "gcse/spanish/aqa/1-F/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86981F-SMS.PDF",
    "gcse/spanish/aqa/-/le-sou/ins.PDF": "",
    "gcse/spanish/aqa/1-H/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86981H-SQP.PDF",
    "gcse/spanish/aqa/1-H/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86981H-SMS.PDF",
    "gcse/spanish/aqa/2-F/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86982F-SRP-9.PDF",
    "gcse/spanish/aqa/2-F/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86982FH-SMS.PDF",
    "gcse/spanish/aqa/2-H/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86982H-SRP-18.PDF",
    "gcse/spanish/aqa/2-H/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86982FH-SMS.PDF",
    "gcse/spanish/aqa/3-F/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86983F-SQP-CR.PDF",
    "gcse/spanish/aqa/3-F/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86983F-SMS.PDF",
    "gcse/spanish/aqa/3-H/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86983H-SQP-CR.PDF",
    "gcse/spanish/aqa/3-H/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86983H-SMS.PDF",
    "gcse/spanish/aqa/4-F/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86984F-SQP-CR.PDF",
    "gcse/spanish/aqa/4-F/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86984FH-SMS.PDF",
    "gcse/spanish/aqa/4-H/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86984H-SQP.PDF",
    "gcse/spanish/aqa/4-H/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-86984FH-SMS.PDF",
    "gcse/spanish/aqa/1-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698LF-QP-JUN23.PDF",
    "gcse/spanish/aqa/1-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698LF-MS-JUN23.PDF",
    "gcse/spanish/aqa/1-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698LH-QP-JUN23.PDF",
    "gcse/spanish/aqa/1-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698LH-MS-JUN23.PDF",
    "gcse/spanish/aqa/3-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698RF-QP-JUN23.PDF",
    "gcse/spanish/aqa/3-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698RF-MS-JUN23.PDF",
    "gcse/spanish/aqa/3-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698RH-QP-JUN23.PDF",
    "gcse/spanish/aqa/3-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698RH-MS-JUN23.PDF",
    "gcse/spanish/aqa/4-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698WF-QP-JUN23.PDF",
    "gcse/spanish/aqa/4-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698WF-MS-JUN23.PDF",
    "gcse/spanish/aqa/4-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698WH-QP-JUN23.PDF",
    "gcse/spanish/aqa/4-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8698WH-MS-JUN23.PDF",
    "gcse/spanish/aqa/1-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698LF-QP-JUN22.PDF",
    "gcse/spanish/aqa/1-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698LF-MS-JUN22.PDF",
    "gcse/spanish/aqa/1-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698LH-QP-JUN22.PDF",
    "gcse/spanish/aqa/1-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698LH-MS-JUN22.PDF",
    "gcse/spanish/aqa/3-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698RF-QP-JUN22.PDF",
    "gcse/spanish/aqa/3-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698RF-MS-JUN22.PDF",
    "gcse/spanish/aqa/3-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698RH-QP-JUN22-CR.PDF",
    "gcse/spanish/aqa/3-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698RH-MS-JUN22.PDF",
    "gcse/spanish/aqa/4-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698WF-QP-JUN22.PDF",
    "gcse/spanish/aqa/4-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698WF-MS-JUN22.PDF",
    "gcse/spanish/aqa/4-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698WH-QP-JUN22.PDF",
    "gcse/spanish/aqa/4-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8698WH-MS-JUN22.PDF",
    "gcse/spanish/aqa/1-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86981F-QP-NOV21.PDF",
    "gcse/spanish/aqa/1-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86981H-MS-NOV21.PDF",
    "gcse/spanish/aqa/1-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86981H-QP-NOV21.PDF",
    "gcse/spanish/aqa/1-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86981H-MS-NOV21.PDF",
    "gcse/spanish/aqa/3-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86983F-QP-NOV21.PDF",
    "gcse/spanish/aqa/3-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86983F-MS-NOV21.PDF",
    "gcse/spanish/aqa/3-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86983H-QP-NOV21.PDF",
    "gcse/spanish/aqa/3-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86983H-MS-NOV21.PDF",
    "gcse/spanish/aqa/4-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86984F-QP-NOV21.PDF",
    "gcse/spanish/aqa/4-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86984F-MS-NOV21.PDF",
    "gcse/spanish/aqa/4-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86984H-QP-NOV21.PDF",
    "gcse/spanish/aqa/4-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-86984H-MS-NOV21.PDF",
    "gcse/spanish/aqa/1-F/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86981F-QP-NOV20.PDF",
    "gcse/spanish/aqa/1-F/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86981F-W-MS-NOV20.PDF",
    "gcse/spanish/aqa/1-H/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86981H-QP-NOV20.PDF",
    "gcse/spanish/aqa/1-H/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86981H-W-MS-NOV20.PDF",
    "gcse/spanish/aqa/3-F/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86983F-QP-NOV20-CR.PDF",
    "gcse/spanish/aqa/3-F/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86983F-W-MS-NOV20.PDF",
    "gcse/spanish/aqa/3-H/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86983H-QP-NOV20-CR.PDF",
    "gcse/spanish/aqa/3-H/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86983H-W-MS-NOV20.PDF",
    "gcse/spanish/aqa/4-F/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86984F-QP-NOV20.PDF",
    "gcse/spanish/aqa/4-F/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86984F-W-MS-NOV20.PDF",
    "gcse/spanish/aqa/4-H/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86984H-QP-NOV20.PDF",
    "gcse/spanish/aqa/4-H/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-86984H-W-MS-NOV20.PDF",
    "gcse/spanish/aqa/1-F/19-jun/qp.PDF": "",
    "gcse/spanish/aqa/1-F/19-jun/ms.PDF": "",
    "gcse/spanish/aqa/-/undefined-tra/ins.PDF": "",
    "gcse/spanish/aqa/1-H/19-jun/qp.PDF": "",
    "gcse/spanish/aqa/1-H/19-jun/ms.PDF": "",
    "gcse/spanish/aqa/3-F/19-jun/qp.PDF": "",
    "gcse/spanish/aqa/3-F/19-jun/ms.PDF": "",
    "gcse/spanish/aqa/3-H/19-jun/qp.PDF": "",
    "gcse/spanish/aqa/3-H/19-jun/ms.PDF": "",
    "gcse/spanish/aqa/4-F/19-jun/qp.PDF": "",
    "gcse/spanish/aqa/4-F/19-jun/ms.PDF": "",
    "gcse/spanish/aqa/4-H/19-jun/qp.PDF": "",
    "gcse/spanish/aqa/4-H/19-jun/ms.PDF": "",
    "gcse/spanish/aqa/1-F/18-jun/qp.PDF": "",
    "gcse/spanish/aqa/1-F/18-jun/ms.PDF": "",
    "gcse/spanish/aqa/1-H/18-jun/qp.PDF": "",
    "gcse/spanish/aqa/1-H/18-jun/ms.PDF": "",
    "gcse/spanish/aqa/3-F/18-jun/qp.PDF": "",
    "gcse/spanish/aqa/3-F/18-jun/ms.PDF": "",
    "gcse/spanish/aqa/3-H/18-jun/qp.PDF": "",
    "gcse/spanish/aqa/3-H/18-jun/ms.PDF": "",
    "gcse/spanish/aqa/4-F/18-jun/qp.PDF": "",
    "gcse/spanish/aqa/4-F/18-jun/ms.PDF": "",
    "gcse/spanish/aqa/4-H/18-jun/qp.PDF": "",
    "gcse/spanish/aqa/4-H/18-jun/ms.PDF": "",

    // A-LEVEL SPANISH

    "a-level/spanish/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-76921-SQP.PDF",
    "a-level/spanish/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-76921-SMS.PDF",
    "a-level/spanish/aqa/1/20-nov/sf.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-76921-SF-NOV20.MP3",
    "a-level/spanish/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-76922-SQP.PDF",
    "a-level/spanish/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-76922-SMS.PDF",
    "a-level/spanish/aqa/3/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-76923-SQP-CR.PDF",
    "a-level/spanish/aqa/3/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/spanish/AQA-76923-SMS.PDF",
    "a-level/spanish/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-76921-QP-JUN22.PDF",
    "a-level/spanish/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-76921-MS-JUN22.PDF",
    "a-level/spanish/aqa/1/20-nov/ins.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-76921-INS-NOV20.PDF",
    "a-level/spanish/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-76922-QP-JUN22.PDF",
    "a-level/spanish/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-76922-MS-JUN22.PDF",
    "a-level/spanish/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-76921-QP-NOV21.PDF",
    "a-level/spanish/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-76921-MS-NOV21.PDF",
    "a-level/spanish/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-76922-QP-NOV21.PDF",
    "a-level/spanish/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-76922-MS-NOV21.PDF",
    "a-level/spanish/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-76921-QP-NOV20.PDF",
    "a-level/spanish/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-76921-W-MS-NOV20.PDF",
    "a-level/spanish/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-76922-QP-NOV20.PDF",
    "a-level/spanish/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-76922-W-MS-NOV20.PDF",

    // AS SPANISH
    "as/spanish/aqa/3/23-jun/cards.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/c58bd29d38ccf2f0f063db3e2ea04d5456e6aba4.pdf",
    "as/spanish/aqa/3/23-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/e198b563c4a6fe7a8d24c27e0403b5ea9dadb76c.pdf",
    "as/spanish/aqa/3/23-jun/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/112bbdce46e3290964b754772febae92db63c748.pdf",
    "as/spanish/aqa/3/23-jun/tn.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/2f473f2a216aecfd0644ea45e6cf0351cfc2b945.pdf",
    "as/spanish/aqa/1/22-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/bfa443b1cb1a241115848e8c51d2b37d5d8bed93.pdf",
    "as/spanish/aqa/3/17-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/f8fe8d8aeb69f28f35eda3dc4f21685f7e1b8c79.pdf",
    "as/spanish/aqa/1/23-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/ab72f8f37569174fd04bf8b6bacebe9edea782a1.pdf",
    "as/spanish/aqa/1/20-nov/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/f2346b68f5f7e868016e7fb88f56e5b712ab5b2f.pdf",
    "as/spanish/aqa/1/23-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/e49d4fe6419a8dd959614bfb620baa62b32fffd3.pdf",
    "as/spanish/aqa/1/22-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/6901a56c6e7c8d9e0e0bc8313d3baea269fb7c9e.pdf",
    "as/spanish/aqa/1/17-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/a5229e2ff6a9138d4536f8a7a778ba706d846696.pdf",
    "as/spanish/aqa/2/17-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/c4503aecb4c3d83315a57efc12fa41746b046632.pdf",
    "as/spanish/aqa/1/20-nov/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/2a1e989ebbebf95e55c375141679de58d7b25ee2.pdf",
    "as/spanish/aqa/1/22-jun/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/505f7d6749fb032f85ba6430fcaf6c93c4c01efc.pdf",
    "as/spanish/aqa/3/17-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/e33e294933a7a10230e1031b55b615efcef5837e.pdf",
    "as/spanish/aqa/2/23-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/e475424beb1eef5600023c5a56bca01f88516e3f.pdf",
    "as/spanish/aqa/1/17-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/baec8ded4beae0695c8924f3cab3863a4a98df73.pdf",
    "as/spanish/aqa/2/22-jun/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/59f8aa651cad2df5d982d5fede63c00f0f2cbb69.pdf",
    "as/spanish/aqa/3/17-spec/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/0701a2e0769fc527a0faf0f2ea8910c18c1b9da2.pdf",
    "as/spanish/aqa/1/23-jun/tr.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/b859cdef6da9fd29aa2f5fcfcdabdd737b13ea07.pdf",
    "as/spanish/aqa/2/23-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/c03842404ce08197683f49c2d7b61ed16667cec9.pdf",
    "as/spanish/aqa/2/20-nov/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/7436d9596b79396459709880ed0180ad5678dc26.pdf",
    "as/spanish/aqa/1/23-jun/sf.mp3":
      "https://cdn.sanity.io/files/p28bar15/green/a0d439d1529e38eb10004eb2fac37a6a1363fa86.zip",
    "as/spanish/aqa/2/23-jun/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/e3c27a834e7eed17ee16144e446a834c16679f98.pdf",
    "as/spanish/aqa/3/22-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/c235b2689417e8db61bcf5ee72bdc7297bf00f04.pdf",
    "as/spanish/aqa/1/22-jun/sf.mp3":
      "https://cdn.sanity.io/files/p28bar15/green/4518525c81e30078840ca134d9a5f81e677af3c7.zip",
    "as/spanish/aqa/1/22-jun/tr.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/bbad1a916faecad431ec894892abe6f94da6c542.pdf",
    "as/spanish/aqa/2/22-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/e9d99af3f5570caf7a120ea348f67168b42fe4df.pdf",
    "as/spanish/aqa/1/17-spec/sf.mp3":
      "https://cdn.sanity.io/files/p28bar15/green/5806373712f947f9137af493e0c4443f8259b321.zip",
    "as/spanish/aqa/2/22-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/963bf5b5372cc212d6724782a087c2d2c7cd7eaa.pdf",
    "as/spanish/aqa/1/17-spec/tr.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/7af533ef28a858ccbe4adfec3a7ff7040d1059ef.pdf",
    "as/spanish/aqa/2/20-nov/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/f95686dc6c6ba522fd40791440a26cfde278c2de.pdf",
    "as/spanish/aqa/1/20-nov/tr.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/964f2cbddaf5c6da7d450a63bdf5fc0319751ba3.pdf",
    "as/spanish/aqa/2/20-nov/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/ab10b3af71e2674eeecdbe667538311a433459ce.pdf",
    "as/spanish/aqa/2/17-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/54bee35e850c8c0344c533df30357b47c6b33ad5.pdf",

    // various sme pages:
    "a-level/accounting/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/accounting/AQA-71271-SQP.PDF",
    "a-level/accounting/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/accounting/AQA-71271-SMS.PDF",
    "a-level/accounting/aqa//d-ans/ins.PDF":
      "https://filestore.aqa.org.uk/resources/accounting/AQA-71272-EX.PDF",
    "a-level/accounting/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/accounting/AQA-71272-SQP.PDF",
    "a-level/accounting/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/accounting/AQA-71272-SMS.PDF",
    "a-level/accounting/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71271-QP-JUN22.PDF",
    "a-level/accounting/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71271-MS-JUN22.PDF",
    "a-level/accounting/aqa//undefined-ins/ins.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71271-INS-MQP18A4-NOV20.PDF",
    "a-level/accounting/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71272-QP-JUN22.PDF",
    "a-level/accounting/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71272-MS-JUN22.PDF",
    "a-level/accounting/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71271-QP-NOV21.PDF",
    "a-level/accounting/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71271-MS-NOV21.PDF",
    "a-level/accounting/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71272-QP-NOV21.PDF",
    "a-level/accounting/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71272-MS-NOV21.PDF",
    "a-level/accounting/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71271-QP-NOV20.PDF",
    "a-level/accounting/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71271-W-MS-NOV20.PDF",
    "a-level/accounting/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71272-QP-NOV20.PDF",
    "a-level/accounting/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71272-W-MS-NOV20.PDF",

    "a-level/biology/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74021-QP-JUN23.PDF",
    "a-level/biology/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74021-MS-JUN23.PDF",
    "a-level/biology/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74022-QP-JUN23.PDF",
    "a-level/biology/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74022-MS-JUN23.PDF",
    "a-level/biology/aqa/3/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74023-QP-JUN23.PDF",
    "a-level/biology/aqa/3/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74023-MS-JUN23.PDF",
    "a-level/biology/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74021-QP-JUN22-CR.PDF",
    "a-level/biology/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74021-MS-JUN22.PDF",
    "a-level/biology/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74022-QP-JUN22.PDF",
    "a-level/biology/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74022-MS-JUN22.PDF",
    "a-level/biology/aqa/3/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74023-QP-JUN22-CR.PDF",
    "a-level/biology/aqa/3/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74023-MS-JUN22.PDF",
    "a-level/biology/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74021-QP-NOV21-CR.PDF",
    "a-level/biology/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74021-MS-NOV21.PDF",
    "a-level/biology/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74022-QP-NOV21.PDF",
    "a-level/biology/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74022-QP-NOV21.PDF",
    "a-level/biology/aqa/3/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74023-QP-NOV21.PDF",
    "a-level/biology/aqa/3/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74023-MS-NOV21.PDF",
    "a-level/biology/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74021-QP-NOV20-CR.PDF",
    "a-level/biology/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74021-W-MS-NOV20.PDF",
    "a-level/biology/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74022-QP-NOV20.PDF",
    "a-level/biology/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74022-W-MS-NOV20.PDF",
    "a-level/biology/aqa/3/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74023-QP-NOV20-CR.PDF",
    "a-level/biology/aqa/3/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74023-W-MS-NOV20.PDF",
    "a-level/biology/aqa/1/19-jun/qp.PDF":
      "https://media.accesstuition.com/Exam-Papers/2019-AQA-A-Level-Biology-Paper-1-QP.pdf",
    "a-level/biology/aqa/1/19-jun/ms.PDF":
      "https://media.accesstuition.com/Exam-Papers/2019-AQA-A-Level-Biology-Paper-1-MS.pdf",
    "a-level/biology/aqa/2/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74022-QP-JUN19.PDF",
    "a-level/biology/aqa/2/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74022-W-MS-JUN19.PDF",
    "a-level/biology/aqa/3/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74023-QP-JUN19.PDF",
    "a-level/biology/aqa/3/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74023-W-MS-JUN19.PDF",
    "a-level/biology/aqa/1/18-jun/qp.PDF":
      "https://media.accesstuition.com/Exam-Papers/2018-AQA-A-Level-Biology-Paper-1-QP.pdf",
    "a-level/biology/aqa/1/18-jun/ms.PDF":
      "https://media.accesstuition.com/Exam-Papers/2018-AQA-A-Level-Biology-Paper-1-MS.pdf",
    "a-level/biology/aqa/2/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74022-QP-JUN18.PDF",
    "a-level/biology/aqa/2/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74022-W-MS-JUN18.PDF",
    "a-level/biology/aqa/3/18-jun/qp.PDF":
      "https://media.accesstuition.com/Exam-Papers/2018-AQA-A-Level-Biology-Paper-3-QP.pdf",
    "a-level/biology/aqa/3/18-jun/ms.PDF":
      "https://media.accesstuition.com/Exam-Papers/2018-AQA-A-Level-Biology-Paper-3-MS.pdf",
    "a-level/biology/aqa/1/17-jun/qp.PDF":
      "https://media.accesstuition.com/Exam-Papers/2017-AQA-A-Level-Biology-Paper-1-QP.pdf",
    "a-level/biology/aqa/1/17-jun/ms.PDF":
      "https://media.accesstuition.com/Exam-Papers/2017-AQA-A-Level-Biology-Paper-1-MS.pdf",
    "a-level/biology/aqa/2/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74022-QP-JUN17.PDF",
    "a-level/biology/aqa/2/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74022-W-MS-JUN17.PDF",
    "a-level/biology/aqa/3/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74023-QP-JUN17.PDF",
    "a-level/biology/aqa/3/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74023-W-MS-JUN17.PDF",

    "a-level/business/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71321-QP-JUN22.PDF",
    "a-level/business/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71321-MS-JUN22.PDF",
    "a-level/business/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71322-QP-JUN22.PDF",
    "a-level/business/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71322-MS-JUN22.PDF",
    "a-level/business/aqa/3/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71323-QP-JUN22.PDF",
    "a-level/business/aqa/3/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71323-MS-JUN22.PDF",
    "a-level/business/aqa//undefined-ins/ins.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Business-Paper-3-In.pdf",
    "a-level/business/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71321-QP-NOV21.PDF",
    "a-level/business/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71321-MS-NOV21.PDF",
    "a-level/business/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71322-QP-NOV21.PDF",
    "a-level/business/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71322-MS-NOV21.PDF",
    "a-level/business/aqa/3/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71323-QP-NOV21.PDF",
    "a-level/business/aqa/3/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71323-MS-NOV21.PDF",
    "a-level/business/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71321-QP-NOV20.PDF",
    "a-level/business/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71321-W-MS-NOV20.PDF",
    "a-level/business/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71322-QP-NOV20.PDF",
    "a-level/business/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71322-W-MS-NOV20.PDF",
    "a-level/business/aqa/3/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71323-QP-NOV20.PDF",
    "a-level/business/aqa/3/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71323-W-MS-NOV20.PDF",
    "a-level/business/aqa/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Business-Paper-1-QP.pdf",
    "a-level/business/aqa/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Business-Paper-1-MS.pdf",
    "a-level/business/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Business-Paper-2-QP.pdf",
    "a-level/business/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Business-Paper-2-MS.pdf",
    "a-level/business/aqa/3/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Business-Paper-3-QP.pdf",
    "a-level/business/aqa/3/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Business-Paper-3-MS.pdf",
    "a-level/business/aqa/1/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Business-Paper-1-QP.pdf",
    "a-level/business/aqa/1/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Business-Paper-1-MS.pdf",
    "a-level/business/aqa/2/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Business-Paper-2-QP.pdf",
    "a-level/business/aqa/2/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Business-Paper-2-MS.pdf",
    "a-level/business/aqa/3/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Business-Paper-3-QP.pdf",
    "a-level/business/aqa/3/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Business-Paper-3-MS.pdf",
    "a-level/business/aqa/1/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Business-Paper-1-QP.pdf",
    "a-level/business/aqa/1/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Business-Paper-1-MS.pdf",
    "a-level/business/aqa/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Business-Paper-2-QP.pdf",
    "a-level/business/aqa/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Business-Paper-2-MS.pdf",
    "a-level/business/aqa/3/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Business-Paper-3-QP.pdf",
    "a-level/business/aqa/3/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Business-Paper-3-MS.pdf",
    "a-level/chemistry/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74051-QP-JUN23.PDF",
    "a-level/chemistry/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74051-MS-JUN23.PDF",
    "a-level/chemistry/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74052-QP-JUN23.PDF",
    "a-level/chemistry/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74052-MS-JUN23.PDF",
    "a-level/chemistry/aqa/3/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74053-QP-JUN23.PDF",
    "a-level/chemistry/aqa/3/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74053-MS-JUN23.PDF",
    "a-level/chemistry/aqa/1/22-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/7811acee1967d39da0ff3d7694099b2daa3475b0.pdf",
    "a-level/chemistry/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74051-MS-JUN22.PDF",
    "a-level/chemistry/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74052-QP-JUN22.PDF",
    "a-level/chemistry/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74052-MS-JUN22.PDF",
    "a-level/chemistry/aqa/3/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74053-QP-JUN22.PDF",
    "a-level/chemistry/aqa/3/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74053-MS-JUN22.PDF",
    "a-level/chemistry/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74051-QP-NOV21.PDF",
    "a-level/chemistry/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74051-MS-NOV21.PDF",
    "a-level/chemistry/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74052-QP-NOV21.PDF",
    "a-level/chemistry/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74052-MS-NOV21.PDF",
    "a-level/chemistry/aqa/3/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74053-QP-NOV21.PDF",
    "a-level/chemistry/aqa/3/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74053-MS-NOV21.PDF",
    "a-level/chemistry/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74051-QP-NOV20.PDF",
    "a-level/chemistry/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74051-W-MS-NOV20.PDF",
    "a-level/chemistry/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74052-QP-NOV20.PDF",
    "a-level/chemistry/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74052-W-MS-NOV20.PDF",
    "a-level/chemistry/aqa/3/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74053-QP-NOV20.PDF",
    "a-level/chemistry/aqa/3/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74053-W-MS-NOV20.PDF",
    "a-level/chemistry/aqa/1/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74051-QP-JUN19.PDF",
    "a-level/chemistry/aqa/1/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74051-W-MS-JUN19.PDF",
    "a-level/chemistry/aqa/2/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74052-QP-JUN19.PDF",
    "a-level/chemistry/aqa/2/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74052-W-MS-JUN19.PDF",
    "a-level/chemistry/aqa/3/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74053-QP-JUN19.PDF",
    "a-level/chemistry/aqa/3/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74053-W-MS-JUN19.PDF",
    "a-level/chemistry/aqa/1/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74051-QP-JUN18.PDF",
    "a-level/chemistry/aqa/1/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74051-W-MS-JUN18.PDF",
    "a-level/chemistry/aqa/2/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74052-QP-JUN18.PDF",
    "a-level/chemistry/aqa/2/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74052-W-MS-JUN18.PDF",
    "a-level/chemistry/aqa/3/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74053-QP-JUN18.PDF",
    "a-level/chemistry/aqa/3/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74053-W-MS-JUN18.PDF",
    "a-level/chemistry/aqa/1/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74051-QP-JUN17.PDF",
    "a-level/chemistry/aqa/1/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74051-W-MS-JUN17.PDF",
    "a-level/chemistry/aqa/2/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74052-QP-JUN17.PDF",
    "a-level/chemistry/aqa/2/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74052-W-MS-JUN17.PDF",
    "a-level/chemistry/aqa/3/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74053-QP-JUN17.PDF",
    "a-level/chemistry/aqa/3/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74053-W-MS-JUN17.PDF",

    "a-level/compsci/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/computing/AQA-75171-SQP.PDF",
    "a-level/compsci/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/computing/AQA-75171-SMS.PDF",
    "a-level/compsci/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/computing/AQA-75172-SQP.PDF",
    "a-level/compsci/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/computing/AQA-75172-SMS.PDF",
    "a-level/compsci/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-75171-QP-JUN23-CR.PDF",
    "a-level/compsci/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-75171-MS-JUN23.PDF",
    "a-level/compsci/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-75172-QP-JUN23.PDF",
    "a-level/compsci/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-75172-MS-JUN23.PDF",
    "a-level/compsci/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-75171-QP-JUN22.PDF",
    "a-level/compsci/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-75171-MS-JUN22.PDF",
    "a-level/compsci/aqa//po-exa/ins.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-75172-WRE-NOV20.PDF",
    "a-level/compsci/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-75172-QP-JUN22.PDF",
    "a-level/compsci/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-75172-MS-JUN22.PDF",
    "a-level/compsci/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-75171-QP-NOV21.PDF",
    "a-level/compsci/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-75171-MS-NOV21.PDF",
    "a-level/compsci/aqa//undefined-ins/ins.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-75171-INS-NOV21.PDF",
    "a-level/compsci/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-75172-QP-NOV21.PDF",
    "a-level/compsci/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-75172-MS-NOV21.PDF",
    "a-level/compsci/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-75171-QP-NOV20.PDF",
    "a-level/compsci/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-75171-W-MS-NOV20.PDF",
    "a-level/compsci/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-75172-QP-NOV20.PDF",
    "a-level/compsci/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-75172-W-MS-NOV20.PDF",
    "a-level/economics/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71361-QP-JUN23.PDF",
    "a-level/economics/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71361-MS-JUN23.PDF",
    "a-level/economics/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71362-QP-JUN23.PDF",
    "a-level/economics/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71362-MS-JUN23.PDF",
    "a-level/economics/aqa/3/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71363-QP-JUN23.PDF",
    "a-level/economics/aqa/3/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71363-MS-JUN23.PDF",
    "a-level/economics/aqa//undefined-ins/ins.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71363-INS-NOV20-CR.PDF",
    "a-level/economics/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71361-QP-JUN22.PDF",
    "a-level/economics/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71361-MS-NOV21.PDF",
    "a-level/economics/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71362-QP-JUN22-CR.PDF",
    "a-level/economics/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71362-MS-JUN22.PDF",
    "a-level/economics/aqa/3/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71363-QP-JUN22.PDF",
    "a-level/economics/aqa/3/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71363-MS-JUN22.PDF",
    "a-level/economics/aqa/1/21-nov/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/09/AQA-A-Level-Economics-November-2021-Paper-1.pdf",
    "a-level/economics/aqa/1/21-nov/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/09/AQA-A-Level-Economics-November-2021-Paper-1-MS.pdf",
    "a-level/economics/aqa/2/21-nov/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/09/AQA-A-Level-Economics-November-2021-Paper-2.pdf",
    "a-level/economics/aqa/2/21-nov/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/09/AQA-A-Level-Economics-November-2021-Paper-2-MS.pdf",
    "a-level/economics/aqa/3/21-nov/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/09/AQA-A-Level-Economics-November-2021-Paper-3.pdf",
    "a-level/economics/aqa/3/21-nov/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/09/AQA-A-Level-Economics-November-2021-Paper-3-MS.pdf",
    "a-level/economics/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71361-QP-NOV21.PDF",
    "a-level/economics/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71361-MS-NOV21.PDF",
    "a-level/economics/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71362-QP-NOV21.PDF",
    "a-level/economics/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71362-MS-NOV21.PDF",
    "a-level/economics/aqa/3/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71363-QP-NOV21.PDF",
    "a-level/economics/aqa/3/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71363-MS-NOV21.PDF",
    "a-level/economics/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71361-QP-NOV20.PDF",
    "a-level/economics/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71361-W-MS-NOV20.PDF",
    "a-level/economics/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71362-QP-NOV20.PDF",
    "a-level/economics/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71362-W-MS-NOV20.PDF",
    "a-level/economics/aqa/3/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71363-QP-NOV20.PDF",
    "a-level/economics/aqa/3/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71363-W-MS-NOV20.PDF",
    "a-level/economics/aqa/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Economics-Paper-1-QP.pdf",
    "a-level/economics/aqa/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Economics-Paper-1-MS.pdf",
    "a-level/economics/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Economics-Paper-2-QP.pdf",
    "a-level/economics/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Economics-Paper-2-MS.pdf",
    "a-level/economics/aqa/3/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Economics-Paper-3-QP.pdf",
    "a-level/economics/aqa/3/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Economics-Paper-3-MS.pdf",
    "a-level/economics/aqa/1/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Economics-Paper-1-QP.pdf",
    "a-level/economics/aqa/1/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Economics-Paper-1-MS-1.pdf",
    "a-level/economics/aqa/2/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Economics-Paper-2-QP.pdf",
    "a-level/economics/aqa/2/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Economics-Paper-2-MS.pdf",
    "a-level/economics/aqa/3/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Economics-Paper-3-QP.pdf",
    "a-level/economics/aqa/3/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2018-Economics-Paper-3-MS.pdf",
    "a-level/economics/aqa/1/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Economics-Paper-1-QP.pdf",
    "a-level/economics/aqa/1/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Economics-Paper-1-MS.pdf",
    "a-level/economics/aqa/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Economics-Paper-2-QP.pdf",
    "a-level/economics/aqa/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Economics-Paper-2-MS.pdf",
    "a-level/economics/aqa/3/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Economics-Paper-3-QP.pdf",
    "a-level/economics/aqa/3/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2017-Economics-Paper-3-MS.pdf",
    "a-level/english-lang/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/english/AQA-77021-SQP.PDF",
    "a-level/english-lang/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/english/AQA-77021-SMS.PDF",
    "a-level/english-lang/aqa//undefined-ins/ins.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77022-INS-JUN17.pdf",
    "a-level/english-lang/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/english/AQA-77022-SQP.PDF",
    "a-level/english-lang/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/english/AQA-77022-SMS.PDF",
    "a-level/english-lang/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-77021-QP-JUN23.PDF",
    "a-level/english-lang/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-77021-MS-JUN23.PDF",
    "a-level/english-lang/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-77022-QP-JUN23.PDF",
    "a-level/english-lang/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-77022-MS-JUN23.PDF",
    "a-level/english-lang/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77021-QP-JUN22.PDF",
    "a-level/english-lang/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77021-MS-JUN22.PDF",
    "a-level/english-lang/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77022-QP-JUN22.PDF",
    "a-level/english-lang/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77022-MS-JUN22.PDF",
    "a-level/english-lang/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77021-QP-NOV21.PDF",
    "a-level/english-lang/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77021-MS-NOV21.PDF",
    "a-level/english-lang/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77022-QP-NOV21.PDF",
    "a-level/english-lang/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77022-MS-NOV21.PDF",
    "a-level/english-lang/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77021-QP-NOV20.PDF",
    "a-level/english-lang/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77021-W-MS-NOV20.PDF",
    "a-level/english-lang/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77022-QP-NOV20.PDF",
    "a-level/english-lang/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77022-W-MS-NOV20.PDF",
    "a-level/english-lang/aqa/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Language-Paper-1-QP.pdf",
    "a-level/english-lang/aqa/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Language-Paper-1-MS.pdf",
    "a-level/english-lang/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Language-Paper-2-QP.pdf",
    "a-level/english-lang/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Language-Paper-2-MS.pdf",
    "a-level/english-lang/aqa/1/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77021-QP-JUN17.pdf",
    "a-level/english-lang/aqa/1/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77021-W-MS-JUN17.pdf",
    "a-level/english-lang/aqa/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77022-QP-JUN17.pdf",
    "a-level/english-lang/aqa/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77022-W-MS-JUN17.pdf",
    "a-level/english-lit/aqa-a/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77121-QP-JUN22.PDF",
    "a-level/english-lit/aqa-a/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77121-MS-JUN22.PDF",
    "a-level/english-lit/aqa-a/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77122B-QP-JUN22.PDF",
    "a-level/english-lit/aqa-a/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77122B-MS-JUN22.PDF",
    "a-level/english-lit/aqa-a//undefined-ins/ins.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77122B-INS-JUN17.pdf",
    "a-level/english-lit/aqa-a/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77121-QP-NOV21-CR.PDF",
    "a-level/english-lit/aqa-a/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77121-MS-NOV21.PDF",
    "a-level/english-lit/aqa-a/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77122B-QP-NOV21.PDF",
    "a-level/english-lit/aqa-a/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77122B-MS-NOV21.PDF",
    "a-level/english-lit/aqa-a/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77121-QP-NOV20.PDF",
    "a-level/english-lit/aqa-a/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77121-W-MS-NOV20.PDF",
    "a-level/english-lit/aqa-a/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77122B-QP-NOV20.PDF",
    "a-level/english-lit/aqa-a/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77122B-W-MS-NOV20.PDF",
    "a-level/english-lit/aqa-a/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Literature-Paper-1-QP.pdf",
    "a-level/english-lit/aqa-a/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Literature-Paper-1-MS.pdf",
    "a-level/english-lit/aqa-a/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Literature-Paper-2A-QP.pdf",
    "a-level/english-lit/aqa-a/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Literature-Paper-2A-MS.pdf",
    "a-level/english-lit/aqa-a/1/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUNE2018-English-Literature-A-Paper-1-QP.pdf",
    "a-level/english-lit/aqa-a/1/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUNE2018-English-Literature-A-Paper-1-MS.pdf",
    "a-level/english-lit/aqa-a/2/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUNE2018-English-Literature-A-Paper-2B-QP.pdf",
    "a-level/english-lit/aqa-a/2/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUNE2018-English-Literature-A-Paper-2B-MS.pdf",
    "a-level/english-lit/aqa-a/1/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77121-QP-JUN17.pdf",
    "a-level/english-lit/aqa-a/1/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77121-W-MS-JUN17.pdf",
    "a-level/english-lit/aqa-a/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77122B-QP-JUN17.pdf",
    "a-level/english-lit/aqa-a/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77122B-W-MS-JUN17.pdf",
    "a-level/english-lit/aqa-b/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77171B-QP-JUN22.PDF",
    "a-level/english-lit/aqa-b/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77171B-MS-JUN22.PDF",
    "a-level/english-lit/aqa-b/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77172B-QP-JUN22.PDF",
    "a-level/english-lit/aqa-b/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77172B-MS-JUN22.PDF",
    "a-level/english-lit/aqa-b/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77171B-QP-NOV21.PDF",
    "a-level/english-lit/aqa-b/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77171B-MS-NOV21.PDF",
    "a-level/english-lit/aqa-b/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77172B-QP-NOV21.PDF",
    "a-level/english-lit/aqa-b/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-77172B-MS-NOV21.PDF",
    "a-level/english-lit/aqa-b/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77171B-QP-NOV20.PDF",
    "a-level/english-lit/aqa-b/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77171B-W-MS-NOV20.PDF",
    "a-level/english-lit/aqa-b/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77172B-QP-NOV20.PDF",
    "a-level/english-lit/aqa-b/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77172B-W-MS-NOV20.PDF",
    "a-level/english-lit/aqa-b/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Literature-B-Paper-1B-QP.pdf",
    "a-level/english-lit/aqa-b/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Literature-B-Paper-1B-MS.pdf",
    "a-level/english-lit/aqa-b/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Literature-B-Paper-2B-QP.pdf",
    "a-level/english-lit/aqa-b/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-English-Literature-B-Paper-2B-MS.pdf",
    "a-level/english-lit/aqa-b/1/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUNE2018-English-Literature-B-Paper-1B-QP.pdf",
    "a-level/english-lit/aqa-b/1/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUNE2018-English-Literature-B-Paper-1B-MS.pdf",
    "a-level/english-lit/aqa-b/2/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUNE2018-English-Literature-B-Paper-2B-QP.pdf",
    "a-level/english-lit/aqa-b/2/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUNE2018-English-Literature-B-Paper-2B-MS.pdf",
    "a-level/english-lit/aqa-b/1/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77171B-QP-JUN17.pdf",
    "a-level/english-lit/aqa-b/1/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77171B-W-MS-JUN17.pdf",
    "a-level/english-lit/aqa-b/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77172B-QP-JUN17.pdf",
    "a-level/english-lit/aqa-b/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77172B-W-MS-JUN17.pdf",
    "a-level/geography/aqa/1/18-spec/qp.PDF":
      "https://pastpapers.co/aqa/A-Level/Geography-7037/AQA-70371-SQP.pdf",
    "a-level/geography/aqa/1/18-spec/ms.PDF":
      "https://pastpapers.co/aqa/A-Level/Geography-7037/AQA-70371-SMS.pdf",
    "a-level/geography/aqa/2/18-spec/qp.PDF":
      "https://pastpapers.co/aqa/A-Level/Geography-7037/AQA-70372-SQP.pdf",
    "a-level/geography/aqa/2/18-spec/ms.PDF":
      "https://pastpapers.co/aqa/A-Level/Geography-7037/AQA-70372-SMS.pdf",
    "a-level/geography/aqa/1/23-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/6e2a25ac1ef71816b11353fd2132e2e6b97b1a21.pdf",
    "a-level/geography/aqa/1/23-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/dd3c9e9990521228890d5fd9e0cc9dc11e867884.pdf",
    "a-level/geography/aqa/2/23-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/6085aa71b970cc10ceb391e67b0170f7e7fec862.pdf",
    "a-level/geography/aqa/2/23-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/a4d02ff7651ca13355d6b916bb0275dabd4ebbf9.pdf",
    "a-level/geography/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70371-QP-JUN22.PDF",
    "a-level/geography/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70371-MS-JUN22.PDF",
    "a-level/geography/aqa//undefined-ins/ins.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70372-INS-NOV20-CR.PDF",
    "a-level/geography/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70372-QP-JUN22.PDF",
    "a-level/geography/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70372-MS-JUN22.PDF",
    "a-level/geography/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-70371-QP-NOV21.PDF",
    "a-level/geography/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-70371-MS-NOV21.PDF",
    "a-level/geography/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-70372-QP-NOV21-CR.PDF",
    "a-level/geography/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-70372-MS-NOV21.PDF",
    "a-level/geography/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70371-QP-NOV20.PDF",
    "a-level/geography/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70371-W-MS-NOV20.PDF",
    "a-level/geography/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70372-QP-NOV20.PDF",
    "a-level/geography/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70372-W-MS-NOV20.PDF",
    "a-level/law/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/law/AQA-71621-SQP.PDF",
    "a-level/law/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/law/AQA-71621-SMS.PDF",
    "a-level/law/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/law/AQA-71622-SQP.PDF",
    "a-level/law/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/law/AQA-71622-SMS.PDF",
    "a-level/law/aqa/3/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/law/AQA-71623H-SQP.PDF",
    "a-level/law/aqa/3/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/law/AQA-71623H-SMS.PDF",
    "a-level/law/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71621-QP-JUN22.PDF",
    "a-level/law/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71621-MS-JUN22.PDF",
    "a-level/law/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71622-QP-JUN22.PDF",
    "a-level/law/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71622-MS-JUN22.PDF",
    "a-level/law/aqa/3/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71623B-QP-JUN22.PDF",
    "a-level/law/aqa/3/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71623B-MS-JUN22.PDF",
    "a-level/law/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71621-QP-NOV21.PDF",
    "a-level/law/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71621-MS-NOV21.PDF",
    "a-level/law/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71622-QP-NOV21.PDF",
    "a-level/law/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71622-MS-NOV21.PDF",
    "a-level/law/aqa/3/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71623B-QP-NOV21.PDF",
    "a-level/law/aqa/3/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71623B-MS-NOV21.PDF",
    "a-level/law/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71621-QP-NOV20.PDF",
    "a-level/law/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71621-W-MS-NOV20.PDF",
    "a-level/law/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71622-QP-NOV20.PDF",
    "a-level/law/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71622-W-MS-NOV20.PDF",
    "a-level/law/aqa/3/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71623B-QP-NOV20.PDF",
    "a-level/law/aqa/3/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71623B-W-MS-NOV20.PDF",
    "a-level/pe/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-75821-QP-JUN22.PDF",
    "a-level/pe/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-75821-MS-JUN22.PDF",
    "a-level/pe/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-75822-QP-JUN22.PDF",
    "a-level/pe/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-75822-MS-JUN22.PDF",
    "a-level/pe/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-75821-QP-NOV21.PDF",
    "a-level/pe/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-75821-MS-NOV21.PDF",
    "a-level/pe/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-75822-QP-NOV21.PDF",
    "a-level/pe/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-75822-MS-NOV21.PDF",
    "a-level/pe/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-75821-QP-NOV20.PDF",
    "a-level/pe/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-75821-W-MS-NOV20.PDF",
    "a-level/pe/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-75822-QP-NOV20.PDF",
    "a-level/pe/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-75822-W-MS-NOV20.PDF",
    "a-level/pe/aqa/1/19-jun/qp.PDF":
      "https://pastpapers.co/aqa/A-Level/Physical%20Education-7582/AQA-75821-QP-JUN19.pdf",
    "a-level/pe/aqa/1/19-jun/ms.PDF":
      "https://pastpapers.co/aqa/A-Level/Physical%20Education-7582/AQA-75821-W-MS-JUN19.pdf",
    "a-level/pe/aqa/2/19-jun/qp.PDF":
      "https://pastpapers.co/aqa/A-Level/Physical%20Education-7582/AQA-75822-QP-JUN19.pdf",
    "a-level/pe/aqa/2/19-jun/ms.PDF":
      "https://pastpapers.co/aqa/A-Level/Physical%20Education-7582/AQA-75822-W-MS-JUN19.pdf",
    "a-level/pe/aqa/1/18-jun/qp.PDF":
      "https://pastpapers.co/aqa/A-Level/Physical%20Education-7582/AQA-75821-QP-JUN18.pdf",
    "a-level/pe/aqa/1/18-jun/ms.PDF":
      "https://pastpapers.co/aqa/A-Level/Physical%20Education-7582/AQA-75821-W-MS-JUN18.pdf",
    "a-level/pe/aqa/2/18-jun/qp.PDF":
      "https://pastpapers.co/aqa/A-Level/Physical%20Education-7582/AQA-75822-QP-JUN18.pdf",
    "a-level/pe/aqa/2/18-jun/ms.PDF":
      "https://pastpapers.co/aqa/A-Level/Physical%20Education-7582/AQA-75822-W-MS-JUN18.pdf",
    "a-level/philosophy/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/philosophy/AQA-71721-SQP.PDF",
    "a-level/philosophy/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/philosophy/AQA-71721-SMS.PDF",
    "a-level/philosophy/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/philosophy/AQA-71722-SQP.PDF",
    "a-level/philosophy/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/philosophy/AQA-71722-SMS.PDF",
    "a-level/philosophy/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71721-QP-JUN22.PDF",
    "a-level/philosophy/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71721-MS-JUN22.PDF",
    "a-level/philosophy/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71722-QP-JUN22.PDF",
    "a-level/philosophy/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71722-MS-JUN22.PDF",
    "a-level/philosophy/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71721-QP-NOV21.PDF",
    "a-level/philosophy/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71721-MS-NOV21.PDF",
    "a-level/philosophy/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71722-QP-NOV21.PDF",
    "a-level/philosophy/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71722-MS-NOV21.PDF",
    "a-level/philosophy/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71721-QP-NOV20.PDF",
    "a-level/philosophy/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71721-W-MS-NOV20.PDF",
    "a-level/philosophy/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71722-QP-NOV20.PDF",
    "a-level/philosophy/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71722-W-MS-NOV20.PDF",
    "a-level/physics/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74081-QP-JUN23.PDF",
    "a-level/physics/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74081-MS-JUN23.PDF",
    "a-level/physics/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74082-QP-JUN23.PDF",
    "a-level/physics/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74082-MS-JUN23.PDF",
    "a-level/physics/aqa/3/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74083A-QP-JUN23.PDF",
    "a-level/physics/aqa/3/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74083A-MS-JUN23.PDF",
    "a-level/physics/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74081-QP-JUN22.PDF",
    "a-level/physics/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74081-MS-JUN22.PDF",
    "a-level/physics/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74082-QP-JUN22.PDF",
    "a-level/physics/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74082-MS-JUN22.PDF",
    "a-level/physics/aqa/3/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74083A-QP-JUN22.PDF",
    "a-level/physics/aqa/3/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74083A-MS-JUN22.PDF",
    "a-level/physics/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74081-QP-NOV21.PDF",
    "a-level/physics/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74081-MS-NOV21.PDF",
    "a-level/physics/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74082-QP-NOV21.PDF",
    "a-level/physics/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74082-MS-NOV21.PDF",
    "a-level/physics/aqa/3/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74083A-QP-NOV21.PDF",
    "a-level/physics/aqa/3/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74083A-MS-NOV21.PDF",
    "a-level/physics/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74081-QP-NOV20.PDF",
    "a-level/physics/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74081-W-MS-NOV20.PDF",
    "a-level/physics/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74082-QP-NOV20.PDF",
    "a-level/physics/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74082-W-MS-NOV20.PDF",
    "a-level/physics/aqa/3/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74083A-QP-NOV20.PDF",
    "a-level/physics/aqa/3/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74083A-W-MS-NOV20.PDF",
    "a-level/physics/aqa/1/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74081-QP-JUN19.PDF",
    "a-level/physics/aqa/1/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74081-W-MS-JUN19.PDF",
    "a-level/physics/aqa/2/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74082-QP-JUN19.PDF",
    "a-level/physics/aqa/2/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74082-W-MS-JUN19.PDF",
    "a-level/physics/aqa/3/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74083A-QP-JUN19.PDF",
    "a-level/physics/aqa/3/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74083A-W-MS-JUN19.PDF",
    "a-level/physics/aqa/1/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74081-QP-JUN18.PDF",
    "a-level/physics/aqa/1/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74081-W-MS-JUN18.PDF",
    "a-level/physics/aqa/2/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74082-QP-JUN18.PDF",
    "a-level/physics/aqa/2/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74082-W-MS-JUN18.PDF",
    "a-level/physics/aqa/3/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74083A-QP-JUN18.PDF",
    "a-level/physics/aqa/3/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74083A-W-MS-JUN18.PDF",
    "a-level/politics/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/politics/AQA-71521-SQP-CR.PDF",
    "a-level/politics/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/politics/AQA-71522-SQP-CR.PDF",
    "a-level/politics/aqa/3/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/politics/AQA-71523-SQP-CR.PDF",
    "a-level/politics/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71521-QP-JUN23.PDF",
    "a-level/politics/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71521-MS-JUN23.PDF",
    "a-level/politics/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71522-QP-JUN23-CR.PDF",
    "a-level/politics/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71522-MS-JUN23.PDF",
    "a-level/politics/aqa/3/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71523-QP-JUN23.PDF",
    "a-level/politics/aqa/3/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71523-MS-JUN23.PDF",
    "a-level/politics/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71521-QP-JUN22.PDF",
    "a-level/politics/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71521-MS-JUN22.PDF",
    "a-level/politics/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71522-QP-JUN22-CR.PDF",
    "a-level/politics/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71522-MS-JUN22.PDF",
    "a-level/politics/aqa/3/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71523-QP-JUN22.PDF",
    "a-level/politics/aqa/3/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71523-MS-JUN22.PDF",
    "a-level/politics/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71521-QP-NOV21.PDF",
    "a-level/politics/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71521-MS-NOV21.PDF",
    "a-level/politics/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71522-QP-NOV21.PDF",
    "a-level/politics/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71522-MS-NOV21.PDF",
    "a-level/politics/aqa/3/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71523-QP-NOV21.PDF",
    "a-level/politics/aqa/3/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71523-MS-NOV21.PDF",
    "a-level/politics/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71521-QP-NOV20.PDF",
    "a-level/politics/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71521-W-MS-NOV20.PDF",
    "a-level/politics/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71522-QP-NOV20.PDF",
    "a-level/politics/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71522-W-MS-NOV20.PDF",
    "a-level/politics/aqa/3/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71523-QP-NOV20.PDF",
    "a-level/politics/aqa/3/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71523-W-MS-NOV20.PDF",
    "a-level/politics/aqa/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Politics-Paper-1-QP.pdf",
    "a-level/politics/aqa/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Politics-Paper-1-MS.pdf",
    "a-level/politics/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Politics-Paper-2-QP.pdf",
    "a-level/politics/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Politics-Paper-2-MS.pdf",
    "a-level/politics/aqa/3/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Politics-Paper-3-QP.pdf",
    "a-level/politics/aqa/3/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-A-Level-JUN2019-Politics-Paper-3-MS.pdf",
    "a-level/psychology/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71821-QP-JUN23.PDF",
    "a-level/psychology/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71821-MS-JUN23.PDF",
    "a-level/psychology/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71822-QP-JUN23.PDF",
    "a-level/psychology/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71822-MS-JUN23.PDF",
    "a-level/psychology/aqa/3/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71823-QP-JUN23.PDF",
    "a-level/psychology/aqa/3/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71823-MS-JUN23.PDF",
    "a-level/psychology/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71821-QP-JUN22.PDF",
    "a-level/psychology/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71821-MS-JUN22.PDF",
    "a-level/psychology/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71822-QP-JUN22.PDF",
    "a-level/psychology/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71822-MS-JUN22.PDF",
    "a-level/psychology/aqa/3/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71823-QP-JUN22.PDF",
    "a-level/psychology/aqa/3/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71823-MS-JUN22.PDF",
    "a-level/psychology/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71821-QP-NOV21.PDF",
    "a-level/psychology/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71821-MS-NOV21.PDF",
    "a-level/psychology/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71822-QP-NOV21.PDF",
    "a-level/psychology/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71822-MS-NOV21.PDF",
    "a-level/psychology/aqa/3/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71823-QP-NOV21.PDF",
    "a-level/psychology/aqa/3/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71823-MS-NOV21.PDF",
    "a-level/psychology/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71821-QP-NOV20.PDF",
    "a-level/psychology/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71821-W-MS-NOV20.PDF",
    "a-level/psychology/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71822-QP-NOV20.PDF",
    "a-level/psychology/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71822-W-MS-NOV20.PDF",
    "a-level/psychology/aqa/3/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71823-QP-NOV20.PDF",
    "a-level/psychology/aqa/3/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71823-W-MS-NOV20.PDF",
    "a-level/psychology/aqa/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-Psychology-Paper-1-QP.pdf",
    "a-level/psychology/aqa/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-Psychology-Paper-1-MS.pdf",
    "a-level/psychology/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-Psychology-Paper-2-QP.pdf",
    "a-level/psychology/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-Psychology-Paper-2-MS.pdf",
    "a-level/psychology/aqa/3/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-Psychology-Paper-3-QP.pdf",
    "a-level/psychology/aqa/3/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-A-Level-Psychology-Paper-3-MS.pdf",
    "a-level/psychology/aqa/1/18-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71821-QP-JUN18.pdf",
    "a-level/psychology/aqa/1/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71821-W-MS-JUN18.pdf",
    "a-level/psychology/aqa/2/18-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71822-QP-JUN18.pdf",
    "a-level/psychology/aqa/2/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71822-W-MS-JUN18.pdf",
    "a-level/psychology/aqa/3/18-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71823-QP-JUN18.pdf",
    "a-level/psychology/aqa/3/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71823-W-MS-JUN18.pdf",
    "a-level/rs/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-70621-SQP.PDF",
    "a-level/rs/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-70621-SMS.PDF",
    "a-level/rs/aqa/2/:-pap/qp.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-70622E-SQP.PDF",
    "a-level/rs/aqa/2/:-pap/ms.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-70622E-SMS.PDF",
    "a-level/rs/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70621-QP-JUN22.PDF",
    "a-level/rs/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70621-MS-JUN22.PDF",
    "a-level/rs/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70622E-QP-JUN22.PDF",
    "a-level/rs/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70622E-MS-JUN22.PDF",
    "a-level/rs/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-70621-QP-NOV21.PDF",
    "a-level/rs/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-70621-MS-NOV21.PDF",
    "a-level/rs/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-70622E-QP-NOV21-BK.PDF",
    "a-level/rs/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-70622E-MS-NOV21-BK.PDF",
    "a-level/rs/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70621-QP-NOV20.PDF",
    "a-level/rs/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70621-W-MS-NOV20.PDF",
    "a-level/rs/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70622E-QP-NOV20-BK.PDF",
    "a-level/rs/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70622E-MS-NOV20-BK.PDF",
    "a-level/rs/aqa/1/19-jun/qp.PDF":
      "https://pastpapers.co/aqa/A-Level/Religious%20Studies-7062/AQA-70621-QP-JUN19.pdf",
    "a-level/rs/aqa/1/19-jun/ms.PDF":
      "https://pastpapers.co/aqa/A-Level/Religious%20Studies-7062/AQA-70621-W-MS-JUN19.pdf",
    "a-level/rs/aqa/2/19-jun/qp.PDF":
      "https://pastpapers.co/aqa/A-Level/Religious%20Studies-7062/AQA-70622E-QP-JUN19.pdf",
    "a-level/rs/aqa/2/19-jun/ms.PDF":
      "https://pastpapers.co/aqa/A-Level/Religious%20Studies-7062/AQA-70622E-W-MS-JUN19.pdf",
    "a-level/rs/aqa/1/18-jun/qp.PDF":
      "https://pastpapers.co/aqa/A-Level/Religious%20Studies-7062/AQA-70621-QP-JUN18.pdf",
    "a-level/rs/aqa/1/18-jun/ms.PDF":
      "https://pastpapers.co/aqa/A-Level/Religious%20Studies-7062/AQA-70621-W-MS-JUN18.pdf",
    "a-level/rs/aqa/2/18-jun/qp.PDF":
      "https://pastpapers.co/aqa/A-Level/Religious%20Studies-7062/AQA-70622E-QP-JUN18.pdf",
    "a-level/rs/aqa/2/18-jun/ms.PDF":
      "https://pastpapers.co/aqa/A-Level/Religious%20Studies-7062/AQA-70622E-W-MS-JUN18.pdf",
    "a-level/sociology/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71921-QP-JUN22.PDF",
    "a-level/sociology/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71921-MS-JUN22.PDF",
    "a-level/sociology/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71922-QP-JUN22.PDF",
    "a-level/sociology/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71922-MS-JUN22.PDF",
    "a-level/sociology/aqa/3/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71923-QP-JUN22.PDF",
    "a-level/sociology/aqa/3/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71923-MS-JUN22.PDF",
    "a-level/sociology/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71921-QP-NOV21.PDF",
    "a-level/sociology/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71921-MS-NOV21.PDF",
    "a-level/sociology/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71922-QP-NOV21.PDF",
    "a-level/sociology/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71922-MS-NOV21.PDF",
    "a-level/sociology/aqa/3/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71923-QP-NOV21.PDF",
    "a-level/sociology/aqa/3/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-71923-MS-NOV21.PDF",
    "a-level/sociology/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71921-QP-NOV20.PDF",
    "a-level/sociology/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71921-W-MS-NOV20.PDF",
    "a-level/sociology/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71922-QP-NOV20.PDF",
    "a-level/sociology/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71922-W-MS-NOV20.PDF",
    "a-level/sociology/aqa/3/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71923-QP-NOV20.PDF",
    "a-level/sociology/aqa/3/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71923-W-MS-NOV20.PDF",
    "a-level/sociology/aqa/1/18-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71921-QP-JUN18.pdf",
    "a-level/sociology/aqa/1/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71921-W-MS-JUN18.pdf",
    "a-level/sociology/aqa/2/18-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71922-QP-JUN18.pdf",
    "a-level/sociology/aqa/2/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71922-W-MS-JUN18.pdf",
    "a-level/sociology/aqa/3/18-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71923R-QP-JUN18.pdf",
    "a-level/sociology/aqa/3/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71923R-W-MS-JUN18.pdf",
    "a-level/sociology/aqa/1/17-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71921-QP-JUN17.pdf",
    "a-level/sociology/aqa/1/17-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71921-W-MS-JUN17.pdf",
    "a-level/sociology/aqa/2/17-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71922-QP-JUN17.pdf",
    "a-level/sociology/aqa/2/17-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71922-W-MS-JUN17.pdf",
    "a-level/sociology/aqa/3/17-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71923-QP-JUN17.pdf",
    "a-level/sociology/aqa/3/17-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71923-W-MS-JUN17.pdf",
    "as/biology/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74011-QP-JUN23.PDF",
    "as/biology/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74011-MS-JUN23.PDF",
    "as/biology/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74012-QP-JUN23.PDF",
    "as/biology/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74012-MS-JUN23.PDF",
    "as/biology/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74011-QP-JUN22.PDF",
    "as/biology/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74011-MS-JUN22.PDF",
    "as/biology/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74012-QP-JUN22.PDF",
    "as/biology/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74012-MS-JUN22.PDF",
    "as/biology/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74011-QP-NOV21.PDF",
    "as/biology/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74011-MS-NOV21.PDF",
    "as/biology/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74012-QP-NOV21.PDF",
    "as/biology/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74012-MS-NOV21.PDF",
    "as/biology/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74011-QP-NOV20-CR.PDF",
    "as/biology/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74011-W-MS-NOV20.PDF",
    "as/biology/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74012-QP-NOV20.PDF",
    "as/biology/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74012-W-MS-NOV20.PDF",
    "as/biology/aqa/2/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74012-QP-JUN19.PDF",
    "as/biology/aqa/2/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74012-W-MS-JUN19.PDF",
    "as/biology/aqa/1/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74011-QP-JUN17.PDF",
    "as/biology/aqa/1/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74011-W-MS-JUN17.PDF",
    "as/biology/aqa/2/16-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2016/june/AQA-74012-QP-JUN16.PDF",
    "as/biology/aqa/2/16-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2016/june/AQA-74012-W-MS-JUN16.PDF",
    "as/business/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71311-QP-JUN22.PDF",
    "as/business/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71311-MS-JUN22.PDF",
    "as/business/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71312-QP-JUN22.PDF",
    "as/business/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71312-MS-JUN22.PDF",
    "as/business/aqa//undefined-ins/ins.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2017-Business-Paper-2-In.pdf",
    "as/business/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71311-QP-NOV20.PDF",
    "as/business/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71311-W-MS-NOV20.PDF",
    "as/business/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71312-QP-NOV20.PDF",
    "as/business/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71312-W-MS-NOV20.PDF",
    "as/business/aqa/1/19-may/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2019-Business-Paper-1-QP.pdf",
    "as/business/aqa/1/19-may/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2019-Business-Paper-1-MS.pdf",
    "as/business/aqa/2/19-may/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2019-Business-Paper-2-QP.pdf",
    "as/business/aqa/2/19-may/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2019-Business-Paper-2-MS.pdf",
    "as/business/aqa/1/18-may/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2018-Business-Paper-1-QP.pdf",
    "as/business/aqa/1/18-may/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2018-Business-Paper-1-MS.pdf",
    "as/business/aqa/2/18-may/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2018-Business-Paper-2-QP.pdf",
    "as/business/aqa/2/18-may/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2018-Business-Paper-2-MS.pdf",
    "as/business/aqa/1/17-may/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2017-Business-Paper-1-QP.pdf",
    "as/business/aqa/1/17-may/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2017-Business-Paper-1-MS.pdf",
    "as/business/aqa/2/17-may/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2017-Business-Paper-2-QP.pdf",
    "as/business/aqa/2/17-may/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2017-Business-Paper-2-MS.pdf",
    "as/chemistry/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74041-QP-JUN23.PDF",
    "as/chemistry/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74041-MS-JUN23.PDF",
    "as/chemistry/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74042-QP-JUN23.PDF",
    "as/chemistry/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74042-MS-JUN23.PDF",
    "as/chemistry/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74041-QP-JUN22.PDF",
    "as/chemistry/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74041-MS-JUN22.PDF",
    "as/chemistry/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74042-QP-JUN22.PDF",
    "as/chemistry/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74042-MS-JUN22.PDF",
    "as/chemistry/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74041-QP-NOV21.PDF",
    "as/chemistry/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74041-MS-NOV21.PDF",
    "as/chemistry/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74042-QP-NOV21.PDF",
    "as/chemistry/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74042-MS-NOV21.PDF",
    "as/chemistry/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74041-QP-NOV20.PDF",
    "as/chemistry/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74041-W-MS-NOV20.PDF",
    "as/chemistry/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74042-QP-NOV20.PDF",
    "as/chemistry/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74042-W-MS-NOV20.PDF",
    "as/chemistry/aqa/1/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74041-QP-JUN19.PDF",
    "as/chemistry/aqa/1/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74041-W-MS-JUN19.PDF",
    "as/chemistry/aqa/2/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74042-QP-JUN19.PDF",
    "as/chemistry/aqa/2/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74042-W-MS-JUN19.PDF",
    "as/chemistry/aqa/1/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74041-QP-JUN18.PDF",
    "as/chemistry/aqa/1/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74041-W-MS-JUN18.PDF",
    "as/chemistry/aqa/2/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74042-QP-JUN18.PDF",
    "as/chemistry/aqa/2/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74042-W-MS-JUN18.PDF",
    "as/chemistry/aqa/1/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74041-QP-JUN17.PDF",
    "as/chemistry/aqa/1/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74041-W-MS-JUN17.PDF",
    "as/chemistry/aqa/2/17-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74042-QP-JUN17.PDF",
    "as/chemistry/aqa/2/17-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2017/june/AQA-74042-W-MS-JUN17.PDF",
    "as/chemistry/aqa/1/16-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2016/june/AQA-74041-QP-JUN16.PDF",
    "as/chemistry/aqa/1/16-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2016/june/AQA-74041-W-MS-JUN16.PDF",
    "as/chemistry/aqa/2/16-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2016/june/AQA-74042-QP-JUN16.PDF",
    "as/chemistry/aqa/2/16-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2016/june/AQA-74042-W-MS-JUN16.PDF",
    "as/economics/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71351-QP-JUN23.PDF",
    "as/economics/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71351-MS-JUN23.PDF",
    "as/economics/aqa//undefined-ins/ins.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71352-INS-NOV20.PDF",
    "as/economics/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71352-QP-JUN23.PDFhttps:/filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71352-QP-JUN23.PDF",
    "as/economics/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71352-MS-JUN23.PDF",
    "as/economics/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71351-QP-JUN22.PDF",
    "as/economics/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71351-MS-JUN22.PDF",
    "as/economics/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71352-QP-JUN22.PDF",
    "as/economics/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71352-MS-JUN22.PDF",
    "as/economics/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71351-QP-NOV20.PDF",
    "as/economics/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71351-W-MS-NOV20.PDF",
    "as/economics/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71352-QP-NOV20.PDF",
    "as/economics/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71352-W-MS-NOV20.PDF",
    "as/economics/aqa/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2019-Economics-Paper-1-QP.pdf",
    "as/economics/aqa/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2019-Economics-Paper-1-MS.pdf",
    "as/economics/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2018-Economics-Paper-2-QP.pdf",
    "as/economics/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2018-Economics-Paper-2-MS.pdf",
    "as/economics/aqa/1/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2018-Economics-Paper-1-QP.pdf",
    "as/economics/aqa/1/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2018-Economics-Paper-1-MS.pdf",
    "as/economics/aqa/2/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2018-Economics-Paper-2-QP.pdf",
    "as/economics/aqa/2/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2018-Economics-Paper-2-MS.pdf",
    "as/economics/aqa/1/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2017-Economics-Paper-1-QP.pdf",
    "as/economics/aqa/1/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2017-Economics-Paper-1-MS.pdf",
    "as/economics/aqa/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2017-Economics-Paper-2-QP.pdf",
    "as/economics/aqa/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-JUN2017-Economics-Paper-2-MS.pdf",
    "as/english-lang/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77011-QP-JUN22.PDF",
    "as/english-lang/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77011-MS-JUN22.PDF",
    "as/english-lang/aqa//undefined-ins/ins.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77011-INS-JUN17.pdf",
    "as/english-lang/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77012-QP-JUN22.PDF",
    "as/english-lang/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77012-MS-JUN22.PDF",
    "as/english-lang/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77011-QP-NOV20.PDF",
    "as/english-lang/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77011-W-MS-NOV20.PDF",
    "as/english-lang/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77012-QP-NOV20.PDF",
    "as/english-lang/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77012-W-MS-NOV20.PDF",
    "as/english-lang/aqa/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Language-Paper-1-QP.pdf",
    "as/english-lang/aqa/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Language-Paper-1-MS.pdf",
    "as/english-lang/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Language-Paper-2-QP.pdf",
    "as/english-lang/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Language-Paper-2-MS.pdf",
    "as/english-lang/aqa/1/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77011-QP-JUN17.pdf",
    "as/english-lang/aqa/1/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77011-W-MS-JUN17.pdf",
    "as/english-lang/aqa/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77012-QP-JUN17.pdf",
    "as/english-lang/aqa/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77012-W-MS-JUN17.pdf",
    "as/english-lit/aqa-a/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77111-QP-JUN22.PDF",
    "as/english-lit/aqa-a/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77111-MS-JUN22.PDF",
    "as/english-lit/aqa-a/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77112-QP-JUN22.PDF",
    "as/english-lit/aqa-a/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-77112-MS-JUN22.PDF",
    "as/english-lit/aqa-a/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77111-QP-NOV20.PDF",
    "as/english-lit/aqa-a/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77111-W-MS-NOV20.PDF",
    "as/english-lit/aqa-a/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77112-QP-NOV20.PDF",
    "as/english-lit/aqa-a/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77112-W-MS-NOV20.PDF",
    "as/english-lit/aqa-a/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Literature-Paper-1-QP.pdf",
    "as/english-lit/aqa-a/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Literature-Paper-1-MS.pdf",
    "as/english-lit/aqa-a/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Literature-Paper-2-QP.pdf",
    "as/english-lit/aqa-a/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Literature-Paper-2-MS.pdf",
    "as/english-lit/aqa-a/1/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-Level-JUNE2018-English-Literature-A-Paper-1-QP.pdf",
    "as/english-lit/aqa-a/1/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-Level-JUNE2018-English-Literature-A-Paper-1-MS.pdf",
    "as/english-lit/aqa-a/2/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-Level-JUNE2018-English-Literature-A-Paper-2-QP.pdf",
    "as/english-lit/aqa-a/2/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-Level-JUNE2018-English-Literature-A-Paper-2-MS.pdf",
    "as/english-lit/aqa-a/1/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77111-QP-JUN17.pdf",
    "as/english-lit/aqa-a/1/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77111-W-MS-JUN17.pdf",
    "as/english-lit/aqa-a/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77112-QP-JUN17.pdf",
    "as/english-lit/aqa-a/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77112-W-MS-JUN17.pdf",
    "as/english-lit/aqa-a/1/16-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77111-QP-JUN16-1.pdf",
    "as/english-lit/aqa-a/1/16-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77111-W-MS-JUN16.pdf",
    "as/english-lit/aqa-a/2/16-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77112-QP-JUN16.pdf",
    "as/english-lit/aqa-a/2/16-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77112-W-MS-JUN16.pdf",
    "as/english-lit/aqa-b/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77161A-QP-NOV20.PDF",
    "as/english-lit/aqa-b/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77161A-W-MS-NOV20.PDF",
    "as/english-lit/aqa-b/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77162A-QP-NOV20.PDF",
    "as/english-lit/aqa-b/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-77162A-W-MS-NOV20.PDF",
    "as/english-lit/aqa-b/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Literature-B-Paper-1B-QP.pdf",
    "as/english-lit/aqa-b/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Literature-B-Paper-1B-MS.pdf",
    "as/english-lit/aqa-b/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Literature-B-Paper-2B-QP.pdf",
    "as/english-lit/aqa-b/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-English-Literature-B-Paper-2B-MS.pdf",
    "as/english-lit/aqa-b/1/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-Level-JUNE2018-English-Literature-B-Paper-1B-QP.pdf",
    "as/english-lit/aqa-b/1/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-Level-JUNE2018-English-Literature-B-Paper-1B-MS.pdf",
    "as/english-lit/aqa-b/2/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-Level-JUNE2018-English-Literature-B-Paper-2B-QP.pdf",
    "as/english-lit/aqa-b/2/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-AS-Level-JUNE2018-English-Literature-B-Paper-2B-MS.pdf",
    "as/english-lit/aqa-b/1/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77161B-QP-JUN17.pdf",
    "as/english-lit/aqa-b/1/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77161B-W-MS-JUN17.pdf",
    "as/english-lit/aqa-b/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77162B-QP-JUN17.pdf",
    "as/english-lit/aqa-b/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77162B-W-MS-JUN17.pdf",
    "as/english-lit/aqa-b/1/16-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77161B-QP-JUN16.pdf",
    "as/english-lit/aqa-b/1/16-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77161B-W-MS-JUN16.pdf",
    "as/english-lit/aqa-b/2/16-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77162B-QP-JUN16.pdf",
    "as/english-lit/aqa-b/2/16-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-77162B-W-MS-JUN16.pdf",
    "as/geography/aqa/1/23-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/6e2a25ac1ef71816b11353fd2132e2e6b97b1a21.pdf",
    "as/geography/aqa/1/23-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/dd3c9e9990521228890d5fd9e0cc9dc11e867884.pdf",
    "as/geography/aqa/2/23-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/6085aa71b970cc10ceb391e67b0170f7e7fec862.pdf",
    "as/geography/aqa/2/23-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/a4d02ff7651ca13355d6b916bb0275dabd4ebbf9.pdf",
    "as/geography/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70361-QP-JUN22.PDF",
    "as/geography/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70361-MS-JUN22.PDF",
    "as/geography/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70362-QP-JUN22.PDF",
    "as/geography/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-70362-MS-JUN22.PDF",
    "as/geography/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70361-QP-NOV20-CR.PDF",
    "as/geography/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70361-W-MS-NOV20.PDF",
    "as/geography/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70362-QP-NOV20.PDF",
    "as/geography/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-70362-W-MS-NOV20.PDF",
    "as/physics/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74071-QP-JUN23.PDF",
    "as/physics/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74071-MS-JUN23.PDF",
    "as/physics/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74072-QP-JUN23.PDF",
    "as/physics/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-74072-MS-JUN23.PDF",
    "as/physics/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74071-QP-JUN22.PDF",
    "as/physics/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74071-MS-JUN22.PDF",
    "as/physics/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74072-QP-JUN22.PDF",
    "as/physics/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-74072-MS-JUN22.PDF",
    "as/physics/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74071-QP-NOV21.PDF",
    "as/physics/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74071-MS-NOV21.PDF",
    "as/physics/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74072-QP-NOV21.PDF",
    "as/physics/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-74072-MS-NOV21.PDF",
    "as/physics/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74071-QP-NOV20.PDF",
    "as/physics/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74071-W-MS-NOV20.PDF",
    "as/physics/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74072-QP-NOV20.PDF",
    "as/physics/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-74072-W-MS-NOV20.PDF",
    "as/physics/aqa/1/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74071-QP-JUN19.PDF",
    "as/physics/aqa/1/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74071-W-MS-JUN19.PDF",
    "as/physics/aqa/2/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74072-QP-JUN19.PDF",
    "as/physics/aqa/2/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-74072-W-MS-JUN19.PDF",
    "as/physics/aqa/1/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74071-QP-JUN18.PDF",
    "as/physics/aqa/1/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74071-W-MS-JUN18.PDF",
    "as/physics/aqa/2/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74072-QP-JUN18.PDF",
    "as/physics/aqa/2/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-74072-W-MS-JUN18.PDF",
    "as/psychology/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71812-QP-JUN22.PDF",
    "as/psychology/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71812-MS-JUN22.PDF",
    "as/psychology/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71812-QP-NOV20.PDF",
    "as/psychology/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71812-W-MS-NOV20.PDF",
    "as/psychology/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-Psychology-Paper-2-QP.pdf",
    "as/psychology/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-AS-Psychology-Paper-2-MS.pdf",
    "as/psychology/aqa/2/18-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71812-QP-JUN18.pdf",
    "as/psychology/aqa/2/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71812-W-MS-JUN18.pdf",
    "as/psychology/aqa/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-71812-QP-JUN17.pdf",
    "as/psychology/aqa/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-71812-W-MS-JUN17.pdf",
    "as/psychology/aqa/2/16-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-71812-QP-JUN16.pdf",
    "as/psychology/aqa/2/16-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2018/12/AQA-71812-W-MS-JUN16.pdf",
    "as/sociology/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71911-QP-JUN23.PDF",
    "as/sociology/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71911-MS-JUN23.PDF",
    "as/sociology/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71912-QP-JUN23.PDF",
    "as/sociology/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-71912-MS-JUN23.PDF",
    "as/sociology/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71911-QP-JUN22.PDF",
    "as/sociology/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71911-MS-JUN22.PDF",
    "as/sociology/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71912-QP-JUN22.PDF",
    "as/sociology/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-71912-MS-JUN22.PDF",
    "as/sociology/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71911-QP-NOV20.PDF",
    "as/sociology/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71911-W-MS-NOV20.PDF",
    "as/sociology/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71912-QP-NOV20.PDF",
    "as/sociology/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-71912-W-MS-NOV20.PDF",
    "as/sociology/aqa/1/18-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71911-QP-JUN18.pdf",
    "as/sociology/aqa/1/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71911-W-MS-JUN18.pdf",
    "as/sociology/aqa/2/18-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71912-QP-JUN18.pdf",
    "as/sociology/aqa/2/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71912-W-MS-JUN18.pdf",
    "as/sociology/aqa/1/17-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71911-QP-JUN17.pdf",
    "as/sociology/aqa/1/17-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71911-W-MS-JUN17.pdf",
    "as/sociology/aqa/2/17-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71912-QP-JUN17.pdf",
    "as/sociology/aqa/2/17-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71912-W-MS-JUN17.pdf",
    "as/sociology/aqa/1/16-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71911-QP-JUN16.pdf",
    "as/sociology/aqa/1/16-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71911-W-MS-JUN16.pdf",
    "as/sociology/aqa/2/16-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71912-QP-JUN16.pdf",
    "as/sociology/aqa/2/16-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-71912-W-MS-JUN16.pdf",
    "gcse/biology/aqa/1-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84611F-QP-JUN23.PDF",
    "gcse/biology/aqa/1-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84611F-MS-JUN23.PDF",
    "gcse/biology/aqa/1-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84611H-QP-JUN23.PDF",
    "gcse/biology/aqa/1-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84611H-MS-JUN23.PDF",
    "gcse/biology/aqa/2-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84612F-QP-JUN23.PDF",
    "gcse/biology/aqa/2-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84612F-MS-JUN23.PDF",
    "gcse/biology/aqa/2-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84612H-QP-JUN23.PDF",
    "gcse/biology/aqa/2-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84612H-MS-JUN23.PDF",
    "gcse/biology/aqa/1-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84611F-QP-JUN22.PDF",
    "gcse/biology/aqa/1-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84611F-MS-JUN22.PDF",
    "gcse/biology/aqa/1-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84611H-QP-JUN22.PDF",
    "gcse/biology/aqa/1-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84611H-MS-JUN22.PDF",
    "gcse/biology/aqa/2-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84612F-QP-JUN22.PDF",
    "gcse/biology/aqa/2-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84612F-MS-JUN22.PDF",
    "gcse/biology/aqa/2-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84612H-QP-JUN22.PDF",
    "gcse/biology/aqa/2-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84612H-MS-JUN22.PDF",
    "gcse/biology/aqa/1-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84611F-QP-NOV21.PDF",
    "gcse/biology/aqa/1-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84611F-MS-NOV21.PDF",
    "gcse/biology/aqa/1-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84611H-QP-NOV21.PDF",
    "gcse/biology/aqa/1-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84611H-MS-NOV21.PDF",
    "gcse/biology/aqa/2-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84612F-QP-NOV21.PDF",
    "gcse/biology/aqa/2-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84612F-MS-NOV21.PDF",
    "gcse/biology/aqa/2-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84612H-QP-NOV21.PDF",
    "gcse/biology/aqa/2-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84612H-MS-NOV21.PDF",
    "gcse/biology/aqa/1-F/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84611F-QP-NOV20.PDF",
    "gcse/biology/aqa/1-F/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84611F-W-MS-NOV20.PDF",
    "gcse/biology/aqa/1-H/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84611H-QP-NOV20.PDF",
    "gcse/biology/aqa/1-H/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84611H-W-MS-NOV20.PDF",
    "gcse/biology/aqa/2-F/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84612F-QP-NOV20.PDF",
    "gcse/biology/aqa/2-F/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84612F-W-MS-NOV20.PDF",
    "gcse/biology/aqa/2-H/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84612H-QP-NOV20.PDF",
    "gcse/biology/aqa/2-H/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84612H-W-MS-NOV20.PDF",
    "gcse/biology/aqa/1-F/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Biology-Foundation-Paper-1-QP.pdf",
    "gcse/biology/aqa/1-F/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Biology-Foundation-Paper-1-MS.pdf",
    "gcse/biology/aqa/1-H/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Biology-Higher-Paper-1-QP.pdf",
    "gcse/biology/aqa/1-H/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Biology-Higher-Paper-1-MS.pdf",
    "gcse/biology/aqa/2-F/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Biology-Foundation-Paper-2-QP.pdf",
    "gcse/biology/aqa/2-F/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Biology-Foundation-Paper-2-MS.pdf",
    "gcse/biology/aqa/2-H/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Biology-Higher-Paper-2-QP.pdf",
    "gcse/biology/aqa/2-H/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Biology-Higher-Paper-2-MS.pdf",
    "gcse/biology/aqa/1-F/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Biology-Foundation-Paper-1-June-2018.pdf",
    "gcse/biology/aqa/1-F/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Biology-Foundation-Paper-1-June-2018-Mark-Scheme.pdf",
    "gcse/biology/aqa/1-H/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Biology-Higher-Paper-1-June-2018.pdf",
    "gcse/biology/aqa/1-H/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Biology-Higher-Paper-1-June-2018-Mark-Scheme.pdf",
    "gcse/biology/aqa/2-F/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Biology-Foundation-Paper-2-June-2018.pdf",
    "gcse/biology/aqa/2-F/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Biology-Foundation-Paper-2-June-2018-Mark-Scheme.pdf",
    "gcse/biology/aqa/2-H/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Biology-Higher-Paper-2-June-2018.pdf",
    "gcse/biology/aqa/2-H/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Biology-Higher-Paper-2-June-2018-Mark-Scheme.pdf",
    "gcse/chemistry/aqa/1-F/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/chemistry/AQA-84621F-SQP.PDF",
    "gcse/chemistry/aqa/1-F/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/chemistry/AQA-84621F-SMS.PDF",
    "gcse/chemistry/aqa/1-H/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/chemistry/AQA-84621H-SQP.PDF",
    "gcse/chemistry/aqa/1-H/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/chemistry/AQA-84621H-SMS.PDF",
    "gcse/chemistry/aqa/2-F/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/chemistry/AQA-84622F-SQP.PDF",
    "gcse/chemistry/aqa/2-F/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/chemistry/AQA-84622F-SMS.PDF",
    "gcse/chemistry/aqa/2-H/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/chemistry/AQA-84622H-SQP.PDF",
    "gcse/chemistry/aqa/2-H/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/chemistry/AQA-84622H-SMS.PDF",
    "gcse/chemistry/aqa/1-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84621F-QP-JUN23.PDF",
    "gcse/chemistry/aqa/1-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84621F-MS-JUN23.PDF",
    "gcse/chemistry/aqa/1-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84621H-QP-JUN23.PDF",
    "gcse/chemistry/aqa/1-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84621H-MS-JUN23.PDF",
    "gcse/chemistry/aqa/2-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84622F-QP-JUN23.PDF",
    "gcse/chemistry/aqa/2-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84622F-MS-JUN23.PDF",
    "gcse/chemistry/aqa/2-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84622H-QP-JUN23.PDF",
    "gcse/chemistry/aqa/2-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84622H-MS-JUN23.PDF",
    "gcse/chemistry/aqa/1-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84621F-QP-JUN22.PDF",
    "gcse/chemistry/aqa/1-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84621F-MS-JUN22.PDF",
    "gcse/chemistry/aqa/1-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84621H-QP-JUN22.PDF",
    "gcse/chemistry/aqa/1-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84621H-MS-JUN22.PDF",
    "gcse/chemistry/aqa/2-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84622F-QP-JUN22.PDF",
    "gcse/chemistry/aqa/2-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84622F-MS-JUN22.PDF",
    "gcse/chemistry/aqa/2-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84622H-QP-JUN22.PDF",
    "gcse/chemistry/aqa/2-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84622H-MS-JUN22.PDF",
    "gcse/chemistry/aqa/1-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84621F-QP-NOV21.PDF",
    "gcse/chemistry/aqa/1-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84621F-MS-NOV21.PDF",
    "gcse/chemistry/aqa/1-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84621H-QP-NOV21.PDF",
    "gcse/chemistry/aqa/1-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84621H-MS-NOV21.PDF",
    "gcse/chemistry/aqa/2-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84622F-QP-NOV21.PDF",
    "gcse/chemistry/aqa/2-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84622F-MS-NOV21.PDF",
    "gcse/chemistry/aqa/2-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84622H-QP-NOV21.PDF",
    "gcse/chemistry/aqa/2-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84622H-MS-NOV21.PDF",
    "gcse/chemistry/aqa/1-F/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84621F-QP-NOV20.PDF",
    "gcse/chemistry/aqa/1-F/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84621F-W-MS-NOV20.PDF",
    "gcse/chemistry/aqa/1-H/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84621H-QP-NOV20.PDF",
    "gcse/chemistry/aqa/1-H/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84621H-W-MS-NOV20.PDF",
    "gcse/chemistry/aqa/2-F/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84622F-QP-NOV20.PDF",
    "gcse/chemistry/aqa/2-F/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84622F-W-MS-NOV20.PDF",
    "gcse/chemistry/aqa/2-H/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84622H-QP-NOV20.PDF",
    "gcse/chemistry/aqa/2-H/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84622H-W-MS-NOV20.PDF",
    "gcse/chemistry/aqa/1-F/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84621F-QP-JUN19.PDF",
    "gcse/chemistry/aqa/1-F/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84621F-W-MS-JUN19.PDF",
    "gcse/chemistry/aqa/1-H/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84621H-QP-JUN19.PDF",
    "gcse/chemistry/aqa/1-H/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84621H-W-MS-JUN19.PDF",
    "gcse/chemistry/aqa/2-F/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Chemistry-Foundation-Paper-2-QP.pdf",
    "gcse/chemistry/aqa/2-F/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Chemistry-Foundation-Paper-2-MS.pdf",
    "gcse/chemistry/aqa/2-H/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Chemistry-Higher-Paper-2-QP.pdf",
    "gcse/chemistry/aqa/2-H/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Chemistry-Higher-Paper-2-MS.pdf",
    "gcse/chemistry/aqa/1-F/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84621F-QP-JUN18.PDF",
    "gcse/chemistry/aqa/1-F/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84621F-W-MS-JUN18.PDF",
    "gcse/chemistry/aqa/1-H/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84621H-QP-JUN18.PDF",
    "gcse/chemistry/aqa/1-H/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84621H-W-MS-JUN18.PDF",
    "gcse/chemistry/aqa/2-F/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84622F-QP-JUN18.PDF",
    "gcse/chemistry/aqa/2-F/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84622F-W-MS-JUN18.PDF",
    "gcse/chemistry/aqa/2-H/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84622H-QP-JUN18.PDF",
    "gcse/chemistry/aqa/2-H/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84622H-W-MS-JUN18.PDF",
    "gcse/compsci/aqa-8525/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/computing/AQA-85251C-SQP-S1.PDF",
    "gcse/compsci/aqa-8525/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/computing/AQA-85251-SMS-S1.PDF",
    "gcse/compsci/aqa-8525/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/computing/AQA-85252-SQP-S1.PDF",
    "gcse/compsci/aqa-8525/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/computing/AQA-85252-SMS-S1.PDF",
    "gcse/compsci/aqa-8525/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-85251C-QP-JUN23.PDF",
    "gcse/compsci/aqa-8525/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-85251-MS-JUN23.PDF",
    "gcse/compsci/aqa-8525/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-85252-QP-JUN23.PDF",
    "gcse/compsci/aqa-8525/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-85252-MS-JUN23.PDF",
    "gcse/compsci/aqa-8525/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-85251C-QP-JUN22.PDF",
    "gcse/compsci/aqa-8525/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-85251-MS-JUN22.PDF",
    "gcse/compsci/aqa-8525/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-85252-QP-JUN22.PDF",
    "gcse/compsci/aqa-8525/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-85252-MS-JUN22.PDF",
    "gcse/compsci/aqa-8525/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-85201-QP-NOV21.PDF",
    "gcse/compsci/aqa-8525/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-85201-MS-NOV21.PDF",
    "gcse/compsci/aqa-8525/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-85202-QP-NOV21.PDF",
    "gcse/compsci/aqa-8525/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-85202-MS-NOV21.PDF",
    "gcse/dance/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/dance/AQA-82362-SQP.PDF",
    "gcse/dance/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/dance/AQA-82362-SMS.PDF",
    "gcse/dance/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8236W-QP-JUN23-CR.PDF",
    "gcse/dance/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8236W-MS-JUN23.PDF",
    "gcse/dance/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8236W-QP-JUN22.PDF",
    "gcse/dance/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8236W-MS-JUN22.PDF",
    "gcse/dance/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8236W-QP-NOV21-CR.PDF",
    "gcse/dance/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8236W-MS-NOV21.PDF",
    "gcse/dance/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8236W-QP-NOV20.PDF",
    "gcse/dance/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8236W-W-MS-NOV20.PDF",
    "gcse/dance/aqa/2/19-jun/qp.PDF":
      "https://pastpapers.co/aqa/GCSE/Dance-8236/AQA-8236W-QP-JUN19.pdf",
    "gcse/dance/aqa/2/19-jun/ms.PDF":
      "https://pastpapers.co/aqa/GCSE/Dance-8236/AQA-8236W-MS-JUN19.pdf",
    "gcse/dance/aqa/2/18-jun/qp.PDF":
      "https://pastpapers.co/aqa/GCSE/Dance-8236/AQA-8236W-QP-JUN18.pdf",
    "gcse/dance/aqa/2/18-jun/ms.PDF":
      "https://pastpapers.co/aqa/GCSE/Dance-8236/AQA-8236W-MS-JUN18.pdf",
    "gcse/drama/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8261W-QP-JUN23.PDF",
    "gcse/drama/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8261W-MS-JUN23.PDF",
    "gcse/drama/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8261W-QP-JUN22-CR.PDF",
    "gcse/drama/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8261W-MS-JUN22.PDF",
    "gcse/drama/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8261W-QP-NOV21.PDF",
    "gcse/drama/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8261W-MS-NOV21.PDF",
    "gcse/drama/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8261W-QP-NOV20-CR.PDF",
    "gcse/drama/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8261W-W-MS-NOV20.PDF",
    "gcse/drama/aqa/2/19-jun/qp.PDF":
      "https://www.revisely.com/documents/papers/gcse/drama/aqa/91462-component-1-understanding-drama-qp.pdf",
    "gcse/drama/aqa/2/19-jun/ms.PDF":
      "https://www.revisely.com/documents/papers/gcse/drama/aqa/93524-component-1-understanding-drama-ms.pdf",
    "gcse/drama/aqa/2/18-jun/qp.PDF":
      "https://www.revisely.com/documents/papers/gcse/drama/aqa/80255-component-1-understanding-drama-qp.pdf",
    "gcse/drama/aqa/2/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/02/AQA-82611-W-MS-JUN18.pdf",
    "gcse/economics/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/economics/AQA-81361-SQP-CR.PDF",
    "gcse/economics/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/economics/AQA-81361-SMS.PDF",
    "gcse/economics/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/economics/AQA-81362-SQP.PDF",
    "gcse/economics/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/economics/AQA-81362-SMS.PDF",
    "gcse/economics/aqa/1/23-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81361-QP-JUN23.PDF",
    "gcse/economics/aqa/1/23-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81361-MS-JUN23.PDF",
    "gcse/economics/aqa/2/23-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81362-QP-JUN23.PDF",
    "gcse/economics/aqa/2/23-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81362-MS-JUN23.PDF",
    "gcse/economics/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81361-QP-JUN22.PDF",
    "gcse/economics/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81361-MS-JUN22.PDF",
    "gcse/economics/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81362-QP-JUN22.PDF",
    "gcse/economics/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81362-MS-JUN22.PDF",
    "gcse/economics/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81361-QP-NOV21.PDF",
    "gcse/economics/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81361-MS-NOV21.PDF",
    "gcse/economics/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81362-QP-NOV21.PDF",
    "gcse/economics/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81362-MS-NOV21.PDF",
    "gcse/economics/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81361-QP-NOV20.PDF",
    "gcse/economics/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81361-W-MS-NOV20.PDF",
    "gcse/economics/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81362-QP-NOV20.PDF",
    "gcse/economics/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81362-W-MS-NOV20.PDF",
    "gcse/economics/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/11/AQA-GCSE-JUN2019-Economics-Paper-2-QP.pdf",
    "gcse/economics/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/11/AQA-GCSE-JUN2019-Economics-Paper-2-MS.pdf",
    "gcse/economics/aqa/1/19-may/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/11/AQA-GCSE-JUN2019-Economics-Paper-1-QP.pdf",
    "gcse/economics/aqa/1/19-may/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/11/AQA-GCSE-JUN2019-Economics-Paper-1-MS.pdf",
    "gcse/engineering/aqa/1/-uni/qp.PDF":
      "https://filestore.aqa.org.uk/resources/engineering/AQA-88521-SQP-CR.PDF",
    "gcse/engineering/aqa/1/-uni/ms.PDF":
      "https://filestore.aqa.org.uk/resources/engineering/AQA-88521-SMS.PDF",
    "gcse/engineering/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8852W-QP-JUN23.PDF",
    "gcse/engineering/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8852W-MS-JUN23.PDF",
    "gcse/engineering/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8852W-QP-JUN22.PDF",
    "gcse/engineering/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8852W-MS-JUN22.PDF",
    "gcse/engineering/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8852W-QP-NOV21.PDF",
    "gcse/engineering/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8852W-MS-NOV21.PDF",
    "gcse/engineering/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8852W-QP-NOV20.PDF",
    "gcse/engineering/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8852W-W-MS-NOV20.PDF",
    "gcse/english-lang/aqa/1/23-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/6627251a69f6772ab747da14b6eb5dcd9701ae5d.pdf",
    "gcse/english-lang/aqa/1/23-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/cba0d80891811a1661036c848681c8c4351b4cd8.pdf",
    "gcse/english-lang/aqa//undefined-ins/ins.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/03/AQA-GCSE-English-Language-June-2017-Paper-2-Insert.pdf",
    "gcse/english-lang/aqa/2/23-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/aeaafff5bd36defd716aac19f1516c41ac3e77b7.pdf",
    "gcse/english-lang/aqa/2/23-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/e5f594eba63b43e4cab478d123ec33603d30953a.pdf",
    "gcse/english-lang/aqa/1/22-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-87001-QP-NOV22-CR.PDF",
    "gcse/english-lang/aqa/1/22-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-87001-MS-NOV22.PDF",
    "gcse/english-lang/aqa/2/22-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-87002-QP-NOV22.PDF",
    "gcse/english-lang/aqa/2/22-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-87002-MS-NOV22.PDF",
    "gcse/english-lang/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-87001-QP-JUN22-CR.PDF",
    "gcse/english-lang/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-87001-MS-JUN22.PDF",
    "gcse/english-lang/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-87002-QP-JUN22.PDF",
    "gcse/english-lang/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-87002-MS-JUN22.PDF",
    "gcse/english-lang/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-87001-QP-NOV21.PDF",
    "gcse/english-lang/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-87001-MS-NOV21.PDF",
    "gcse/english-lang/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-87002-QP-NOV21.PDF",
    "gcse/english-lang/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-87002-MS-NOV21.PDF",
    "gcse/english-lang/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-87001-QP-NOV20.PDF",
    "gcse/english-lang/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-87001-W-MS-NOV20.PDF",
    "gcse/english-lang/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-87002-QP-NOV20.PDF",
    "gcse/english-lang/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-87002-W-MS-NOV20.PDF",
    "gcse/english-lang/aqa/1/19-nov/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/08/AQA-GCSE-English-Language-November-2021-Paper-1.pdf",
    "gcse/english-lang/aqa/1/19-nov/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/08/AQA-GCSE-English-Language-November-2021-Paper-1-MS.pdf",
    "gcse/english-lang/aqa/2/19-nov/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/08/AQA-GCSE-English-Language-November-2021-Paper-2.pdf",
    "gcse/english-lang/aqa/2/19-nov/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/08/AQA-GCSE-English-Language-November-2021-Paper-2-MS.pdf",
    "gcse/english-lang/aqa/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-English-Language-Paper-1-QP.pdf",
    "gcse/english-lang/aqa/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-English-Language-Paper-1-MS.pdf",
    "gcse/english-lang/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-English-Language-Paper-2-QP.pdf",
    "gcse/english-lang/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-English-Language-Paper-2-MS.pdf",
    "gcse/english-lang/aqa/1/18-nov/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-NOV2018-English-Language-Paper-1-QP.pdf",
    "gcse/english-lang/aqa/1/18-nov/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-NOV2018-English-Language-Paper-1-MS.pdf",
    "gcse/english-lang/aqa/2/18-nov/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-NOV2018-English-Language-Paper-2-QP.pdf",
    "gcse/english-lang/aqa/2/18-nov/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-NOV2018-English-Language-Paper-2-MS.pdf",
    "gcse/english-lang/aqa/1/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Language-Paper-1-June-2018.pdf",
    "gcse/english-lang/aqa/1/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Language-Paper-1-June-2018-Mark-Scheme.pdf",
    "gcse/english-lang/aqa/2/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Language-Paper-2-June-2018.pdf",
    "gcse/english-lang/aqa/2/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Language-Paper-2-June-2018-Mark-Scheme.pdf",
    "gcse/english-lang/aqa/1/17-nov/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/03/AQA-GCSE-English-Language-November-2017-Paper-1.pdf",
    "gcse/english-lang/aqa/1/17-nov/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/03/AQA-GCSE-English-Language-November-2017-Paper-1-MS.pdf",
    "gcse/english-lang/aqa/2/17-nov/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/03/AQA-GCSE-English-Language-November-2017-Paper-2.pdf",
    "gcse/english-lang/aqa/2/17-nov/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/03/AQA-GCSE-English-Language-November-2017-Paper-2-MS.pdf",
    "gcse/english-lang/aqa/1/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/03/AQA-GCSE-English-Language-June-2017-Paper-1.pdf",
    "gcse/english-lang/aqa/1/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/03/AQA-GCSE-English-Language-June-2017-Paper-1-MS.pdf",
    "gcse/english-lang/aqa/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/03/AQA-GCSE-English-Language-June-2017-Paper-2.pdf",
    "gcse/english-lang/aqa/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/03/AQA-GCSE-English-Language-June-2017-Paper-2-MS.pdf",
    "gcse/english-lit/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/english/AQA-87021-SQP-V1.PDF",
    "gcse/english-lit/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/english/AQA-87021-SMS.PDF",
    "gcse/english-lit/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/english/AQA-87022-SQP.PDF",
    "gcse/english-lit/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/english/AQA-87022-SMS.PDF",
    "gcse/english-lit/aqa/1/23-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/06a1f8526d000ba281779c1e5d15da64fbce958b.pdf",
    "gcse/english-lit/aqa/1/23-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/03f761e92d700e28198b3b0762a003f0e801a4e9.pdf",
    "gcse/english-lit/aqa/2/23-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/6b6ad6d5656c8f43735703b17c9ca2c17e76b436.pdf",
    "gcse/english-lit/aqa/2/23-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/be17489dade9adb799a08da10c5ada3d3bacf17d.pdf",
    "gcse/english-lit/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-87021P-QP-JUN22-CR.PDF",
    "gcse/english-lit/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-87021P-MS-JUN22.PDF",
    "gcse/english-lit/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-87022-QP-JUN22.PDF",
    "gcse/english-lit/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-87022-MS-JUN22.PDF",
    "gcse/english-lit/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-87021P-QP-NOV21.PDF",
    "gcse/english-lit/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-87021P-MS-NOV21.PDF",
    "gcse/english-lit/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-87022-QP-NOV21.PDF",
    "gcse/english-lit/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-87022-MS-NOV21.PDF",
    "gcse/english-lit/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-87021-QP-NOV20.PDF",
    "gcse/english-lit/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-87021-W-MS-NOV20.PDF",
    "gcse/english-lit/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-87022-QP-NOV20-CR.PDF",
    "gcse/english-lit/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-87022-W-MS-NOV20.PDF",
    "gcse/english-lit/aqa/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-English-Literature-Paper-1-QP.pdf",
    "gcse/english-lit/aqa/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-English-Literature-Paper-1-MS.pdf",
    "gcse/english-lit/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-English-Literature-Paper-2-QP.pdf",
    "gcse/english-lit/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-English-Literature-Paper-2-MS.pdf",
    "gcse/english-lit/aqa/1/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Literature-Paper-1-June-2018.pdf",
    "gcse/english-lit/aqa/1/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Literature-Paper-1-June-2018-Mark-Scheme.pdf",
    "gcse/english-lit/aqa/2/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Literature-Paper-2-June-2018.pdf",
    "gcse/english-lit/aqa/2/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Literature-Paper-2-June-2018-Mark-Scheme.pdf",
    "gcse/english-lit/aqa/1/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Literature-Paper-1-June-2017.pdf",
    "gcse/english-lit/aqa/1/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Literature-Paper-1-June-2017-Mark-Scheme.pdf",
    "gcse/english-lit/aqa/2/17-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Literature-Paper-2-June-2017.pdf",
    "gcse/english-lit/aqa/2/17-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-English-Literature-Paper-2-June-2017-Mark-Scheme.pdf",
    "gcse/geography/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/geography/AQA-80351-SQP-CR.PDF",
    "gcse/geography/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/geography/AQA-80351-SMS.PDF",
    "gcse/geography/aqa//undefined-ins/ins.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-JUN2018-Geography-Paper-3-Ins.pdf",
    "gcse/geography/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/geography/AQA-80352-SQP-CR.PDF",
    "gcse/geography/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/geography/AQA-80352-SMS.PDF",
    "gcse/geography/aqa/3/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/geography/AQA-80353-SQP-CR.PDF",
    "gcse/geography/aqa/3/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/geography/AQA-80353-SMS.PDF",
    "gcse/geography/aqa//undefined-boo/ins.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-JUN2018-Geography-Pre-release-booklet.pdf",
    "gcse/geography/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-80351-QP-JUN23-CR.PDF",
    "gcse/geography/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-80351-MS-JUN23.PDF",
    "gcse/geography/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-80352-QP-JUN23-CR.PDF",
    "gcse/geography/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-80352-MS-JUN23.PDF",
    "gcse/geography/aqa/3/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-80353-QP-JUN23.PDF",
    "gcse/geography/aqa/3/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-80353-MS-JUN23.PDF",
    "gcse/geography/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80351-QP-JUN22.PDF",
    "gcse/geography/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80351-MS-JUN22.PDF",
    "gcse/geography/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80352-QP-JUN22-CR.PDF",
    "gcse/geography/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80352-MS-JUN22.PDF",
    "gcse/geography/aqa/3/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80353-QP-JUN22.PDF",
    "gcse/geography/aqa/3/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80353-MS-JUN22.PDF",
    "gcse/geography/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80351-QP-NOV21.PDF",
    "gcse/geography/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80351-MS-NOV21.PDF",
    "gcse/geography/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80352-QP-NOV21.PDF",
    "gcse/geography/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80352-MS-NOV21.PDF",
    "gcse/geography/aqa/3/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80353-QP-NOV21.PDF",
    "gcse/geography/aqa/3/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80353-MS-NOV21.PDF",
    "gcse/geography/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80351-QP-NOV20-CR.PDF",
    "gcse/geography/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80351-W-MS-NOV20.PDF",
    "gcse/geography/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80352-QP-NOV20-CR.PDF",
    "gcse/geography/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80352-W-MS-NOV20.PDF",
    "gcse/geography/aqa/3/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80353-QP-NOV20.PDF",
    "gcse/geography/aqa/3/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80353-W-MS-NOV20.PDF",
    "gcse/geography/aqa/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Geography-Paper-1-QP.pdf",
    "gcse/geography/aqa/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Geography-Paper-1-MS.pdf",
    "gcse/geography/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Geography-Paper-2-QP.pdf",
    "gcse/geography/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Geography-Paper-2-MS.pdf",
    "gcse/geography/aqa/3/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Geography-Paper-3-QP.pdf",
    "gcse/geography/aqa/3/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Geography-Paper-3-MS.pdf",
    "gcse/geography/aqa/1/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-JUN2018-Geography-Paper-1-QP.pdf",
    "gcse/geography/aqa/1/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-JUN2018-Geography-Paper-1-MS.pdf",
    "gcse/geography/aqa/2/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-JUN2018-Geography-Paper-2-QP.pdf",
    "gcse/geography/aqa/2/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-JUN2018-Geography-Paper-2-MS.pdf",
    "gcse/geography/aqa/3/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-JUN2018-Geography-Paper-3-QP.pdf",
    "gcse/geography/aqa/3/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2022/01/AQA-GCSE-JUN2018-Geography-Paper-3-MS.pdf",
    "gcse/history/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/history/AQA-81451BE-SQP.PDF",
    "gcse/history/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/history/AQA-81451BE-SMS.PDF",
    "gcse/history/aqa//undefined-ins/ins.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-History-Paper-2-Section-BD-In.pdf",
    "gcse/history/aqa//d-ans/ins.PDF":
      "https://filestore.aqa.org.uk/resources/history/AQA-81452BD-EX.PDF",
    "gcse/history/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/history/AQA-81452BD-SQP.PDF",
    "gcse/history/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/history/AQA-81452BD-SMS.PDF",
    "gcse/history/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81451BE-QP-JUN23.PDF",
    "gcse/history/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81451BE-MS-JUN23.PDF",
    "gcse/history/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81452BD-QP-JUN23.PDF",
    "gcse/history/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81452BD-MS-JUN23.PDF",
    "gcse/history/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81451BE-QP-JUN22.PDF",
    "gcse/history/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81451BE-MS-JUN22.PDF",
    "gcse/history/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81452BD-QP-JUN22.PDF",
    "gcse/history/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81452BD-MS-JUN22.PDF",
    "gcse/history/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81451BD-QP-NOV21.PDF",
    "gcse/history/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81451BD-MS-NOV21.PDF",
    "gcse/history/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81452BD-QP-NOV21.PDF",
    "gcse/history/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81452BD-MS-NOV21.PDF",
    "gcse/history/aqa/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81451BE-QP-NOV20.PDF",
    "gcse/history/aqa/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81451BE-W-MS-NOV20.PDF",
    "gcse/history/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81452BD-QP-NOV20.PDF",
    "gcse/history/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81452BD-W-MS-NOV20.PDF",
    "gcse/history/aqa/1/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-History-Paper-1-Section-BE-QP.pdf",
    "gcse/history/aqa/1/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-History-Paper-1-Section-BE-MS.pdf",
    "gcse/history/aqa/2/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-History-Paper-2-Section-BD-QP.pdf",
    "gcse/history/aqa/2/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-History-Paper-2-Section-BD-MS.pdf",
    "gcse/music/aqa//-com/qp.PDF":
      "https://filestore.aqa.org.uk/resources/music/AQA-82713-SQP-CR.PDF",
    "gcse/music/aqa//-com/ms.PDF":
      "https://filestore.aqa.org.uk/resources/music/AQA-82711-SMS-22.PDF",
    "gcse/music/aqa//st-res/ins.PDF":
      "https://www.aqa.org.uk/resources/music/gcse/music/teach/resource-list-study-pieces-and-listening-list",
    "gcse/music/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8271W-QP-JUN23-CR.PDF",
    "gcse/music/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8271W-MS-JUN23-CR.PDF",
    "gcse/music/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8271W-QP-JUN22-CR.PDF",
    "gcse/music/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8271W-MS-JUN22-CR.PDF",
    "gcse/music/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8271C-QP-NOV21-CR.PDF",
    "gcse/music/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8271W-MS-NOV21.PDF",
    "gcse/music/aqa/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8271W-QP-NOV20-CR.PDF",
    "gcse/music/aqa/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8271W-W-MS-NOV20.PDF",
    "gcse/music/aqa/2/19-jun/qp.PDF":
      "https://pastpapers.co/aqa/GCSE/Music-8271/AQA-8271W-QP-JUN19-CR.pdf",
    "gcse/music/aqa/2/19-jun/ms.PDF":
      "https://pastpapers.co/aqa/GCSE/Music-8271/AQA-8271W-W-MS-JUN19.pdf",
    "gcse/music/aqa/2/18-jun/qp.PDF":
      "https://pastpapers.co/aqa/GCSE/Music-8271/AQA-8271W-QP-JUN18-CR.pdf",
    "gcse/music/aqa/2/18-jun/ms.PDF":
      "https://pastpapers.co/aqa/GCSE/Music-8271/AQA-8271W-W-MS-JUN18.pdf",
    "gcse/pe/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/pe/AQA-85821-SQP.PDF",
    "gcse/pe/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/pe/AQA-85821-SMS.PDF",
    "gcse/pe/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-85821-QP-JUN23.PDF",
    "gcse/pe/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-85821-MS-JUN23.PDF",
    "gcse/pe/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-85822-QP-JUN23.PDF",
    "gcse/pe/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-85822-MS-JUN23.PDF",
    "gcse/pe/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-85821-QP-JUN22.PDF",
    "gcse/pe/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-85821-MS-JUN22.PDF",
    "gcse/pe/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-85822-QP-JUN22.PDF",
    "gcse/pe/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-85822-MS-JUN22.PDF",
    "gcse/pe/aqa/1/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-85821-QP-NOV21.PDF",
    "gcse/pe/aqa/1/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-85821-MS-NOV21.PDF",
    "gcse/pe/aqa/2/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-85822-QP-NOV21.PDF",
    "gcse/pe/aqa/2/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-85822-MS-NOV21.PDF",
    "gcse/pe/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-85821-QP-NOV20.PDF",
    "gcse/pe/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-85821-W-MS-NOV20.PDF",
    "gcse/pe/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-85822-QP-NOV20.PDF",
    "gcse/pe/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-85822-W-MS-NOV20.PDF",
    "gcse/physics/aqa/2-F/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/physics/AQA-84632F-SQP.PDF",
    "gcse/physics/aqa/2-F/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/physics/AQA-84632F-SMS.PDF",
    "gcse/physics/aqa/2-H/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/physics/AQA-84632H-SQP.PDF",
    "gcse/physics/aqa/2-H/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/physics/AQA-84632H-SMS.PDF",
    "gcse/physics/aqa/2-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84632F-QP-JUN23.PDF",
    "gcse/physics/aqa/2-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84632F-MS-JUN23.PDF",
    "gcse/physics/aqa/2-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84632H-QP-JUN23.PDF",
    "gcse/physics/aqa/2-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84632H-MS-JUN23.PDF",
    "gcse/physics/aqa/1-F/23-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84631F-QP-JUN23.PDF",
    "gcse/physics/aqa/1-F/23-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84631F-MS-JUN23.PDF",
    "gcse/physics/aqa/1-H/23-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84631H-QP-JUN23.PDF",
    "gcse/physics/aqa/1-H/23-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84631H-MS-JUN23.PDF",
    "gcse/physics/aqa/1-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84631F-QP-JUN22.PDF",
    "gcse/physics/aqa/1-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84631F-MS-JUN22.PDF",
    "gcse/physics/aqa/1-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84631H-QP-JUN22.PDF",
    "gcse/physics/aqa/1-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84631H-MS-JUN22.PDF",
    "gcse/physics/aqa/2-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84632F-QP-JUN22.PDF",
    "gcse/physics/aqa/2-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84632F-MS-JUN22.PDF",
    "gcse/physics/aqa/2-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84632H-QP-JUN22.PDF",
    "gcse/physics/aqa/2-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84632H-MS-JUN22.PDF",
    "gcse/physics/aqa/1-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84631F-QP-NOV21.PDF",
    "gcse/physics/aqa/1-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84631F-MS-NOV21.PDF",
    "gcse/physics/aqa/1-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84631H-QP-NOV21.PDF",
    "gcse/physics/aqa/1-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84631H-MS-NOV21.PDF",
    "gcse/physics/aqa/2-F/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84632F-QP-NOV21.PDF",
    "gcse/physics/aqa/2-F/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84632F-MS-NOV21.PDF",
    "gcse/physics/aqa/2-H/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84632H-QP-NOV21.PDF",
    "gcse/physics/aqa/2-H/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84632H-MS-NOV21.PDF",
    "gcse/physics/aqa/2-F/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84632F-QP-NOV20.PDF",
    "gcse/physics/aqa/2-F/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84632F-W-MS-NOV20.PDF",
    "gcse/physics/aqa/2-H/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84632H-QP-NOV20.PDF",
    "gcse/physics/aqa/2-H/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84632H-W-MS-NOV20.PDF",
    "gcse/physics/aqa/1-F/20-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84631F-QP-NOV20.PDF",
    "gcse/physics/aqa/1-F/20-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84631F-QP-NOV20.PDF",
    "gcse/physics/aqa/1-H/20-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84631H-QP-NOV20.PDF",
    "gcse/physics/aqa/1-H/20-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84631H-W-MS-NOV20.PDF",
    "gcse/physics/aqa/2-F/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84632F-QP-JUN19.PDF",
    "gcse/physics/aqa/2-F/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84632F-W-MS-JUN19.PDF",
    "gcse/physics/aqa/2-H/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84632H-QP-JUN19.PDF",
    "gcse/physics/aqa/2-H/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84632H-W-MS-JUN19.PDF",
    "gcse/physics/aqa/1-F/19-may/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84631F-QP-JUN19.PDF",
    "gcse/physics/aqa/1-F/19-may/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84631F-W-MS-JUN19.PDF",
    "gcse/physics/aqa/1-H/19-may/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Physics-Higher-Paper-1-QP.pdf",
    "gcse/physics/aqa/1-H/19-may/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Physics-Higher-Paper-1-MS.pdf",
    "gcse/physics/aqa/2-F/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84632F-QP-JUN18.PDF",
    "gcse/physics/aqa/2-F/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84632F-W-MS-JUN18.PDF",
    "gcse/physics/aqa/2-H/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84632H-QP-JUN18.PDF",
    "gcse/physics/aqa/2-H/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84632H-W-MS-JUN18.PDF",
    "gcse/physics/aqa/1-F/18-may/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Physics-Foundation-Paper-1-June-2018.pdf",
    "gcse/physics/aqa/1-F/18-may/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Physics-Foundation-Paper-1-June-2018-Mark-Scheme.pdf",
    "gcse/physics/aqa/1-H/18-may/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Physics-Higher-Paper-1-June-2018.pdf",
    "gcse/physics/aqa/1-H/18-may/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/07/AQA-GCSE-Physics-Higher-Paper-1-June-2018-Mark-Scheme.pdf",
    "gcse/psychology/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/psychology/AQA-81821-SQP-CR.PDF",
    "gcse/psychology/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/psychology/AQA-81821-SMS.PDF",
    "gcse/psychology/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/psychology/AQA-81822-SQP.PDF",
    "gcse/psychology/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/psychology/AQA-81822-SMS.PDF",
    "gcse/psychology/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81821-QP-JUN23.PDF",
    "gcse/psychology/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81821-MS-JUN23.PDF",
    "gcse/psychology/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81822-QP-JUN23.PDF",
    "gcse/psychology/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81822-MS-JUN23.PDF",
    "gcse/psychology/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81821-QP-JUN22.PDF",
    "gcse/psychology/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81821-MS-JUN22.PDF",
    "gcse/psychology/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81822-QP-JUN22.PDF",
    "gcse/psychology/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81822-MS-JUN22.PDF",
    "gcse/psychology/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81821-QP-NOV21.PDF",
    "gcse/psychology/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81821-MS-NOV21.PDF",
    "gcse/psychology/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81822-QP-NOV21.PDF",
    "gcse/psychology/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81822-MS-NOV21.PDF",
    "gcse/psychology/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81821-QP-NOV20.PDF",
    "gcse/psychology/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81821-W-MS-NOV20.PDF",
    "gcse/psychology/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81822-QP-NOV20.PDF",
    "gcse/psychology/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81822-W-MS-NOV20.PDF",
    "gcse/psychology/aqa/1/19-jun/qp.PDF":
      "https://pastpapers.co/aqa/GCSE/Psychology-8182/AQA-81821-QP-JUN19.pdf",
    "gcse/psychology/aqa/1/19-jun/ms.PDF":
      "https://pastpapers.co/aqa/GCSE/Psychology-8182/AQA-81821-W-MS-JUN19.pdf",
    "gcse/psychology/aqa/2/19-jun/qp.PDF":
      "https://pastpapers.co/aqa/GCSE/Psychology-8182/AQA-81822-QP-JUN19.pdf",
    "gcse/psychology/aqa/2/19-jun/ms.PDF":
      "https://pastpapers.co/aqa/GCSE/Psychology-8182/AQA-81822-W-MS-JUN19.pdf",
    "gcse/rs/aqa-a/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-806217-SQP-S2.PDF",
    "gcse/rs/aqa-a/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-806217-SMS-S2.PDF",
    "gcse/rs/aqa-a/2/:-pap/qp.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-80622B-SQP-S2.PDF",
    "gcse/rs/aqa-a/2/:-pap/ms.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-80622B-SMS-S2.PDF",
    "gcse/rs/aqa-a/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-806217-QP-JUN23.PDF",
    "gcse/rs/aqa-a/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-806217-MS-JUN23.PDF",
    "gcse/rs/aqa-a/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-80622B-QP-JUN23.PDF",
    "gcse/rs/aqa-a/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80622B-MS-JUN22.PDF",
    "gcse/rs/aqa-a/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-806217-QP-JUN22.PDF",
    "gcse/rs/aqa-a/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-806217-MS-JUN22.PDF",
    "gcse/rs/aqa-a/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80622B-QP-JUN22.PDF",
    "gcse/rs/aqa-a/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80622B-MS-JUN22.PDF",
    "gcse/rs/aqa-a/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-806217-QP-NOV21.PDF",
    "gcse/rs/aqa-a/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-806217-MS-NOV21.PDF",
    "gcse/rs/aqa-a/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80622B-QP-NOV21.PDF",
    "gcse/rs/aqa-a/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80622B-MS-NOV21.PDF",
    "gcse/rs/aqa-a/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-806217-QP-NOV20.PDF",
    "gcse/rs/aqa-a/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-806217-W-MS-NOV20.PDF",
    "gcse/rs/aqa-a/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80622B-QP-NOV20.PDF",
    "gcse/rs/aqa-a/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80622B-W-MS-NOV20.PDF",
    "gcse/rs/aqa-a/1/18-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/03/AQA-806217-QP-JUN18.pdf",
    "gcse/rs/aqa-a/1/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/03/AQA-806217-W-MS-JUN18.pdf",
    "gcse/rs/aqa-a/2/18-jun/qp.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/03/AQA-80622B-QP-JUN18.pdf",
    "gcse/rs/aqa-a/2/18-jun/ms.PDF":
      "https://www.cienotes.com/wp-content/uploads/2020/03/AQA-80622B-W-MS-JUN18.pdf",
    "gcse/rs/aqa-b/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-80631-SQP-S2.PDF",
    "gcse/rs/aqa-b/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-80631-SMS-S2.PDF",
    "gcse/rs/aqa-b/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-80632Y-SQP-S2.PDF",
    "gcse/rs/aqa-b/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/rs/AQA-80632Y-SMS-S2.PDF",
    "gcse/rs/aqa-b/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-80631-QP-JUN23.PDF",
    "gcse/rs/aqa-b/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-80631-MS-JUN23.PDF",
    "gcse/rs/aqa-b/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-80632Y-QP-JUN23.PDF",
    "gcse/rs/aqa-b/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-80632Y-MS-JUN23.PDF",
    "gcse/rs/aqa-b/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80631-QP-JUN22.PDF",
    "gcse/rs/aqa-b/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80631-MS-JUN22.PDF",
    "gcse/rs/aqa-b/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80632Y-QP-JUN22.PDF",
    "gcse/rs/aqa-b/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-80632Y-MS-JUN22.PDF",
    "gcse/rs/aqa-b/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80631-QP-NOV21.PDF",
    "gcse/rs/aqa-b/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80631-MS-NOV21.PDF",
    "gcse/rs/aqa-b/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80632Y-QP-NOV21.PDF",
    "gcse/rs/aqa-b/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-80632Y-MS-NOV21.PDF",
    "gcse/rs/aqa-b/1/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80631-QP-NOV20.PDF",
    "gcse/rs/aqa-b/1/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80631-W-MS-NOV20.PDF",
    "gcse/rs/aqa-b/2/20-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80632Y-QP-NOV20.PDF",
    "gcse/rs/aqa-b/2/20-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-80632Y-W-MS-NOV20.PDF",
    "gcse/science/aqa-synergy/1-F/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/science/AQA-84651F-SQP.PDF",
    "gcse/science/aqa-synergy/1-F/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/science/AQA-84651F-SMS.PDF",
    "gcse/science/aqa-synergy//ua-phy/ins.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-8465-DB-JUN18.PDF",
    "gcse/science/aqa-synergy//bl-per/ins.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-8465-PT-JUN18.PDF",
    "gcse/science/aqa-synergy/2-F/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/science/AQA-84652F-SQP.PDF",
    "gcse/science/aqa-synergy/2-F/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/science/AQA-84652F-SMS.PDF",
    "gcse/science/aqa-synergy/3-F/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/science/AQA-84653F-SQP.PDF",
    "gcse/science/aqa-synergy/3-F/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/science/AQA-84653F-SMS.PDF",
    "gcse/science/aqa-synergy/4-F/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/science/AQA-84654F-SMS.PDF",
    "gcse/science/aqa-synergy/4-F/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/science/AQA-84654F-SMS.PDF",
    "gcse/science/aqa-synergy/1-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84651F-QP-JUN22.PDF",
    "gcse/science/aqa-synergy/1-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84651F-MS-JUN22.PDF",
    "gcse/science/aqa-synergy/1-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84651H-QP-JUN22.PDF",
    "gcse/science/aqa-synergy/1-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84651H-MS-JUN22.PDF",
    "gcse/science/aqa-synergy/2-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84652F-QP-JUN22.PDF",
    "gcse/science/aqa-synergy/2-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84652F-MS-JUN22.PDF",
    "gcse/science/aqa-synergy/2-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84652H-QP-JUN22.PDF",
    "gcse/science/aqa-synergy/2-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84652H-MS-JUN22.PDF",
    "gcse/science/aqa-synergy/3-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84653F-QP-JUN22.PDF",
    "gcse/science/aqa-synergy/3-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84653F-MS-JUN22.PDF",
    "gcse/science/aqa-synergy/3-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84653H-QP-JUN22.PDF",
    "gcse/science/aqa-synergy/3-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84653H-MS-JUN22.PDF",
    "gcse/science/aqa-synergy/4-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84654F-QP-JUN22.PDF",
    "gcse/science/aqa-synergy/4-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84654F-MS-JUN22.PDF",
    "gcse/science/aqa-synergy/4-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84654H-QP-JUN22.PDF",
    "gcse/science/aqa-synergy/4-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84654H-MS-JUN22.PDF",
    "gcse/science/aqa-synergy/1-F/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84651F-QP-NOV21.PDF",
    "gcse/science/aqa-synergy/1-F/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84651F-MS-NOV21.PDF",
    "gcse/science/aqa-synergy/1-H/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84651H-QP-NOV21.PDF",
    "gcse/science/aqa-synergy/1-H/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84651H-MS-NOV21.PDF",
    "gcse/science/aqa-synergy/2-F/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84652F-QP-NOV21.PDF",
    "gcse/science/aqa-synergy/2-F/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84652F-MS-NOV21.PDF",
    "gcse/science/aqa-synergy/2-H/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84652H-QP-NOV21.PDF",
    "gcse/science/aqa-synergy/2-H/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84652H-MS-NOV21.PDF",
    "gcse/science/aqa-synergy/3-F/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84653F-QP-NOV21.PDF",
    "gcse/science/aqa-synergy/3-F/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84653F-MS-NOV21.PDF",
    "gcse/science/aqa-synergy/3-H/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84653H-QP-NOV21.PDF",
    "gcse/science/aqa-synergy/3-H/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84653H-MS-NOV21.PDF",
    "gcse/science/aqa-synergy/4-F/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84654F-QP-NOV21.PDF",
    "gcse/science/aqa-synergy/4-F/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84654F-MS-NOV21.PDF",
    "gcse/science/aqa-synergy/4-H/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84654H-QP-NOV21.PDF",
    "gcse/science/aqa-synergy/4-H/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84654H-MS-NOV21.PDF",
    "gcse/science/aqa-synergy/1-F/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84651F-QP-NOV20.PDF",
    "gcse/science/aqa-synergy/1-F/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84651F-W-MS-NOV20.PDF",
    "gcse/science/aqa-synergy/1-H/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84651H-QP-NOV20.PDF",
    "gcse/science/aqa-synergy/1-H/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84651H-W-MS-NOV20.PDF",
    "gcse/science/aqa-synergy/2-F/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84652F-QP-NOV20.PDF",
    "gcse/science/aqa-synergy/2-F/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84652F-W-MS-NOV20.PDF",
    "gcse/science/aqa-synergy/2-H/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84652H-QP-NOV20.PDF",
    "gcse/science/aqa-synergy/2-H/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84652H-W-MS-NOV20.PDF",
    "gcse/science/aqa-synergy/3-F/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84653F-QP-NOV20.PDF",
    "gcse/science/aqa-synergy/3-F/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84653F-W-MS-NOV20.PDF",
    "gcse/science/aqa-synergy/3-H/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84653H-QP-NOV20.PDF",
    "gcse/science/aqa-synergy/3-H/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84653H-W-MS-NOV20.PDF",
    "gcse/science/aqa-synergy/4-F/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84654F-QP-NOV20.PDF",
    "gcse/science/aqa-synergy/4-F/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84654F-W-MS-NOV20.PDF",
    "gcse/science/aqa-synergy/4-H/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84654H-QP-NOV20.PDF",
    "gcse/science/aqa-synergy/4-H/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84654H-W-MS-NOV20.PDF",
    "gcse/science/aqa-synergy/3-F/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84653F-QP-JUN19.PDF",
    "gcse/science/aqa-synergy/3-F/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84653F-W-MS-JUN19.PDF",
    "gcse/science/aqa-synergy/3-H/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84653H-QP-JUN19.PDF",
    "gcse/science/aqa-synergy/3-H/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84653H-W-MS-JUN19.PDF",
    "gcse/science/aqa-synergy/3-F/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84653F-QP-JUN18.PDF",
    "gcse/science/aqa-synergy/3-F/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84653F-W-MS-JUN18.PDF",
    "gcse/science/aqa-synergy/3-H/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84653H-QP-JUN18.PDF",
    "gcse/science/aqa-synergy/3-H/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-84653H-W-MS-JUN18.PDF",
    "gcse/science/aqa-trilogy/1-F/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/5ed0c2d076d3c04cc2e01c7ef8315b748d8f1333.pdf",
    "gcse/science/aqa-trilogy/1-F/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/77037ca9cde84149f1174b4909e0f43ff44f75ea.pdf",
    "gcse/science/aqa-trilogy/1-H/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/97f6654b8733a2701cba8a9db798f98cdc3a1dbb.pdf",
    "gcse/science/aqa-trilogy/1-H/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/05ac00cd347f18c758afcd70bc2b3a570d56291d.pdf",
    "gcse/science/aqa-trilogy/2-F/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/d5c216ffd6450aec78300c9166d79dd2537a721f.pdf",
    "gcse/science/aqa-trilogy/2-F/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/c38befe7729fd28d0908164f2a4b5b48109633a5.pdf",
    "gcse/science/aqa-trilogy/2-H/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/282181702dbf9c207c25427b6b7b289b5ea821c6.pdf",
    "gcse/science/aqa-trilogy/2-H/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/249582f30c3ff8adc8245b178df4cd57c23a2d40.pdf",
    "gcse/science/aqa-trilogy/3-F/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/9425f674c6f7eaa59fcb98f22692447f3dd1c3d2.pdf",
    "gcse/science/aqa-trilogy/3-F/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/066ff879d480308086cbe3cea3b1922ba033189d.pdf",
    "gcse/science/aqa-trilogy//undefined-ins/ins.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/5abd249f27365afc0117e0b42640632fbf1fafa3.pdf",
    "gcse/science/aqa-trilogy/3-H/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/2716839f7b6fe83f6680a1a68f5d705a7c7164a8.pdf",
    "gcse/science/aqa-trilogy/3-H/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/1a124f614e967008b76eed4af8b2f81e70c9ac6b.pdf",
    "gcse/science/aqa-trilogy/4-F/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/ee4fe8d887440747fae63609d4801ad81ea749da.pdf",
    "gcse/science/aqa-trilogy/4-F/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/ae3480eed74f5298a6e92b2fb84f773472a817e7.pdf",
    "gcse/science/aqa-trilogy/4-H/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/ac346c22d1d8e93d8288d3c17503148c722abfdb.pdf",
    "gcse/science/aqa-trilogy/4-H/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/4d75180f7fe02c8e23d72cc5594136eb6b89ab94.pdf",
    "gcse/science/aqa-trilogy/5-F/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/24579d8104a03f067c74c68f3a27ba8ce4582e32.pdf",
    "gcse/science/aqa-trilogy/5-F/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/c7a82fd58b00e15df582e64080b1a17852f08b47.pdf",
    "gcse/science/aqa-trilogy/5-H/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/a894d51fe40d8d6ce631d031e13928e2e74a9d38.pdf",
    "gcse/science/aqa-trilogy/5-H/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/e9e10f6c348efe3081189ffe7f4510da908620bc.pdf",
    "gcse/science/aqa-trilogy/6-F/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/c7e263d8dffeaad477f0523cc0eba410cc309758.pdf",
    "gcse/science/aqa-trilogy/6-F/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/b089c9e56d8872b032a80f0c014e3d45266ff691.pdf",
    "gcse/science/aqa-trilogy/6-H/18-spec/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/97f1d201c9a5539c54c32417177f744cfb45dd82.pdf",
    "gcse/science/aqa-trilogy/6-H/18-spec/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/0055f8f1d01dad14f4d7ea73bc56fa7dece322a5.pdf",
    "gcse/science/aqa-trilogy/1-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8464P1F-QP-JUN23.PDF",
    "gcse/science/aqa-trilogy/1-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8464P1F-MS-JUN23.PDF",
    "gcse/science/aqa-trilogy/1-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8464P1H-QP-JUN23.PDF",
    "gcse/science/aqa-trilogy/1-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8464P1H-MS-JUN23.PDF",
    "gcse/science/aqa-trilogy/2-F/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8464P2F-QP-JUN23.PDF",
    "gcse/science/aqa-trilogy/2-F/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8464P2F-MS-JUN23.PDF",
    "gcse/science/aqa-trilogy/2-H/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8464P2H-QP-JUN23.PDF",
    "gcse/science/aqa-trilogy/2-H/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-8464P2H-MS-JUN23.PDF",
    "gcse/science/aqa-trilogy/1-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8464P1F-QP-JUN22.PDF",
    "gcse/science/aqa-trilogy/1-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8464P1F-MS-JUN22.PDF",
    "gcse/science/aqa-trilogy/1-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8464P1H-QP-JUN22.PDF",
    "gcse/science/aqa-trilogy/1-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8464P1H-MS-JUN22.PDF",
    "gcse/science/aqa-trilogy/2-F/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8464P2F-QP-JUN22.PDF",
    "gcse/science/aqa-trilogy/2-F/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8464P2F-MS-JUN22.PDF",
    "gcse/science/aqa-trilogy/2-H/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8464P2H-QP-JUN22.PDF",
    "gcse/science/aqa-trilogy/2-H/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-8464P2H-MS-JUN22.PDF",
    "gcse/science/aqa-trilogy/1-F/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8464P1F-QP-NOV21.PDF",
    "gcse/science/aqa-trilogy/1-F/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8464P1F-MS-NOV21.PDF",
    "gcse/science/aqa-trilogy/1-H/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8464P1H-QP-NOV21.PDF",
    "gcse/science/aqa-trilogy/1-H/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8464P1H-MS-NOV21.PDF",
    "gcse/science/aqa-trilogy/2-F/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8464P2F-QP-NOV21.PDF",
    "gcse/science/aqa-trilogy/2-F/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8464P2F-MS-NOV21.PDF",
    "gcse/science/aqa-trilogy/2-H/21-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8464P2H-QP-NOV21.PDF",
    "gcse/science/aqa-trilogy/2-H/21-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-8464P2H-MS-NOV21.PDF",
    "gcse/science/aqa-trilogy/1-F/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8464P1F-QP-NOV20.PDF",
    "gcse/science/aqa-trilogy/1-F/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8464P1F-W-MS-NOV20.PDF",
    "gcse/science/aqa-trilogy/1-H/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8464P1H-QP-NOV20.PDF",
    "gcse/science/aqa-trilogy/1-H/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8464P1H-W-MS-NOV20.PDF",
    "gcse/science/aqa-trilogy/2-F/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8464P2F-QP-NOV20.PDF",
    "gcse/science/aqa-trilogy/2-F/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8464P2F-W-MS-NOV20.PDF",
    "gcse/science/aqa-trilogy/2-H/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8464P2H-QP-NOV20.PDF",
    "gcse/science/aqa-trilogy/2-H/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-8464P2H-W-MS-NOV20.PDF",
    "gcse/science/aqa-trilogy/1-F/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-8464P1F-QP-JUN19.PDF",
    "gcse/science/aqa-trilogy/1-F/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-8464P1F-W-MS-JUN19.PDF",
    "gcse/science/aqa-trilogy/1-H/19-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-8464P1H-QP-JUN19.PDF",
    "gcse/science/aqa-trilogy/1-H/19-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-8464P1H-W-MS-JUN19.PDF",
    "gcse/science/aqa-trilogy/2-F/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Combined-Science-Foundation-Physics-Paper-2-QP.pdf",
    "gcse/science/aqa-trilogy/2-F/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Combined-Science-Foundation-Physics-Paper-2-MS.pdf",
    "gcse/science/aqa-trilogy/2-H/19-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Combined-Science-Higher-Physics-Paper-2-QP.pdf",
    "gcse/science/aqa-trilogy/2-H/19-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2021/09/AQA-GCSE-Combined-Science-Higher-Physics-Paper-2-MS.pdf",
    "gcse/science/aqa-trilogy/1-F/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-Combined-Science-Trilogy-Physics-Foundation-Paper-1-2018.pdf",
    "gcse/science/aqa-trilogy/1-F/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-Combined-Science-Trilogy-Physics-Foundation-Paper-1-2018-Mark-Scheme.pdf",
    "gcse/science/aqa-trilogy/1-H/18-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-8464P1H-QP-JUN18.PDF",
    "gcse/science/aqa-trilogy/1-H/18-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2018/june/AQA-8464P1H-W-MS-JUN18.PDF",
    "gcse/science/aqa-trilogy/2-F/18-jun/qp.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-Combined-Science-Trilogy-Physics-Foundation-Paper-2-2018.pdf",
    "gcse/science/aqa-trilogy/2-F/18-jun/ms.PDF":
      "https://mmerevise.co.uk/app/uploads/2023/08/AQA-GCSE-Combined-Science-Trilogy-Physics-Foundation-Paper-2-2018-Mark-Scheme.pdf",
    "gcse/science/aqa-trilogy/2-H/18-jun/qp.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/3d29cf05ec3a905ad443a77014a6ce234c40183d.pdf",
    "gcse/science/aqa-trilogy/2-H/18-jun/ms.PDF":
      "https://cdn.sanity.io/files/p28bar15/green/4e8bc7e0604ae78cbf2c329008d9e7c44508516b.pdf",
    "gcse/sociology/aqa/1/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/sociology/AQA-81921-SQP.PDF",
    "gcse/sociology/aqa/1/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/sociology/AQA-81921-SMS.PDF",
    "gcse/sociology/aqa/2/18-spec/qp.PDF":
      "https://filestore.aqa.org.uk/resources/sociology/AQA-81922-SQP-CR.PDF",
    "gcse/sociology/aqa/2/18-spec/ms.PDF":
      "https://filestore.aqa.org.uk/resources/sociology/AQA-81922-SMS.PDF",
    "gcse/sociology/aqa/1/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81921-QP-JUN23.PDF",
    "gcse/sociology/aqa/1/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81921-MS-JUN23.PDF",
    "gcse/sociology/aqa/2/23-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81922-QP-JUN23-CR.PDF",
    "gcse/sociology/aqa/2/23-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-81922-MS-JUN23.PDF",
    "gcse/sociology/aqa/1/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81921-QP-JUN22.PDF",
    "gcse/sociology/aqa/1/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81921-MS-JUN22.PDF",
    "gcse/sociology/aqa/2/22-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81922-QP-JUN22.PDF",
    "gcse/sociology/aqa/2/22-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-81922-MS-JUN22.PDF",
    "gcse/sociology/aqa/1/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81921-QP-NOV21.PDF",
    "gcse/sociology/aqa/1/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81921-MS-NOV21.PDF",
    "gcse/sociology/aqa/2/21-nov/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81922-QP-NOV21.PDF",
    "gcse/sociology/aqa/2/21-nov/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-81922-MS-NOV21.PDF",
    "gcse/sociology/aqa/1/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81921-QP-NOV20.PDF",
    "gcse/sociology/aqa/1/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81921-W-MS-NOV20.PDF",
    "gcse/sociology/aqa/2/20-jun/qp.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81922-QP-NOV20.PDF",
    "gcse/sociology/aqa/2/20-jun/ms.PDF":
      "https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-81922-W-MS-NOV20.PDF",
    "gcse/sociology/aqa/1/19-jun/qp.PDF":
      "https://pastpapers.co/aqa/GCSE/Sociology-8192/AQA-81921-QP-JUN19.pdf",
    "gcse/sociology/aqa/1/19-jun/ms.PDF":
      "https://pastpapers.co/aqa/GCSE/Sociology-8192/AQA-81921-W-MS-JUN19.pdf",
    "gcse/sociology/aqa/2/19-jun/qp.PDF":
      "https://pastpapers.co/aqa/GCSE/Sociology-8192/AQA-81922-QP-JUN19.pdf",
    "gcse/sociology/aqa/2/19-jun/ms.PDF":
      "https://pastpapers.co/aqa/GCSE/Sociology-8192/AQA-81922-W-MS-JUN19.pdf",
  };

  return (
    <>
      <style>{seeSS}</style>

      <div className="exams-flex">
        <div className="sidebar sidebar-left">
          {paperTypeEnabled ? (
            <div className="fade-in">
              <p>
                <b>Ads</b>
              </p>
              <img src={meat} alt="Meat crisps" />
            </div>
          ) : (
            <></>
          )}
        </div>

        <div className="centrebar">
          {/* <button onClick={handleCookie}>Set Cookie</button> 
		<button onClick={localStorage.setItem("ruff", "true")}>Set LocalStorage</button>

		<div className="buttonnn" onClick={() => setCount(!count)} style={{color: count ? 'green' : 'red'}}>Toggle</div> */}

          <div className="bg-box-parent">
            {" "}
            {/* Background box */}
            <div
              className="box select-box"
              id="bg-box-1"
              style={{ height: box1Height }}
            ></div>
            <div
              style={{
                position: "relative",
                margin: "0px auto",
                width: "30px",
              }}
            >
              <div className="triangle"></div>
            </div>
          </div>
          <div className="box select-box" id="select-box-1">
            <div>
              {/* Qualifications - dropdown header */}
              <button
                className="qual-select"
                style={{ transform: "translateY(0px)", paddingTop: "14px" }}
                onClick={() => {
                  setToggleQual(!toggleQual);
                  resetTogglesExcept(1);
                }}
                role="checkbox"
                aria-checked={toggleQual}
                aria-labelledby="chk-qual-label"
              >
                {qualName} {/* cookies.user */}{" "}
                <img
                  className="dropdown-img"
                  src={dropdown}
                  style={{
                    transform: toggleQual
                      ? "translate(3px, -3px) rotate(180deg)"
                      : "translate(3px, -3px)",
                  }}
                  alt="Dropdown icon"
                />
              </button>
              <label id="chk-qual-label" style={{ display: "none" }}>
                Current qualification: {qualName}. Press this to toggle whether
                Qualification selection (e.g. GCSE, A-Level) is open or not.
              </label>

              {/* Qualifications */}
              <div
                className="choice-div"
                style={{ display: toggleQual ? "block" : "none" }}
              >
                {props.qualData.map((item) => {
                  return item.url !== "as" ? ( // create newline for as/a-level/ial
                    <NavLink
                      className="grid-item"
                      key={item.id}
                      to={item.url}
                      onClick={() => {
                        setToggleQual(!toggleQual);
                        setToggleSubj(true);
                        setQualName(item.name);
                        setQualNum(item.id);
                        setSubjColour("#eec9e8");
                        resetFields(3);
                        setSubjEnabled(true);
                        setExamBoardEnabled(false);
                        setPaperTypeEnabled(false);
                      }}
                    >
                      <div className="qual-title qual-title-pink">
                        {item.name}
                      </div>
                    </NavLink>
                  ) : (
                    <>
                      <br />
                      <NavLink
                        className="grid-item"
                        key={item.id}
                        to={item.url}
                        onClick={() => {
                          setToggleQual(!toggleQual);
                          setToggleSubj(true);
                          setQualName(item.name);
                          setQualNum(item.id);
                          setSubjColour("#eec9e8");
                          resetFields(3);
                          setSubjEnabled(true);
                          setExamBoardEnabled(false);
                          setPaperTypeEnabled(false);
                        }}
                      >
                        <div className="qual-title qual-title-pink">
                          {item.name}
                        </div>
                      </NavLink>
                    </>
                  );
                })}
              </div>
            </div>

            <hr />

            <div>
              {/* Subjects - dropdown header */}
              <button
                className="qual-select"
                style={{ paddingTop: "6px" }}
                onClick={() => {
                  setToggleSubj(!toggleSubj);
                  resetTogglesExcept(2);
                }}
                role="checkbox"
                aria-checked={toggleSubj}
                aria-labelledby="chk-subj-label"
              >
                <span style={{ color: subjEnabled ? "black" : "lightgrey" }}>
                  <span
                    className="subj-circle subj-circle-title"
                    style={{ color: subjColour }}
                  >
                    •
                  </span>
                  {subjName}
                </span>{" "}
                <img
                  className="dropdown-img"
                  src={dropdown}
                  style={{
                    transform: toggleSubj
                      ? "translate(3px, -3px) rotate(180deg)"
                      : "translate(3px, -3px)",
                    display: subjEnabled ? "inline" : "none",
                  }}
                  alt="Dropdown icon"
                />
              </button>
              <label id="chk-subj-label" style={{ display: "none" }}>
                Current subject: {subjName}. Press this to toggle whether
                Subject selection (e.g. Maths, English, Sciences) is open or
                not.
              </label>

              {/* Subjects */}
              <div
                className="choice-div"
                style={{ display: toggleSubj ? "block" : "none" }}
              >
                {subjDataFilter.map((item) => (
                  <NavLink
                    className="grid-item"
                    key={item.id}
                    to={getUrlPath(loc_parts, 1, item.url)}
                    onClick={() => {
                      setToggleSubj(!toggleSubj);
                      setToggleBoard(true);
                      setSubjName(item.name);
                      setSubjNum(item.id);
                      setSubjColour(colourDict[item.colour]);
                      resetFields(2);
                      setExamBoardEnabled(true);
                      setPaperTypeEnabled(false);
                    }}
                  >
                    <div className="qual-title subj-title">
                      {" "}
                      <span
                        className="subj-circle"
                        style={{ color: colourDict[item.colour] }}
                      >
                        •
                      </span>{" "}
                      {item.name}{" "}
                    </div>
                  </NavLink>
                ))}
              </div>
            </div>
          </div>

          <div className="bg-box-parent">
            <div
              className="box select-box bg-box-2"
              style={{
                background: "white",
                height: box2Height,
                boxShadow: "none",
              }}
            ></div>
            <div
              className="box select-box bg-box-2"
              style={{
                display: showBoxN(loc_parts[2]) ? "block" : "block",
                background: subjColour.concat("80"),
                height: box2Height,
              }}
            ></div>
            <div
              style={{
                position: "relative",
                margin: "0px auto",
                width: "30px",
              }}
            >
              <div className="triangle" style={{ background: "white" }}></div>
              <div
                className="triangle"
                style={{ background: subjColour.concat("80") }}
              ></div>
            </div>
          </div>
          <div className="box select-box" id="select-box-2">
            <div>
              {/* Exam Boards - Dropdown      style={{visibility: showBoxN(loc_parts[2]) ? 'visible' : 'hidden'}}   */}
              <button
                className="qual-select"
                style={{ paddingTop: "23px" }}
                onClick={() => {
                  setToggleBoard(!toggleBoard);
                  resetTogglesExcept(3);
                }}
                role="checkbox"
                aria-checked={toggleBoard}
                aria-labelledby="chk-exam-board-label"
              >
                <span style={{ opacity: examBoardEnabled ? 1 : 0.2 }}>
                  {examBoardName}
                </span>{" "}
                <img
                  className="dropdown-img"
                  src={dropdown}
                  style={{
                    transform: toggleBoard
                      ? "translate(3px, -3px) rotate(180deg)"
                      : "translate(3px, -3px)",
                    display: examBoardEnabled ? "inline" : "none",
                  }}
                  alt="Dropdown icon"
                />
              </button>
              <label id="chk-exam-board-label" style={{ display: "none" }}>
                Current exam board: {examBoardName}. Press this to toggle
                whether Exam Board selection (e.g. AQA, Edexcel, OCR) is open or
                not.
              </label>

              {/* Exam Boards */}
              <div
                className="choice-div"
                style={{ display: toggleBoard ? "block" : "none" }}
              >
                {examBoardDataFilter.map((item) => (
                  <NavLink
                    className="grid-item"
                    key={item.id}
                    to={getUrlPath(loc_parts, 2, item.url)}
                    onClick={() => {
                      window.gtag("event", "conversion", {
                        send_to: "AW-10904777324/xJOGCN3vt74DEOzk5s8o",
                      });
                      setToggleBoard(!toggleBoard);
                      setExamBoardName(item.name);
                      setExamBoardNum(item.id);
                      resetFields(1);
                      setPaperTypeEnabled(true);
                      allPapersFunctionClick(item.id);
                    }}
                  >
                    {" "}
                    {/* papersFromServer("uk/"+loc_parts[1]+"/"+loc_parts[2]+"/"+item.url+"/"); */}
                    <div className="qual-title board-title">{item.name}</div>
                  </NavLink>
                ))}
              </div>
            </div>

            <hr />

            <div>
              <div className="qual-select" style={{ paddingTop: "5px" }}>
                <span
                  className="papertype-flex"
                  style={{ opacity: paperTypeEnabled ? 1 : 0.2 }}
                >
                  {/* Bookmark button */}
                  <button
                    role="checkbox"
                    aria-checked={props.usePersStatesPaperType[paperTypeNum][0]}
                    aria-labelledby="chk1-label"
                    className="papertype-flex-item"
                    onClick={
                      Cookies.get("rcl_consent_given")
                        ? () => {
                            props.usePersStatesPaperType[paperTypeNum][1](
                              !props.usePersStatesPaperType[paperTypeNum][0],
                            );
                          }
                        : undefined
                    }
                    alt="Add or remove this set of papers from the Bookmarks page"
                  >
                    {" "}
                    {/* This is just: setBookmarkToggle(!bookmarkToggle) */}
                    {/* {paperTypeNum} // for testing whether 'all papers' bookmark has id of 'All PaperZ' */}
                    {props.usePersStatesPaperType[paperTypeNum][0] &&
                    paperTypeEnabled ? (
                      <svg
                        className="bookmark-menu"
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="41.2px"
                        height="60.5px"
                        viewBox="0 0 41.2 60.5"
                        xmlSpace="preserve"
                      >
                        <g>
                          <path
                            fill="#000000"
                            d="M37,58L22.2,41.9c-0.8-0.9-2.1-0.9-2.9,0L4.2,58.1C3.4,58.9,2,58.4,2,57.2V9.5C2,5.3,5.3,2,9.5,2h22.3
												c4.1,0,7.5,3.3,7.5,7.5v47.7C39.2,58.3,37.8,58.9,37,58z"
                          />
                          <path
                            fill="#000000"
                            d="M3.3,60.5c-0.8,0-1.6-0.3-2.2-0.9c-0.7-0.6-1-1.5-1-2.4V9.5C0,4.3,4.3,0,9.5,0h22.3c5.2,0,9.5,4.3,9.5,9.5
												v47.7c0,1.8-1.5,3.3-3.3,3.3c-0.9,0-1.8-0.4-2.4-1.1L20.7,43.2L5.6,59.4C5,60.1,4.2,60.5,3.3,60.5z M9.5,4C6.5,4,4,6.5,4,9.5v45.9
												l13.8-14.8c0.8-0.8,1.8-1.3,2.9-1.3c1.1,0,2.2,0.5,2.9,1.3l13.6,14.7V9.5c0-3-2.5-5.5-5.5-5.5H9.5z"
                          />
                        </g>
                      </svg>
                    ) : (
                      <svg
                        className="bookmark-menu"
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="41.2px"
                        height="60.5px"
                        viewBox="0 0 41.2 60.5"
                        xmlSpace="preserve"
                      >
                        <path
                          fill="#000000"
                          d="M3.3,60.5c-0.8,0-1.6-0.3-2.2-0.9c-0.7-0.6-1-1.5-1-2.4V9.5C0,4.3,4.3,0,9.5,0h22.3c5.2,0,9.5,4.3,9.5,9.5
											v47.7c0,1.8-1.5,3.3-3.3,3.3c-0.9,0-1.8-0.4-2.4-1.1L20.7,43.2L5.6,59.4C5,60.1,4.2,60.5,3.3,60.5z M9.5,4C6.5,4,4,6.5,4,9.5v45.9
											l13.8-14.8c0.8-0.8,1.8-1.3,2.9-1.3c1.1,0,2.2,0.5,2.9,1.3l13.6,14.7V9.5c0-3-2.5-5.5-5.5-5.5H9.5z"
                        />
                      </svg>
                    )}
                  </button>
                  <label id="chk1-label" style={{ display: "none" }}>
                    Add or remove this set of papers from the Bookmarks page
                  </label>

                  <button
                    className="papertype-flex-item"
                    onClick={() => {
                      setTogglePaper(!togglePaper);
                      resetTogglesExcept(4);
                    }}
                    role="checkbox"
                    aria-checked={togglePaper}
                    aria-labelledby="chk-papertype-label"
                    style={{ marginTop: "-6.5px" }}
                  >
                    <span className="papertype-name">
                      <span>{paperTypeName}</span>
                    </span>
                    <img
                      className="dropdown-img"
                      src={dropdown}
                      style={{
                        transform: togglePaper
                          ? "translate(8px, -3px) rotate(180deg)"
                          : "translate(8px, -3px)",
                        display: paperTypeEnabled ? "inline" : "none",
                      }}
                      alt="Dropdown icon"
                    />
                  </button>

                  <label id="chk-papertype-label" style={{ display: "none" }}>
                    Current set of papers: {paperTypeName}. Press this to toggle
                    whether Paper set selection (e.g. Paper 1, Paper 2, All
                    Papers) is open or not.
                  </label>
                </span>
              </div>

              {/* Papertypes */}
              <div
                style={{ display: showBoxN(loc_parts[3]) ? "block" : "none" }}
              >
                <div
                  className="choice-div choice-div-papertypes"
                  style={{ display: togglePaper ? "block" : "none" }}
                >
                  <NavLink
                    className="grid-item"
                    key="0"
                    to={getUrlPath(loc_parts, 3, "")}
                    onClick={() => {
                      setTogglePaper(!togglePaper);
                      setPaperTypeName("All papers");
                      setPaperTypeNum(0);
                      setPapersFiltered(false);
                      allPapersFunctionClick(examBoardNum);
                    }}
                  >
                    {" "}
                    {/* allPapersFunctionClick(examBoardNum) */}
                    <div className="qual-title papertype-title papertype-title-allpapers">
                      All papers
                    </div>
                  </NavLink>

                  {paperTypeDataFilter.map((item) => (
                    <NavLink
                      className="grid-item"
                      key={item.id}
                      to={getUrlPathHash(
                        loc_parts,
                        3,
                        item.url.replace("-", ""),
                      )}
                      onClick={() => {
                        setTogglePaper(!togglePaper);
                        setPaperTypeUrl(item.url.replace("-", ""));
                        setPaperTypeName(item.name);
                        setPaperTypeNum(item.id);
                        setPapersFiltered(true);
                      }}
                    >
                      <div className="qual-title papertype-title">
                        {item.name}
                      </div>
                    </NavLink>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* <div className="how-to" style={{display: showBoxN(loc_parts[3]) ? 'none' : 'block' }}>Get papers by selecting above!</div> */}

          <div
            className="box box-papers shadow-filter"
            style={{
              display: "block",
              background: subjColour,
              padding: "15px 0 7px 0px",
              marginBottom: "65px",
            }}
          >
            <div
              style={{
                position: "relative",
                margin: "0px auto",
                width: "30px",
                zIndex: -10,
              }}
            >
              <div
                className="triangle"
                style={{
                  background: subjColour,
                  transform: "scaleX(1.4) translateY(-23px) rotate(45deg)",
                }}
              ></div>
            </div>
            {/*
			<svg style={{width: '200px', opacity: '0.3', position: 'absolute', left: '30%', top: '20px'}} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				 viewBox="0 0 103.8 82.9"  xmlSpace="preserve">
				<path fill="none" stroke="#FFFFFF" stroke-width="4" stroke-miterlimit="10" d="M60.2,70.6l-30.1,9.8c-4.8,1.6-10-1.1-11.6-5.9
					L2.4,24.9c-1.6-4.8,1.1-10,5.9-11.6l30.1-9.8C43.2,2,48.4,4.7,50,9.5L66.1,59C67.7,63.8,65,69,60.2,70.6z"/>
				<path fill="none" stroke="#FFFFFF" stroke-width="4" stroke-miterlimit="10" d="M45.8,4.3l1.3,0l20.5,0.1c5.1,0,9.2,4.2,9.2,9.2
					l-0.2,52.1c0,5.1-4.2,9.2-9.2,9.2L47,74.8"/>
				<path fill="none" stroke="#FFFFFF" stroke-width="4" stroke-miterlimit="10" d="M30,6.5c0.4-0.4,0.9-0.7,1.4-1
					c1.4-0.8,3-1.3,4.6-1.3"/>
				<path fill="none" stroke="#FFFFFF" stroke-width="4" stroke-miterlimit="10" d="M56.3,4.7c0.4-0.4,0.9-0.8,1.4-1.2
					c2.3-1.6,5.4-2,8.2-1l29.8,10.6c4.8,1.7,7.3,7,5.6,11.7L83.9,74c-1.7,4.8-7,7.3-11.7,5.6l-10.5-3.7l-1.8-0.6"/>
			</svg>
			*/}
            <div
              className="how-to"
              style={{ display: showBoxN(loc_parts[3]) ? "none" : "block" }}
            >
              Get{" "}
              <span>
                {qualNum ? qualName : ""} {subjNum ? subjName : ""} past papers
              </span>{" "}
              by selecting above!
            </div>

            <div
              style={{
                display:
                  showBoxN(loc_parts[3]) && props.loadingPapers
                    ? "block"
                    : "none",
              }}
            >
              Loading past papers...
            </div>

            <div
              style={{
                display:
                  showBoxN(loc_parts[3]) && !props.loadingPapers
                    ? "block"
                    : "none",
              }}
            >
              {papersFiltered ? (
                <>
                  {/* Papers ARE Filtered (e.g. 1-H) */}
                  <div className="papertype-box">
                    {props.paperData.papers
                      .filter(
                        (item) =>
                          item.id ===
                          "papers/uk/" +
                            loc_parts[1] +
                            "/" +
                            loc_parts[2] +
                            "/" +
                            loc_parts[3],
                      )
                      .map((item) => (
                        <>
                          {item.pprtypes
                            .filter(
                              (item) =>
                                item.pprtype.replace("-", "") === paperTypeUrl,
                            )
                            .map((item) => (
                              <>
                                {item["yr-months"].map((item) => (
                                  <>
                                    <div className="paper-pill-2-around">
                                      <div
                                        key={item.id}
                                        className="paper-pill-2"
                                      ></div>
                                    </div>

                                    <div className="papers-slide-parent">
                                      {item.papers.map((it, index) => {
                                        let url = it["url"];

                                        // remove urlStart from beginnning of url
                                        const urlEnd = url.replace(
                                          urlStart,
                                          "",
                                        );

                                        if (aqaMap[urlEnd]) {
                                          url = aqaMap[urlEnd];
                                        }

                                        return (
                                          <div key={index} className="ppr">
                                            {/* // Pre-txt papers:
                                              <div>
                                              <a href={"https://examoo.s3.eu-west-2.amazonaws.com/"+item.id+it} target="_blank">
                                                  <div><span>{paperDict[it]}</span></div>
                                                  <div></div>
                                                  <div></div> 
                                              </a>
                                              </div>
                                              */}

                                            <div>
                                              <a href={url} target="_blank">
                                                <div>
                                                  <img
                                                    style={{
                                                      width: "90%",
                                                      marginTop: "4px",
                                                    }}
                                                    src={
                                                      `${process.env.PUBLIC_URL}/img/` +
                                                      it["name"] +
                                                      ".svg"
                                                    }
                                                    alt={
                                                      qualName +
                                                      " " +
                                                      subjName +
                                                      " " +
                                                      examBoardName +
                                                      " " +
                                                      paperTypeName +
                                                      " " +
                                                      paperDict[it["name"]] +
                                                      " " +
                                                      item.yr +
                                                      " " +
                                                      item.month
                                                    }
                                                  />
                                                </div>{" "}
                                                {/* {paperDict[it['name']]} */}
                                                <div></div>
                                                <div></div>
                                              </a>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>

                                    <div
                                      style={{
                                        background: "#00000080",
                                        width: "90%",
                                        margin: "0px auto 20px auto",
                                        color: "white",
                                        height: "45px",
                                        position: "relative",
                                        borderRadius: "0px 0px 20px 20px",
                                      }}
                                    >
                                      <span>
                                        <span
                                          style={{
                                            position: "absolute",
                                            left: "15px",
                                          }}
                                        >
                                          <span>{item.yr}</span>
                                          <span className="month-style">
                                            {item.month.toUpperCase()}
                                          </span>
                                        </span>

                                        <span
                                          style={{
                                            position: "absolute",
                                            right: "15px",
                                          }}
                                        >
                                          <span>
                                            <img
                                              style={{
                                                height: "30px",
                                                opacity: "0.3",
                                                transform:
                                                  "translate(16px, -6.5px)",
                                              }}
                                              src={vertical}
                                              alt="Small vertical line"
                                            />
                                          </span>

                                          <button
                                            onClick={
                                              Cookies.get("rcl_consent_given")
                                                ? () => {
                                                    props.usePersStatesPaperYear[
                                                      item.id
                                                    ][1](
                                                      !props
                                                        .usePersStatesPaperYear[
                                                        item.id
                                                      ][0],
                                                    );
                                                  }
                                                : undefined
                                            }
                                            role="checkbox"
                                            aria-checked={
                                              props.usePersStatesPaperYear[
                                                item.id
                                              ][0]
                                            }
                                            aria-labelledby="chk-tick-label"
                                          >
                                            {props.usePersStatesPaperYear[
                                              item.id
                                            ][0] ? (
                                              <svg
                                                className="tick-onoff"
                                                style={{
                                                  background: "#63D771",
                                                }}
                                                version="1.1"
                                                id="Layer_1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 75.8 56.9"
                                                xmlSpace="preserve"
                                              >
                                                <rect
                                                  x="12.6"
                                                  y="15.8"
                                                  transform="matrix(0.7071 -0.7071 0.7071 0.7071 -20.0908 25.0116)"
                                                  fill="#FFFFFF"
                                                  width="15.2"
                                                  height="41.8"
                                                />
                                                <rect
                                                  x="39.8"
                                                  y="-4.2"
                                                  transform="matrix(0.7071 0.7071 -0.7071 0.7071 33.986 -25.1457)"
                                                  fill="#FFFFFF"
                                                  width="15.2"
                                                  height="65.3"
                                                />
                                              </svg>
                                            ) : (
                                              <svg
                                                className="tick-onoff"
                                                version="1.1"
                                                id="Layer_1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 75.8 56.9"
                                                xmlSpace="preserve"
                                              >
                                                <rect
                                                  x="12.6"
                                                  y="15.8"
                                                  transform="matrix(0.7071 -0.7071 0.7071 0.7071 -20.0908 25.0116)"
                                                  fill="#FFFFFF"
                                                  width="15.2"
                                                  height="41.8"
                                                />
                                                <rect
                                                  x="39.8"
                                                  y="-4.2"
                                                  transform="matrix(0.7071 0.7071 -0.7071 0.7071 33.986 -25.1457)"
                                                  fill="#FFFFFF"
                                                  width="15.2"
                                                  height="65.3"
                                                />
                                              </svg>
                                            )}
                                          </button>
                                          <label
                                            id="chk-tick-label"
                                            style={{ display: "none" }}
                                          >
                                            Toggle to save whether or not you
                                            have completed the papers from this
                                            year.
                                          </label>
                                        </span>
                                      </span>
                                    </div>
                                  </>
                                ))}
                              </>
                            ))}
                        </>
                      ))}
                  </div>
                </>
              ) : (
                <>
                  {/* Papers NOT Filtered (i.e. all papers here) */}

                  {paperTypeDataFilter.map((item0) => (
                    <div
                      className="papertype-box"
                      style={{ paddingBottom: "1px" }}
                    >
                      <div className="qual-title-papers">{item0.name}</div>

                      {props.paperData.papers
                        .filter(
                          (item) =>
                            item.id ===
                            "papers/uk/" +
                              loc_parts[1] +
                              "/" +
                              loc_parts[2] +
                              "/" +
                              loc_parts[3],
                        )
                        .map((item) => (
                          <>
                            {item.pprtypes
                              .filter((item) => item.pprtype === item0.url)
                              .map((item) => (
                                <>
                                  {item["yr-months"].map((item) => (
                                    <>
                                      <div className="paper-pill-2-around">
                                        <div
                                          key={item.id}
                                          className="paper-pill-2"
                                        ></div>
                                      </div>

                                      <div className="papers-slide-parent">
                                        {item.papers.map((it, index) => {
                                          let url = it["url"];

                                          // remove urlStart from beginnning of url
                                          const urlEnd = url.replace(
                                            urlStart,
                                            "",
                                          );

                                          if (aqaMap[urlEnd]) {
                                            url = aqaMap[urlEnd];
                                          }

                                          return (
                                            <div key={index} className="ppr">
                                              <div>
                                                <a href={url} target="_blank">
                                                  <div>
                                                    <img
                                                      style={{
                                                        width: "90%",
                                                        marginTop: "4px",
                                                      }}
                                                      src={
                                                        `${process.env.PUBLIC_URL}/img/` +
                                                        it["name"] +
                                                        ".svg"
                                                      }
                                                      alt={
                                                        qualName +
                                                        " " +
                                                        subjName +
                                                        " " +
                                                        examBoardName +
                                                        " " +
                                                        paperTypeName +
                                                        " " +
                                                        paperDict[it["name"]] +
                                                        " " +
                                                        item.yr +
                                                        " " +
                                                        item.month
                                                      }
                                                    />
                                                  </div>{" "}
                                                  {/* {paperDict[it['name']]} */}
                                                  <div></div>
                                                  <div></div>
                                                </a>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>

                                      <div
                                        style={{
                                          background: "#00000080",
                                          width: "90%",
                                          margin: "0px auto 20px auto",
                                          color: "white",
                                          height: "45px",
                                          position: "relative",
                                          borderRadius: "0px 0px 20px 20px",
                                        }}
                                      >
                                        <span>
                                          <span
                                            style={{
                                              position: "absolute",
                                              left: "15px",
                                            }}
                                          >
                                            <span>{item.yr}</span>
                                            <span className="month-style">
                                              {item.month.toUpperCase()}
                                            </span>
                                          </span>

                                          <span
                                            style={{
                                              position: "absolute",
                                              right: "15px",
                                            }}
                                          >
                                            <span>
                                              <img
                                                style={{
                                                  height: "30px",
                                                  opacity: "0.3",
                                                  transform:
                                                    "translate(16px, -6.5px)",
                                                }}
                                                src={vertical}
                                                alt="Small vertical line"
                                              />
                                            </span>

                                            <button
                                              onClick={
                                                Cookies.get("rcl_consent_given")
                                                  ? () => {
                                                      props.usePersStatesPaperYear[
                                                        item.id
                                                      ][1](
                                                        !props
                                                          .usePersStatesPaperYear[
                                                          item.id
                                                        ][0],
                                                      );
                                                    }
                                                  : undefined
                                              }
                                              role="checkbox"
                                              aria-checked={
                                                props.usePersStatesPaperYear[
                                                  item.id
                                                ][0]
                                              }
                                              aria-labelledby="chk-tick-label-2"
                                            >
                                              {props.usePersStatesPaperYear[
                                                item.id
                                              ][0] ? (
                                                <svg
                                                  className="tick-onoff"
                                                  style={{
                                                    background: "#63D771",
                                                  }}
                                                  version="1.1"
                                                  id="Layer_1"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                                  x="0px"
                                                  y="0px"
                                                  viewBox="0 0 75.8 56.9"
                                                  xmlSpace="preserve"
                                                >
                                                  <rect
                                                    x="12.6"
                                                    y="15.8"
                                                    transform="matrix(0.7071 -0.7071 0.7071 0.7071 -20.0908 25.0116)"
                                                    fill="#FFFFFF"
                                                    width="15.2"
                                                    height="41.8"
                                                  />
                                                  <rect
                                                    x="39.8"
                                                    y="-4.2"
                                                    transform="matrix(0.7071 0.7071 -0.7071 0.7071 33.986 -25.1457)"
                                                    fill="#FFFFFF"
                                                    width="15.2"
                                                    height="65.3"
                                                  />
                                                </svg>
                                              ) : (
                                                <svg
                                                  className="tick-onoff"
                                                  version="1.1"
                                                  id="Layer_1"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                                  x="0px"
                                                  y="0px"
                                                  viewBox="0 0 75.8 56.9"
                                                  xmlSpace="preserve"
                                                >
                                                  <rect
                                                    x="12.6"
                                                    y="15.8"
                                                    transform="matrix(0.7071 -0.7071 0.7071 0.7071 -20.0908 25.0116)"
                                                    fill="#FFFFFF"
                                                    width="15.2"
                                                    height="41.8"
                                                  />
                                                  <rect
                                                    x="39.8"
                                                    y="-4.2"
                                                    transform="matrix(0.7071 0.7071 -0.7071 0.7071 33.986 -25.1457)"
                                                    fill="#FFFFFF"
                                                    width="15.2"
                                                    height="65.3"
                                                  />
                                                </svg>
                                              )}
                                            </button>
                                            <label
                                              id="chk-tick-label-2"
                                              style={{ display: "none" }}
                                            >
                                              Toggle to save whether or not you
                                              have completed the papers from
                                              this year.
                                            </label>
                                          </span>
                                        </span>
                                      </div>

                                      {/* <Adsense
										client="ca-pub-3775908651962462"
										data-adtest="on"
										slot="6258212978"
										style={{ display: 'block' }}
										layout="in-article"
										format="fluid"
										/> */}
                                    </>
                                  ))}
                                </>
                              ))}
                          </>
                        ))}
                    </div>
                  ))}

                  {/* Papers NOT Filtered (i.e. all papers here) */}
                  {/*
					{paperTypeDataFilter.map(item0 =>
						<div className="papertype-box" style={{paddingBottom: '1px'}}>
						<div className="qual-title-papers">{item0.name}</div>

						{props.paperData.papers.filter(item => item.papertype === item0.url).map(item =>
							<>
							<div className="paper-pill-2-around">
								<div key={item.id} className="paper-pill-2"> 
								</div>
							</div>

							<div className="papers-slide-parent">
									
										
									{item.papers.map((it, index) =>
										<div key={index} className="ppr"> 
											<div>
											<a href={"https://examoo.s3.eu-west-2.amazonaws.com/"+item.url+it} target="_blank">
													<div><span>{paperDict[it]}</span></div>
													<div></div>
													<div></div> 
											</a>
											</div>
										</div>
									)}
							</div>


							<div style={{background: '#00000080', width: '90%', margin: '0px auto 20px auto', color: 'white', height: '45px', position: 'relative', borderRadius: '0px 0px 20px 20px'}}>
								
								<span>
									<span style={{position: 'absolute', left: '15px'}}>
										<span>{item.year}</span> 
										<span className="month-style">{item.month.toUpperCase()}</span> 
									</span>

									<span style={{position: 'absolute', right: '15px'}}>
										<span>
											
											<img style={{height: '30px', opacity: '0.3', transform: 'translate(16px, -6.5px)'}} src={vertical} alt=""/> 
										</span>

										
										<span onClick={() => { props.usePersStatesPaperYear[item.url][1]( !props.usePersStatesPaperYear[item.url][0] ) }}>
											
											{props.usePersStatesPaperYear[item.url][0]
											?
											<svg className="tick-onoff" style={{background: '#63D771'}} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
											viewBox="0 0 75.8 56.9" xmlSpace="preserve">
												<rect x="12.6" y="15.8" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -20.0908 25.0116)" fill="#FFFFFF" width="15.2" height="41.8"/>
												<rect x="39.8" y="-4.2" transform="matrix(0.7071 0.7071 -0.7071 0.7071 33.986 -25.1457)" fill="#FFFFFF" width="15.2" height="65.3"/>
											</svg>

											:
											<svg className="tick-onoff" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
											viewBox="0 0 75.8 56.9" xmlSpace="preserve">
												<rect x="12.6" y="15.8" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -20.0908 25.0116)" fill="#FFFFFF" width="15.2" height="41.8"/>
												<rect x="39.8" y="-4.2" transform="matrix(0.7071 0.7071 -0.7071 0.7071 33.986 -25.1457)" fill="#FFFFFF" width="15.2" height="65.3"/>
											</svg>

											}

										</span>
									</span>
								</span>
							</div>
							</>
						)}	

					</div>

					)}
					*/}
                </>
              )}

              {/* <div><p>Back to top</p></div> */}

              <div style={{ paddingBottom: "5px", marginTop: "-2px" }}>
                <p
                  style={{
                    width: "250px",
                    margin: "0 auto 20px auto",
                    fontSize: "15px",
                    lineHeight: "17px",
                    opacity: 0.3,
                    cursor: "default",
                  }}
                >
                  That's all the{" "}
                  {examBoardName + " " + subjName + " " + qualName} past papers!
                </p>
              </div>
            </div>

            {paperTypeEnabled ? (
              <span
                style={{
                  opacity: "0.4",
                  margin: "-11px auto 0 auto",
                  paddingBottom: "10px",
                  display: "table",
                }}
              >
                <a
                  href="https://discord.gg/tc9TNjQvUp"
                  target="_blank"
                  style={{ margin: "0 3px" }}
                >
                  {" "}
                  <img
                    src={socialDiscord}
                    alt="Discord Logo"
                    style={{
                      width: "34px",
                      padding: "0px 3px",
                      transform: "translateY(-1.5px)",
                    }}
                  />
                </a>
                <a
                  href="https://www.instagram.com/examoo.co.uk/"
                  target="_blank"
                  style={{ margin: "0 4px" }}
                >
                  {" "}
                  <img
                    src={socialInsta}
                    alt="Instagram Logo"
                    style={{ width: "30px", padding: "0px 3px" }}
                  />
                </a>
                <a
                  href="https://www.tiktok.com/@examoo.co.uk"
                  target="_blank"
                  style={{ margin: "0 4px" }}
                >
                  {" "}
                  <img
                    src={socialTiktok}
                    alt="Tiktok Logo"
                    style={{ width: "30px", padding: "0px 3px" }}
                  />
                </a>
              </span>
            ) : (
              <></>
            )}
          </div>

          <div>
            {/* A Route is like urls.py in Django, but for SPA (single-page apps) 
				The 'thing' in <BoardPaper thing={thing} /> goes into 'props' of next file. 
				It's like 'context' in Django, but works for functions awa variables. */}
            {/*
			<Routes> 
				<Route path="/ruff/*" element={<QualSubject 
					pathNavBar={props.pathNavBar}
					setPathNavBar={props.setPathNavBar}/>
				}/>
			</Routes>
			*/}
          </div>
        </div>

        <div className="sidebar sidebar-right">
          {paperTypeEnabled ? (
            <div className="fade-in">
              <p style={{ transform: "translateX(-11px)" }}>
                have to pay rent sorry{" "}
                <span
                  style={{
                    fontSize: "20px",
                    position: "absolute",
                    transform: "translate(5px, -2px)",
                  }}
                >
                  😬
                </span>
              </p>
              <img src={meat} alt="Meat crisps" />

              <Adsense
                client="ca-pub-3775908651962462"
                data-adtest="on"
                slot="4362391969"
                style={{ display: "block" }}
                data-ad-format="auto"
                data-full-width-responsive="true"
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
}

export default Exams;

// ----- BUGS -----

// refreshing on anything but http://localhost:3000 gives error !!! (even if just a '/' afterwards)
// [ Uncaught TypeError: Cannot read properties of null (reading 'filter') ]

//
